/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/learn/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChessboard;
/* harmony export (immutable) */ __webpack_exports__["f"] = prepareChessboard;
/* unused harmony export updatePieces */
/* harmony export (immutable) */ __webpack_exports__["l"] = validateDrag;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateDrop;
/* harmony export (immutable) */ __webpack_exports__["o"] = validatePosition;
/* harmony export (immutable) */ __webpack_exports__["k"] = validateCoordinates;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadNextConfiguration;
/* harmony export (immutable) */ __webpack_exports__["i"] = showMagnus;
/* harmony export (immutable) */ __webpack_exports__["j"] = showReminder;
/* harmony export (immutable) */ __webpack_exports__["n"] = validateMove;
/* harmony export (immutable) */ __webpack_exports__["g"] = restrictMove;
/* harmony export (immutable) */ __webpack_exports__["h"] = showCapturedPieces;
/* harmony export (immutable) */ __webpack_exports__["c"] = hideCapturedPieces;
/* harmony export (immutable) */ __webpack_exports__["e"] = plotArrow;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSubstring;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_card__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(2);
var pieceWidth,pieceHeight;var captureCount=0;/**
* @name createChessboard 
* @function
* @param {config}
* @description: Create chessboard
*/function createChessboard(config){var afterLoad=function afterLoad(){prepareChessboard(config);};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}/**
* @name prepareChessboard 
* @function
* @param {config}
* @description: prepare initial Chessboard
*/function prepareChessboard(config){var piecesArray=config.piecesArray,showIndicators=config.showIndicators,singleSpare=config.singleSpare,position=config.position,sparePieces=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-7492f'),leftSparePieces=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-top-4028b'),rightSparePieces=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-bottom-ae20f'),styleClasses='assignment '+config.assignmentClass;sparePieces.css('padding','0');styleClasses=styleClasses+(showIndicators?showIndicators.allSides?' indicators all-sides ':' indicators ':'');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').addClass(styleClasses);if(singleSpare){var styleClass=position==='right'?'sparepieces_container_right':'sparepieces_container_left';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').append('<div class=\'sparepieces_container '+styleClass+'\'></div>');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sparepieces_container').append(sparePieces);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').append("<div class='sparepieces_container sparepieces_container_left'></div>");__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sparepieces_container_left').append(leftSparePieces);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').append("<div class='sparepieces_container sparepieces_container_right'></div>");__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sparepieces_container_right').append(rightSparePieces);}piecesArray&&piecesArray.map(function(piece){return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("display","block");});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sparepieces_container img').css('visibility','visible');}/**
* @name updatePieces
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/function updatePieces(piece,count,limit){var onDrop=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(count===limit-1){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("visibility","hidden");}else{if(onDrop){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("visibility","visible");}}}/**
* @name validateDrag
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/function validateDrag(piece,limit){var pieceCount=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".board-b72b1 img[data-piece = "+piece+"]").length;updatePieces(piece,pieceCount,limit);}/**
* @name validateDrop
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/function validateDrop(piece,limit,target,validatePieces,celebrationSound){setTimeout(function(){var pieceCount=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".board-b72b1 img[data-piece = "+piece+"]").length;updatePieces(piece,pieceCount-1,limit,true);},100);if(validatePieces[piece].filter(function(f){return f===target;}).length===0){if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("audio-play",__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* WRONG_ANSWER_AUDIO */]);}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("visibility","visible");return'trash';}else{if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("audio-play",__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* CORRECT_ANSWER_AUDIO */]);}}}/**
* @name validatePosition
* @function
* @param {}
* @description: Validate the assignment and navigate
*/function validatePosition(pieceLimit,resultFen,next){var bubbleConfig=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var isQA=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var celebrationSound=arguments[5];if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".piece-417db").length>=12+pieceLimit){setTimeout(function(){var fen=__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.fen();if(fen===resultFen){if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ACTIVITY_SUCCESS_AUDIO */]);}if(isQA){__WEBPACK_IMPORTED_MODULE_2__components_card__["a" /* default */].result=__WEBPACK_IMPORTED_MODULE_2__components_card__["a" /* default */].result+1;}if(bubbleConfig){showMagnus(bubbleConfig);loadNextConfiguration(4000,next,celebrationSound);}else{loadNextConfiguration(2000,next,celebrationSound);}}},100);}}/**
* @name validateCoordinates
* @function
* @param {}
* @description: Validate the Coordinates
*/function validateCoordinates(coordinate,next,coordinateCount){var bubbleConfig=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var isQA=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var completionAudio=arguments[5];completionAudio=completionAudio===false?completionAudio:true;if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').find('.'+coordinate).length===coordinateCount){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('clear-timer');if(isQA){__WEBPACK_IMPORTED_MODULE_2__components_card__["a" /* default */].result=__WEBPACK_IMPORTED_MODULE_2__components_card__["a" /* default */].result+1;}if(bubbleConfig){showMagnus(bubbleConfig);loadNextConfiguration(4000,next,completionAudio);}else{loadNextConfiguration(2000,next,completionAudio);}}}/**
* @name loadNextConfiguration
* @function
* @param {timeout}
* @description: Load next configuration
*/function loadNextConfiguration(timeout,next,completionAudio){if(completionAudio){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config',next);},timeout);}/**
* @name showMagnus
* @function
* @param {config}
* @description: Show Magnus
*/function showMagnus(config){var bubbleConfig=typeof config==='string'?{text:config}:config;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-show',bubbleConfig);}/**
* @name showReminder
* @function
* @param {remainingCount}
* @description: Show reminder
*/function showReminder(remainingCount){// $(document).trigger('clear-timer');
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');showMagnus({data:'Keep going... <br/> '+remainingCount+' more to go',position:'left',styleClass:'xs',timeout:5000});}/**
* @name validateMove
* @function
* @param {source, target}
* @description: Validate chess piece Move
*/function validateMove(source,target,piece){var showCaptured=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var move=__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(move.captured&&showCaptured){showCapturedPieces(piece,move);}}}/**
* @name restrictMove
* @function
* @param {piece}
* @description: Allow only move black or white piece
*/function restrictMove(piece,p){if(piece.search(p)!==-1){return false;}}/**
* @name showCapturedPieces
* @function
* @param {piece, move}
* @description: Show Captured Pieces
*/function showCapturedPieces(piece,move){var showLeft=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var captured=move.captured,capturedPieceColor=__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CAPTURED_PIECE_COLOR_MAPPER */][move.color],capturedPiece=capturedPieceColor+captured.toUpperCase(),spareContainerClass='';if(move.color===__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* BLACK_PIECE */]||showLeft){spareContainerClass='.spare-pieces-bottom-ae20f';}else{spareContainerClass='.spare-pieces-top-4028b';}var el=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(spareContainerClass+' img')[captureCount];if(el){pieceWidth=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).width();pieceHeight=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).height();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr({'src':'img/chesspieces/simple_black_white/'+capturedPiece+'.svg','data-piece':capturedPiece});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).css({'visibility':'visible','display':'block'});}else{var p='<img src="img/chesspieces/simple_black_white/'+capturedPiece+'.svg" class="piece-417db" data-piece='+capturedPiece+' style="width: '+pieceWidth+'px; height: '+pieceHeight+'px; visibility: visible; display: block;">';__WEBPACK_IMPORTED_MODULE_0_jquery___default()(spareContainerClass).append(p);}captureCount++;}/**
* @name hideCapturedPieces
* @function
* @param {}
* @description: Hide Captured Pieces
*/function hideCapturedPieces(){captureCount=0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-7492f img').css('visibility','hidden');}/**
* @name plotArrow
* @function
* @param {ctx, source, target, sourceOffset, targetOffset, arrowHeadWidth, arrowTailWidth}
* @description: Plots an arrow on canvas
*/function plotArrow(ctx,fromClass,toClass,offsetFromx,offsetFromy,offsetTox,offsetToy,arrowHead,arrowTail,arrowColor){var fromA=document.getElementsByClassName("square-a1"),fromAx=fromA[0].offsetParent.offsetLeft+fromA[0].offsetLeft,toB=document.getElementsByClassName("square-b1"),toBx=toB[0].offsetParent.offsetLeft+toB[0].offsetLeft;var squareEdge=toBx-fromAx;var offset=squareEdge/2;offsetFromx=offsetFromx?offsetFromx/10*squareEdge:offset;offsetFromy=offsetFromy?offsetFromy/10*squareEdge:offset;offsetTox=offsetTox?offsetTox/10*squareEdge:offset;offsetToy=offsetToy?offsetToy/10*squareEdge:offset;arrowHead=arrowHead||arrowHead===0?arrowHead:squareEdge/9;arrowTail=arrowTail?arrowTail:squareEdge/8;arrowColor=arrowColor?arrowColor:"#F2A455";var from=document.getElementsByClassName(fromClass),fromx=from[0].offsetParent.offsetLeft+from[0].offsetLeft+offsetFromx,fromy=from[0].offsetParent.offsetTop+from[0].offsetTop+offsetFromy,to=document.getElementsByClassName(toClass),tox=to[0].offsetParent.offsetLeft+to[0].offsetLeft+offsetTox,toy=to[0].offsetParent.offsetTop+to[0].offsetTop+offsetToy,headlen=arrowHead,angle=Math.atan2(toy-fromy,tox-fromx);ctx.beginPath();ctx.moveTo(fromx,fromy);ctx.lineTo(tox,toy);ctx.strokeStyle=arrowColor;ctx.lineWidth=arrowTail;ctx.stroke();//starting a new path from the head of the arrow to one of the sides of the point
ctx.beginPath();ctx.moveTo(tox,toy);ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),toy-headlen*Math.sin(angle-Math.PI/7));//path from the side point of the arrow, to the other side point
ctx.lineTo(tox-headlen*Math.cos(angle+Math.PI/7),toy-headlen*Math.sin(angle+Math.PI/7));//path from the side point back to the tip of the arrow, and then again to the opposite side point
ctx.lineTo(tox,toy);ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),toy-headlen*Math.sin(angle-Math.PI/7));//draws the paths created above
ctx.strokeStyle=arrowColor;ctx.lineWidth=arrowHead;ctx.stroke();ctx.fillStyle=arrowColor;ctx.fill();}/**
* @name getSubstring
* @function
* @param {from, to}
* @description: To get the substring from the 'from' and 'to' coordinates
*/function getSubstring(from,to){var fromFinal=from.substr(7,9),toFinal=to.substr(7,9);return fromFinal+'-'+toFinal;}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BLACK_INITIAL_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WHITE_INITIAL_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BLACK_PIECE_SEARCH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WHITE_PIECE_SEARCH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BLACK_KING_SEARCH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CAPTURED_PIECE_COLOR_MAPPER; });
/* unused harmony export WHITE_PIECE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BLACK_PIECE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVITY_SUCCESS_AUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORRECT_ANSWER_AUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WRONG_ANSWER_AUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITY_COMPLETION_AUDIO; });
/* unused harmony export GLOBAL_ASSETS */
var BLACK_INITIAL_MOVE=' b - - 0 1';var WHITE_INITIAL_MOVE=' w - - 0 1';var BLACK_PIECE_SEARCH_KEY=/^b/;var WHITE_PIECE_SEARCH_KEY=/^w/;var BLACK_KING_SEARCH_KEY=/^bK/;var CAPTURED_PIECE_COLOR_MAPPER={b:'w',w:'b'};var WHITE_PIECE='w';var BLACK_PIECE='b';var ACTIVITY_SUCCESS_AUDIO={src:'img/audio/lesson_end.mp3',start:true,controls:false};var CORRECT_ANSWER_AUDIO={src:'img/audio/correct_answer.mp3',start:true,controls:false};var WRONG_ANSWER_AUDIO={src:'img/audio/wrong_answer.mp3',start:true,controls:false};var ACTIVITY_COMPLETION_AUDIO={src:'img/audio/activity_complete.mp3',start:true,controls:false};var GLOBAL_ASSETS=['/img/volume.svg','/img/mute.svg','/img/thinking_bubble.svg','/img/dragon.png','/img/bubble_down.svg','/img/chessboard_indication.svg','/img/chessboard_indication_full.svg','/img/dropdown.png','/img/chesspieces/simple_black_white/bK.svg','/img/chesspieces/simple_black_white/bQ.svg','/img/chesspieces/simple_black_white/bR.svg','/img/chesspieces/simple_black_white/bB.svg','/img/chesspieces/simple_black_white/bN.svg','/img/chesspieces/simple_black_white/bP.svg','/img/chesspieces/simple_black_white/wK.svg','/img/chesspieces/simple_black_white/wQ.svg','/img/chesspieces/simple_black_white/wR.svg','/img/chesspieces/simple_black_white/wB.svg','/img/chesspieces/simple_black_white/wN.svg','/img/chesspieces/simple_black_white/wP.svg'];// /img/chesspieces/wikipedia/bK.png
// /img/chesspieces/wikipedia/bQ.png
// /img/chesspieces/wikipedia/bR.png
// /img/chesspieces/wikipedia/bB.png
// /img/chesspieces/wikipedia/bN.png
// /img/chesspieces/wikipedia/bP.png
// /img/chesspieces/wikipedia/wK.png
// /img/chesspieces/wikipedia/wQ.png
// /img/chesspieces/wikipedia/wR.png
// /img/chesspieces/wikipedia/wB.png
// /img/chesspieces/wikipedia/wN.png
// /img/chesspieces/wikipedia/wP.png
// /img/background_1.png
// /img/background_2.png
// /img/background_3.png

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}//import Chess from '../chess/chessLib'
var ChessBoard=function(){function ChessBoard(){_classCallCheck(this,ChessBoard);var that=this;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('chessBoard-show',function(e,data){that.displayChessBoard(data);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('chessBoard-hide',function(e,data){that.hideChessBoard();}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('chessBoard-destroy',function(e,data){that.destroyChessBoard();}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('canvas-show',function(e,data){that.showCanvas();}).bind(that);}/**
  * @name displayChessBoard
  * @function
  * @param {config}
  * @description: Display the chess board
  */_createClass(ChessBoard,[{key:'displayChessBoard',value:function displayChessBoard(config){var chessboard=config.board,positionFen=config.positionFen,pieceTheme=chessboard.config.pieceTheme;chessboard.config.pieceTheme=pieceTheme?pieceTheme:"img/chesspieces/simple_black_white/{piece}.svg";ChessBoard.config=chessboard;if(config.hint){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container'));__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').addClass('hint-chessboard');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.center-box').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container'));__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo, .qa-section-container').removeClass('show').addClass('hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').removeClass('hint-chessboard');}if(config.heading){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.castling-head').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').prepend('<div class="castling-head"> <b>'+config.heading+'</b> </div>');}var screenWidth=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').width(),screenHeight=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').height();if(config.canvas){if(!document.getElementById("myCanvas")){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').append('<canvas id="myCanvas" width='+screenWidth+' height='+screenHeight+' ></canvas>');}}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').remove();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').removeClass('hide').addClass('show-flex');ChessBoard.game=positionFen?new window.Chess(positionFen):new window.Chess();ChessBoard.board=window.ChessBoard('chessBoard',chessboard.config);ChessBoard.board.resize();//to show arrows in hint chessboard
if(config.canvas&&config.hint){var c=document.getElementById("myCanvas"),ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.canvas.from,config.canvas.to,null,null,null,null,4,2);}if(chessboard.afterLoad){chessboard.afterLoad();}}/**
  * @name showCanvas
  * @function
  * @param {}
  * @description: show canvas
  */},{key:'showCanvas',value:function showCanvas(){var screenWidth=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').width(),screenHeight=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').height();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').append('<canvas id="myCanvas" width='+screenWidth+' height='+screenHeight+' ></canvas>');}/**
  * @name hideChessBoard
  * @function
  * @param {}
  * @description: Hide the chess board
  */},{key:'hideChessBoard',value:function hideChessBoard(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').html('');}/**
  * @name destroyChessBoard
  * @function
  * @param {}
  * @description: Destroy the chess board
  */},{key:'destroyChessBoard',value:function destroyChessBoard(){if(ChessBoard.board){ChessBoard.board.destroy();}}}]);return ChessBoard;}();/* harmony default export */ __webpack_exports__["a"] = (ChessBoard);ChessBoard.board=null;ChessBoard.config=null;ChessBoard.game=null;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var User=function(){function User(){_classCallCheck(this,User);}_createClass(User,null,[{key:'getUser',/**
  * @name id
  * @function
  * @param {}
  * @description: getter for user
  */value:function getUser(){return User.user;}/**
  * @name setUser
  * @function
  * @param {value}
  * @description: setter for user
  */},{key:'setUser',value:function setUser(value){User.user=value;}}]);return User;}();User.user={id:'',name:'',currentLesson:''};/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = highlightCoordinates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
/**
* @name highlightCoordinates
* @function
* @param {config}
* @description: chess board related task
*/function highlightCoordinates(config){var afterLoad=function afterLoad(){var squares=config.coordinates?config.coordinates:[],coordinateClass=config.coordinateClass,next=config.next,isQA=config.isQA,bubbleConfig=config.bubbleConfig?config.bubbleConfig:null,celebrationSound=config.celebrationSound===false?false:true,correctAnswerCount=0,remainingAnswerCount=void 0,reminder=config.reminder,activityCompletionSound=true;var correctClick=false;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);if(bubbleConfig){bubbleConfig.data=bubbleConfig.data.replace('userName',__WEBPACK_IMPORTED_MODULE_2__classes_user__["a" /* default */].user.name);}var board=document.getElementsByClassName("chessboard-63f37");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(board[0]).click(function(e){e.preventDefault();if(!correctClick){if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);}}correctClick=false;});squares.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).click(function(e){e.preventDefault();if(!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass(coordinateClass)){correctAnswerCount++;remainingAnswerCount=squares.length-correctAnswerCount;correctClick=true;if(reminder){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* showReminder */])(remainingAnswerCount);}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass(coordinateClass);if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);}if(isQA){activityCompletionSound=false;}Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* validateCoordinates */])(coordinateClass,next,squares.length,bubbleConfig,isQA,activityCompletionSound);}});});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_user__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var nextConfigTimeout;var Card=function(){function Card(){_classCallCheck(this,Card);var that=this;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('qa-bubble-show',function(e,data){var qa=data.qa;//initializing result with 0
if(qa.id===0){Card.result=0;}__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].currentTime='227.5';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo').removeClass('show').addClass('hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').removeClass('show-flex').addClass('hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qa-section-container').removeClass('hide').addClass('show');if(qa.result){that.displayResultModule(qa);}else{that.displayCard(qa);}}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('qa-bubble-hide',function(e,data){clearTimeout(nextConfigTimeout);that.hideCard();}).bind(that);}/**
  * @name displayCard
  * @function
  * @param {qa}
  * @description: Display the card
  */_createClass(Card,[{key:'displayCard',value:function displayCard(qa){var question=qa.question,answers=qa.answer,validateAnswer=qa.validateAnswer,isAssessment=qa.isAssessment,styleClass=qa.styleClass,rightAnswerTimeout=qa.rightAnswerTimeout;var body='\n      <div class="qa-section">\n        <div class="qa-section-wrapper">\n          <div class="header flex-center">\n            <div class="question-container"><div class="question">'+question+'</div></div>   \n          </div>\n          <div class="body">\n            <div class="answer-container full-height flex-horizontal-center">\n              <span class="btn answer" data-answer=\'0\'>'+(answers[0]?answers[0]:'N/A')+'</span>\n              <span class="btn answer" data-answer=\'1\'>'+(answers[1]?answers[1]:'N/A')+'</span>\n              <span class="btn answer" data-answer=\'2\'>'+(answers[2]?answers[2]:'N/A')+'</span>\n              <span class="btn answer" data-answer=\'3\'>'+(answers[3]?answers[3]:'N/A')+'</span> \n            </div>       \n          </div>\n        </div>\n    </div>';if(qa.chessboard){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('chessBoard-show',qa.chessboard);}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qa-section-content').html(body);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').click(function(){var userAnswer=parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-answer'),10),timeout=rightAnswerTimeout?rightAnswerTimeout:4000;if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer-container').find('.selected').length<1){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').removeClass('selected');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('selected');if(userAnswer===validateAnswer.rightAnswer||isAssessment){Card.result=Card.result+1;if(qa.highlightSquares){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config');},4000);}else{setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config');},1000);}}else{if(!qa.isAssessment){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-show',{data:'Oops...!!!<br/>The correct answer is "'+qa.rightAnswer+'"',position:'left',styleClass:styleClass});}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config');},timeout);}}});}/**
  * @name hideCard
  * @function
  * @param {}
  * @description: Hide the card
  */},{key:'hideCard',value:function hideCard(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qa-section').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hint-image-container').remove();}/**
  * @name displayResultModule
  * @function
  * @param {data}
  * @description: Display the score card
  */},{key:'displayResultModule',value:function displayResultModule(data){var userName=__WEBPACK_IMPORTED_MODULE_1__classes_user__["a" /* default */].user.name,correctAnswers=Card.result,isAssessment=data.isPreAssessment,positiveMsg='Great work, '+userName+'! <br/>You got '+correctAnswers+'/10. <br/>Looks like you are <br/>ready for <br/>'+data.nextLesson+'!',negativeMsg=userName+', you got '+correctAnswers+'/10. <br/>You might want to <br/>practice a bit more <br/>before moving on to <br/>'+data.nextLesson+'!',positiveMsgLesson20='Great work, '+userName+'! <br/>You got '+correctAnswers+'/10. <br/>Congratulations!!Well done.',negativeMsgLesson20=userName+', you got '+correctAnswers+'/10. <br/>You might want to <br/>practice a bit more!',resultLesson20=correctAnswers>6?positiveMsgLesson20:negativeMsgLesson20,message='You are done. Thanks for letting me know what you know!.',result=isAssessment?message:correctAnswers>6?positiveMsg:negativeMsg,qaTimeout=data.timeout;// Todo: Need to call Rest Api for progress 
console.log('correctAnswers',correctAnswers);var postData={id:__WEBPACK_IMPORTED_MODULE_1__classes_user__["a" /* default */].getUser().id,username:userName,"lesson_id":__WEBPACK_IMPORTED_MODULE_1__classes_user__["a" /* default */].getUser().currentLesson,"Score":correctAnswers};fetch("https://db.firstmovechess.org/student/lesson",{body:JSON.stringify(postData),method:"POST"}).then(function(response){return response.json();}).then(function(responseData){if(window.ga){window.ga('send',{hitType:'event',eventCategory:'Lesson Stats',eventAction:'Lesson click',eventLabel:__WEBPACK_IMPORTED_MODULE_1__classes_user__["a" /* default */].getUser().currentLesson});}console.log(responseData);});if(data.nextLesson!=='None'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-show',{data:result,position:data.position,styleClass:data.styleClass});}else if(data.nextLesson==='None'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-show',{data:resultLesson20,position:data.position,styleClass:data.styleClass});}if(qaTimeout){nextConfigTimeout=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config');},qaTimeout);}}}]);return Card;}();/* harmony default export */ __webpack_exports__["a"] = (Card);Card.result=0;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(11);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(9);
module.exports = __webpack_require__(16);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(10).enable();
  window.Promise = __webpack_require__(13);
}

// fetch() polyfill for making API calls.
__webpack_require__(14);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(15);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(7);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(7);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_screen__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lessons__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_app_scss__);
var allOptions,currentLesson;var body="\n<div class='stretch flex-center flex-column chess-app'>\n  <header class='page-header flex flex-space-between full-width'>\n    <div class='header-section full-width flex-center'>\n      <span class='title-bold'>FIRST MOVE FOR KIDS</span>\n    </div>\n    <div class='header-section full-width flex-vertical-center'>\n      <ul class=\"select-box flex flex-column sub-title-bold padding-left\">\n        <li class=\"init lesson-list\">Pre-Assessment</li>\n        <ul class=\"scroll-dropdown\">\n        "+__WEBPACK_IMPORTED_MODULE_2__lessons__["b" /* lessonsTitle */].map(function(item,index){return"<li class=\"lesson-list\" data-value="+index+">"+item+"</li>";}).join('')+"\n        </ul>\n      </ul>\n    </div>\n    <div class='header-section full-width flex-vertical-center'>\n      <span class='sub-title-bold padding-left'>VIEW ALL LESSONS</span>\n    </div>\n    <div class='header-section full-width flex-vertical-center'>\n      <div class='user-profile  flex-vertical-center padding-left'>\n        <img src='/img/user.png'><span class='user-name sub-title-bold padding-left'>Hi User</span>\n      </div>\n    </div>\n  </header>\n  <div class='page-body stretch flex'>\n    <div class='overlay hide'></div>\n    <div class='left-box flex flex-full flex-center full-height'>\n      <div class='back-btn-container flex-center full-height'>\n        <button id='previous' class='btn flex-center hide'><img src='/img/back.svg'></button>\n      </div>\n      <div class='left-box-content full-height full-width flex-center'></div>\n    </div>\n    <div class='center-box flex-center full-height'>\n      <video controls controlsList=\"nofullscreen nodownload noremoteplayback\" id='chessVideo' class=\"intro-video hide\" autoplay>\n        <source src=\"img/lesson_1.mp4\" type=\"video/mp4\">\n        Your browser does not support the video tag.\n      </video>\n      <audio id=\"chessAudio\" autoplay>\n        <source src=\"\" type=\"audio/mpeg\" autoplay>\n        Your browser does not support the audio element.\n      </audio>\n      <div class='chessboard-container flex-center flex-column'>\n        <div id=\"chessBoard\" class='chessboard'></div>\n      </div>\n      <div class='qa-section-container'>\n        <div class='qa-section-content flex-center flex-full full-width full-height'></div>\n      </div>\n      <div class='activity-section-container'>\n        <div class='activity-section-content flex-center flex-full full-width full-height'></div>\n      </div>\n    </div>\n    <div class='right-box flex flex-full flex-center'>\n      <div class='right-box-content flex-center full-height'></div>\n      <div class='next-btn-container flex-center full-height'>\n        <div class=\"volume-control flex-center\"></div>\n        <button id='next' class='btn flex-center hide'><img src='/img/next.svg'></button>\n      </div>\n    </div>\n  </div>\n<div>";// lesson dropdown
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("click",".init",function(e){e.preventDefault();e.stopPropagation();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-dropdown').toggle();// $(".select-box li:nth-child(" + (currentLesson + 1) + ")").addClass(
//   "selected"
// );
});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("click",".lesson-list:not(.init)",function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-dropdown').toggle();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config',[0,true]);var selectedValue=parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-value"),10);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-dropdown > li').removeClass('selected');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('selected');if(currentLesson!==selectedValue){currentLesson=selectedValue;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("next-config",[0,true]);}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".select-box").children(".init").html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).html());allOptions.toggle();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind("click",function(e){var $clicked=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);if(!$clicked.parents().hasClass("select-box"))allOptions.hide();});function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\[\]]/g,"\\$&");var regex=new RegExp("[?&]"+name+"(=([^&#]*)|&|#|$)"),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g," "));}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){var username=getParameterByName('username')||'Anonymous';var student_id=getParameterByName('student_id')||0;var playVideo=getParameterByName('PlayVideo');if(playVideo){var lessonNum=playVideo.split("_").pop();currentLesson=isNaN(lessonNum)?1:Number(lessonNum);if(currentLesson>=21){currentLesson=20;}}var user={id:student_id,name:username,currentLesson:currentLesson};__WEBPACK_IMPORTED_MODULE_3__classes_user__["a" /* default */].user=user;loadRoot(currentLesson);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("click","#next",function(e){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("next-config");});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("click","#previous",function(e){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("previous-config");});window.addEventListener("resize",function(event){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".bubble").css("height",__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".bubble").width());updateScreen();});/**
 * @name removeComponents
 * @function
 * @param {}
 * @description: Remove components form the screen
 */function removeComponents(currentChapter){var removeBubble=currentChapter&&currentChapter.text&&currentChapter.text.continue?false:true;if(removeBubble){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("bubble-hide");}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("video-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("chessBoard-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("chessBoard-destroy");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("qa-bubble-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("activity-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("direction-box-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("options-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("canvas-hide");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("clear-timer");__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessBoard").attr("class","chessboard");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".castling-head").remove();}/**
 * @name updateScreen
 * @function
 * @param {}
 * @description: update the component size
 */function updateScreen(){var windowWidht=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".page-body").width(),windowHeight=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".page-body").height(),contentHeight=windowHeight,contentWidth=windowHeight*1.78,placeholderWidth=42*windowWidht/100;if(contentWidth>windowWidht){contentWidth=contentWidth>windowWidht?windowWidht:contentWidth;contentHeight=contentWidth/1.78;}__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo").css("height",contentHeight);__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo, #myCanvas").css("width",contentWidth);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qa-section-container").css("width",placeholderWidth);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qa-section-container").css("height",placeholderWidth);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chessboard-container, .activity-section-container").css("width",placeholderWidth+50);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chessboard-container, .activity-section-container").css("height",placeholderWidth);}/**
 * @name updateNavigationButtons
 * @function
 * @param {previous, next} previous and next state
 * @description: Enable/Disable the navigation buttons
 */function updateNavigationButtons(previous,next){if(previous===null){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#previous").removeClass("show").addClass("hide");}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#previous").removeClass("hide").addClass("show");}if(next===null){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#next").removeClass("show").addClass("hide");}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#next").removeClass("hide").addClass("show");}}/**
 * @name loadRoot
 * @function
 * @param {Object} initialState : current lesson state
 * @description: Load screen with current lesson details
 */function loadRoot(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").html(body).ready(function(){var screen=new __WEBPACK_IMPORTED_MODULE_1__classes_screen__["a" /* default */](),currentLessonId=initialState,currentChapterId=0,currentChapter=__WEBPACK_IMPORTED_MODULE_2__lessons__["a" /* lessons */][currentLessonId].config[currentChapterId],previous=currentChapter?currentChapter.previous:null,next=currentChapter?currentChapter.next:null,nextConfig=void 0,previousConfig=void 0;__WEBPACK_IMPORTED_MODULE_1__classes_screen__["a" /* default */].loadPreloadedLessonsArray();__WEBPACK_IMPORTED_MODULE_1__classes_screen__["a" /* default */].updatePreloadedLessonsArray(currentLessonId,true,__WEBPACK_IMPORTED_MODULE_2__lessons__["a" /* lessons */][currentLessonId].assets);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chess-app").attr("class","stretch flex-center flex-column chess-app lesson-"+currentLessonId);__WEBPACK_IMPORTED_MODULE_3__classes_user__["a" /* default */].user.currentLesson=currentLessonId;updateNavigationButtons(previous,next);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".header-section .user-name").html("Hi "+__WEBPACK_IMPORTED_MODULE_3__classes_user__["a" /* default */].user.name);screen.renderLesson(currentChapter);allOptions=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".select-box").children("li:not(.init)");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".lesson-list")[parseInt(initialState,10)+1].click();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".init")[0].click();updateScreen();currentLesson=currentLessonId;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind("next-config",function(e,configId){var lessonChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;nextConfig=configId===undefined?currentChapter.next:configId;if(nextConfig===undefined||nextConfig===null){removeComponents();return false;}if(lessonChange){__WEBPACK_IMPORTED_MODULE_1__classes_screen__["a" /* default */].updatePreloadedLessonsArray(currentLesson,true,__WEBPACK_IMPORTED_MODULE_2__lessons__["a" /* lessons */][currentLesson].assets);}currentChapter=__WEBPACK_IMPORTED_MODULE_2__lessons__["a" /* lessons */][currentLesson].config[nextConfig];removeComponents(currentChapter);previous=currentChapter.previous;next=currentChapter.next;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chess-app").attr("class","stretch flex-center flex-column chess-app lesson-"+currentLesson);updateNavigationButtons(previous,next);screen.renderLesson(currentChapter);}).bind(screen);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind("previous-config",function(e,configId){removeComponents();previousConfig=configId===undefined?currentChapter.previous:configId;if(previousConfig===undefined||previousConfig===null){return false;}currentChapter=__WEBPACK_IMPORTED_MODULE_2__lessons__["a" /* lessons */][currentLesson].config[currentChapter.previous];previous=currentChapter.previous;next=currentChapter.next;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".chess-app").attr("class","stretch flex-center flex-column chess-app lesson-"+currentLesson);updateNavigationButtons(previous,next);screen.renderLesson(currentChapter);}).bind(screen);});}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bubble__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_audio__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_card__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activity__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_directionBox__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_options__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_table__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Screen=function(){function Screen(){_classCallCheck(this,Screen);this.bubble=new __WEBPACK_IMPORTED_MODULE_1__components_bubble__["a" /* default */]();this.card=new __WEBPACK_IMPORTED_MODULE_4__components_card__["a" /* default */]();this.video=new __WEBPACK_IMPORTED_MODULE_2__components_video__["a" /* default */]();this.audio=new __WEBPACK_IMPORTED_MODULE_3__components_audio__["a" /* default */]();this.chessBoard=new __WEBPACK_IMPORTED_MODULE_5__components_chessBoard__["a" /* default */]();this.activity=new __WEBPACK_IMPORTED_MODULE_6__components_activity__["a" /* default */]();this.directionBox=new __WEBPACK_IMPORTED_MODULE_7__components_directionBox__["a" /* default */]();this.options=new __WEBPACK_IMPORTED_MODULE_8__components_options__["a" /* default */]();this.table=new __WEBPACK_IMPORTED_MODULE_9__components_table__["a" /* default */]();}_createClass(Screen,[{key:'renderLesson',/**
  * @name renderLesson
  * @function
  * @param {lessonConfig}
  * @description: render the chapter based on the current lesson
  */value:function renderLesson(lessonConfig){if(lessonConfig){if(lessonConfig.text){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-show',lessonConfig.text);}if(lessonConfig.video){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('video-show',lessonConfig);}if(lessonConfig.audio){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',lessonConfig.audio);}if(lessonConfig.qa){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('qa-bubble-show',lessonConfig);}if(lessonConfig.chessboard){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('chessBoard-show',lessonConfig.chessboard);}if(lessonConfig.activity){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('activity-show',lessonConfig.activity);}if(lessonConfig.directions){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('direction-box-show',lessonConfig.directions);}if(lessonConfig.options){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('options-show',lessonConfig.options);}if(lessonConfig.table){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('table-show');}}}}],[{key:'loadPreloadedLessonsArray',value:function loadPreloadedLessonsArray(){for(var i=0;i<20;i++){Screen.preLoadedLessons[i]=false;}}},{key:'updatePreloadedLessonsArray',value:function updatePreloadedLessonsArray(index,value){var imageArray=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];if(Screen.preLoadedLessons[index]!==value){Screen.preLoadedLessons[index]=value;var imageUrls='';for(var i=0;i<imageArray.length;i++){imageUrls=imageUrls+'url('+imageArray[i]+')';}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<style>body:before{content: '+imageUrls+'}</style>').appendTo('head');}}}]);return Screen;}();Screen.preLoadedLessons=[];/* harmony default export */ __webpack_exports__["a"] = (Screen);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var magnusTimeout,bubbleStyleClass;var Bubble=function(){function Bubble(){_classCallCheck(this,Bubble);var that=this;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('bubble-show',function(e,config){that.displayBubble(config);}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('bubble-hide',function(e,data){that.hideBubble();}).bind(that);/**
    * @name clearTimer
    * @function
    * @param {data}
    * @description: Clear the timer for magnus
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('clear-timer',function(e,config){clearTimeout(magnusTimeout);}).bind(that);}/**
  * @name displayBubble
  * @function
  * @param {data}
  * @description: Display the bubble
  */_createClass(Bubble,[{key:'displayBubble',value:function displayBubble(text){var position=text.position?text.position==='center'?'left':text.position:'left',styleClass=text.styleClass?text.styleClass:'md',bubbleTimeout=1000,timeout=text.timeout?text.timeout:0;magnusTimeout=setTimeout(function(){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech').length===0){var body=' \n      <div class=\'speech-bubble '+text.position+' flex-center flex-column\'>\n        <div class="speech flex flex-full full-width flex-horizontal-center flex-vertical-bottom">\n          <div class="bubble flex flex-center flex-column '+styleClass+' '+position+'"></div>\n        </div>\n        <div class="bubble-down-container full-width"><div class="bubble-down full-width"></div></div>\n        <div class=\'dragon-container flex-full full-width\'>\n          <div class=\'dragon '+text.position+'\'></div>\n        </div>\n      </div>';bubbleStyleClass=styleClass;if(text.position==='right'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').html(body);}else if(text.position==='center'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qa-section-content').html(body);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.left-box-content').html(body);}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').html('<div class=\'bubble-content\'>'+text.data+'</div>');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.dragon').css({'height':'100%','width':'100%'});},500);}else{if(!text.continue){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble-down, .bubble').css('opacity','0');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').css('height','80px');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble-down').css('height','0');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').removeClass(bubbleStyleClass).addClass(styleClass);bubbleTimeout=500;}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').html('<div class=\'bubble-content\'>'+text.data+'</div>');},500);}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').css('height',__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble').width());__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble-down, .bubble').css('opacity','1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble-down').css('height','100%');},bubbleTimeout);},timeout);}/**
  * @name hideBubble
  * @function
  * @param {}
  * @description: Hide the bubble
  */},{key:'hideBubble',value:function hideBubble(){clearTimeout(magnusTimeout);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bubble-down').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.dragon').remove();}}]);return Bubble;}();/* harmony default export */ __webpack_exports__["a"] = (Bubble);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Video=function(){function Video(){_classCallCheck(this,Video);var that=this;var _fn;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('video-show',function(e,data){var video=data.video,endTime=video.endTime,autoStartNext=video.autoStartNext,next=video.next;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo').removeClass('hide').addClass('show');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.qa-section-container').removeClass('show').addClass('hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').removeClass('show-flex').addClass('hide');if(!data.audio){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-pause');}that.displayVideo(video);if(endTime){_fn=function fn(){if(this.currentTime>=endTime&&this.currentTime<endTime+0.6){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].removeEventListener("timeupdate",_fn);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('video-hide');if(autoStartNext){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config',next);}}};__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].addEventListener("timeupdate",_fn);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo').on('ended',function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('video-hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo").unbind('ended');if(autoStartNext){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config',next);}});}}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('video-hide',function(e,data){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0]){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].removeEventListener("timeupdate",_fn);__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo").unbind('ended');that.hideVideo();}}).bind(that);}/**
  * @name displayVideo
  * @function
  * @param {video}
  * @description: Play the video
  */_createClass(Video,[{key:'displayVideo',value:function displayVideo(video){var _loadFnc;if(!__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0]){return;}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".overlay").removeClass('hide').addClass('show');_loadFnc=function loadFnc(){this.currentTime=video.startTime?video.startTime:0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].removeEventListener("loadedmetadata",_loadFnc);};__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo source').attr('src',video.src);__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].load();__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].addEventListener('loadedmetadata',_loadFnc,false);}/**
  * @name hideVideo
  * @function
  * @param {}
  * @description: Pause the video
  */},{key:'hideVideo',value:function hideVideo(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessVideo")[0].pause();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".overlay").removeClass('show').addClass('hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessVideo').removeClass('show').addClass('hide');}}]);return Video;}();/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Audio=function Audio(){_classCallCheck(this,Audio);var that=this;/**
    * @name audio-play
    * @function
    * @param {data}
    * @description: Event listener for play the audio
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('audio-play',function(e,audio){if(audio.autoPlay||audio.start){var audioElm=document.getElementById('chessAudio'),volControl=audio.controls===false?false:true;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio').attr('src',audio.src);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio').attr('loop',audio.loop);if(volControl){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.volume-control').html('<span class="volume-icon volume"></span>');}audioElm.muted=false;}else if(audio.stop){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-pause');}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio').on('ended',function(){if(!audio.loop){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-pause');}__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessAudio").unbind('ended');});}).bind(that);/**
    * @name audio-pause
    * @function
    * @param {data}
    * @description: Event listener for pause the audio
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('audio-pause',function(e,data){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio').removeAttr('loop');if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio')[0]){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessAudio')[0].pause();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.volume-icon').remove();}).bind(that);/**
    * @name
    * @function
    * @param {}
    * @description: Event listener for volume icon
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click','.volume-icon',function(e){var audioElm=document.getElementById('chessAudio');audioElm.muted=!audioElm.muted;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass("volume mute");});};/* harmony default export */ __webpack_exports__["a"] = (Audio);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var assignmentClass;var Activity=function Activity(){_classCallCheck(this,Activity);var that=this;/**
    * @name activity-show
    * @function
    * @param {config}
    * @description: Event listener for show activity
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('activity-show',function(e,config){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-container').removeClass('hide').addClass('show');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-container').removeClass(assignmentClass).addClass(config.assignmentClass);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-content').removeClass(assignmentClass).addClass(config.assignmentClass);assignmentClass=config.assignmentClass;config.callback();}).bind(that);/**
    * @name activity-hide
    * @function
    * @param {config}
    * @description: Event listener for hide activity
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('activity-hide',function(e,config){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-container').removeClass('show').addClass('hide');}).bind(that);};/* harmony default export */ __webpack_exports__["a"] = (Activity);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var directionsTimeout;var DirectionBox=function DirectionBox(){_classCallCheck(this,DirectionBox);var that=this;/**
    * @name direction-box-show
    * @function
    * @param {config}
    * @description: Event listener for show direction box
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('direction-box-show',function(e,config){var timeout=config.timeout,directionData=config.data,className=config.className;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append('<div class=\'directions '+className+'\'></div>');directionsTimeout=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').html(directionData);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').css('opacity','1');},timeout);}).bind(that);/**
    * @name direction-box-hide
    * @function
    * @param {config}
    * @description: Event listener for hide direction box
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('direction-box-hide',function(e,config){clearTimeout(directionsTimeout);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').remove();}).bind(that);};/* harmony default export */ __webpack_exports__["a"] = (DirectionBox);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Options=function(){function Options(){_classCallCheck(this,Options);var that=this;/**
    * @name options-show
    * @function
    * @param {config}
    * @description: Event listener for show options
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('options-show',function(e,config){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append('<div class=\'options\'></div>');that.displayOptions(config);}).bind(that);/**
    * @name options-hide
    * @function
    * @param {config}
    * @description: Event listener for hide options
    */__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('options-hide',function(e,config){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.options').remove();}).bind(that);}/**
  * @name displayOptions
  * @function
  * @param {config}
  * @description: Display the options
  */_createClass(Options,[{key:'displayOptions',value:function displayOptions(config){var answers=config.answer,validateAnswer=config.validateAnswer,next=config.next?config.next:null,magnusCorrectAnswer=config.magnusCorrectAnswer,magnusWrongAnswer=config.magnusWrongAnswer,count=config.count;var body='\n        <div class="options-section">\n            <div class="options-section-wrapper">\n                <div class="body">\n                    <div class="answer-container full-height flex-horizontal-center">\n                        <span class="btn answer" data-answer=\'0\'>'+(answers[0]?answers[0]:'N/A')+'</span>\n                        <span class="btn answer" data-answer=\'1\'>'+(answers[1]?answers[1]:'N/A')+'</span>\n                        '+(answers[2]?'<span class="btn answer" data-answer="2">'+answers[2]+'</span>':'')+'\n                        '+(answers[3]?'<span class="btn answer" data-answer="3">'+answers[3]+'</span>':'')+'     \n                </div>\n            </div>\n        </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.options').html(body);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.options').css('opacity','1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').click(function(){var userAnswer=parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-answer'),10);//if ($('.answer-container').find('.selected').length < 1) {
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').removeClass('selected');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('selected');if(config.id===0)__WEBPACK_IMPORTED_MODULE_1__card__["a" /* default */].result=0;if(userAnswer===validateAnswer.rightAnswer){var text=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('get-value',[text,true]);if(config.isQA){__WEBPACK_IMPORTED_MODULE_1__card__["a" /* default */].result=__WEBPACK_IMPORTED_MODULE_1__card__["a" /* default */].result+1;}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);if(config.magnusCorrectAnswer){Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* showMagnus */])(magnusCorrectAnswer);next&&Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* loadNextConfiguration */])(magnusCorrectAnswer.waitTime||4000,next);}else{next&&Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* loadNextConfiguration */])(2000,next);}}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);if(config.magnusWrongAnswer){if(!config.validateCounter){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('selected');Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* showMagnus */])(magnusWrongAnswer);next&&Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* loadNextConfiguration */])(magnusWrongAnswer.waitTime,next);}else{if(count===0){Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* showMagnus */])(magnusWrongAnswer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('get-value',[config.rightAnswer,false]);next&&Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* loadNextConfiguration */])(magnusWrongAnswer.waitTime,next);}else{count--;}}}else{next&&Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* loadNextConfiguration */])(1000,next);}}if(config.highlightSquare){var square=document.getElementsByClassName(config.highlightSquare);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(square[0]).addClass("filled-square");}if(config.canvas){var offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null,screenWidth=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').width(),screenHeight=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-body').height();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-container').append('<canvas id="myCanvas" width='+screenWidth+' height='+screenHeight+' ></canvas>');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);if(config.canvas.offset){offsetFromx=config.canvas.offset[0];offsetFromy=config.canvas.offset[1];offsetTox=config.canvas.offset[2];offsetToy=config.canvas.offset[3];}Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* plotArrow */])(ctx,config.canvas.from,config.canvas.to,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,config.canvas.color);}//}
});}}]);return Options;}();/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Table=function(){function Table(){_classCallCheck(this,Table);var that=this;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('table-show',function(e,values){that.displayTable(values);}).bind(that);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('table-hide',function(e,data){that.hideTable();}).bind(that);}/**
    * @name displayTable
    * @function
    * @param {values}
    * @description: Display the table
    */_createClass(Table,[{key:'displayTable',value:function displayTable(values){var value1=values[0]?values[0]:'',value2=values[1]?values[1]:'',value3=values[2]?values[2]:'',value4=values[3]?values[3]:'',value5=values[4]?values[4]:'',value6=values[5]?values[5]:'',value7=values[6]?values[6]:'',value8=values[7]?values[7]:'';var body='\n        <table id="fill-table">\n            <colgroup>\n                <col />\n                <col />\n                <col style="background-color:#D3D3D3;"/>\n            </colgroup>\n            <thead><tr><th colspan="3"><b>Notation Table</th></tr></thead>\n            <tbody>\n                <tr><th>Steps</th><th>White</th><th>Black</th></tr>\n                <tr><td>1</td><td class="table-value">'+value1+'</td><td class="table-value">'+value2+'</td></tr>\n                <tr><td>2</td><td class="table-value">'+value3+'</td><td class="table-value">'+value4+'</td></tr>\n                <tr><td>3</td><td class="table-value">'+value5+'</td><td class="table-value">'+value6+'</td></tr>\n                <tr><td>4</td><td class="table-value">'+value7+'</td><td class="table-value">'+value8+'</td></tr>\n            </tbody>\n        </table>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.left-box-content').html(body);}/**
     * @name hideTable
     * @function
     * @param
     * @description: Hide the table
     */},{key:'hideTable',value:function hideTable(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fill-table').remove();}}]);return Table;}();/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lessons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lessonsTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pre_assessment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson_1__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_2__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_3__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lesson_4__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson_5__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lesson_6__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lesson_7__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lesson_8__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lesson_9__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lesson_10__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lesson_11__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lesson_12__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lesson_13__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lesson_14__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lesson_15__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lesson_16__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lesson_17__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lesson_18__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lesson_19__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lesson_20__ = __webpack_require__(65);
//Lessons array
var lessons={0:__WEBPACK_IMPORTED_MODULE_0__pre_assessment__["a" /* default */],1:__WEBPACK_IMPORTED_MODULE_1__lesson_1__["a" /* default */],2:__WEBPACK_IMPORTED_MODULE_2__lesson_2__["a" /* default */],3:__WEBPACK_IMPORTED_MODULE_3__lesson_3__["a" /* default */],4:__WEBPACK_IMPORTED_MODULE_4__lesson_4__["a" /* default */],5:__WEBPACK_IMPORTED_MODULE_5__lesson_5__["a" /* default */],6:__WEBPACK_IMPORTED_MODULE_6__lesson_6__["a" /* default */],7:__WEBPACK_IMPORTED_MODULE_7__lesson_7__["a" /* default */],8:__WEBPACK_IMPORTED_MODULE_8__lesson_8__["a" /* default */],9:__WEBPACK_IMPORTED_MODULE_9__lesson_9__["a" /* default */],10:__WEBPACK_IMPORTED_MODULE_10__lesson_10__["a" /* default */],11:__WEBPACK_IMPORTED_MODULE_11__lesson_11__["a" /* default */],12:__WEBPACK_IMPORTED_MODULE_12__lesson_12__["a" /* default */],13:__WEBPACK_IMPORTED_MODULE_13__lesson_13__["a" /* default */],14:__WEBPACK_IMPORTED_MODULE_14__lesson_14__["a" /* default */],15:__WEBPACK_IMPORTED_MODULE_15__lesson_15__["a" /* default */],16:__WEBPACK_IMPORTED_MODULE_16__lesson_16__["a" /* default */],17:__WEBPACK_IMPORTED_MODULE_17__lesson_17__["a" /* default */],18:__WEBPACK_IMPORTED_MODULE_18__lesson_18__["a" /* default */],19:__WEBPACK_IMPORTED_MODULE_19__lesson_19__["a" /* default */],20:__WEBPACK_IMPORTED_MODULE_20__lesson_20__["a" /* default */]//Lessons title;
};var lessonsTitle=['Pre-Assessment','Lesson 1 (Intro and Board Basics)','Lesson 2 (The Board and Pieces)','Lesson 3 (The Pawn)','Lesson 4 (The Knight)','Lesson 5 (The Bishop)','Lesson 6 (The Rook)','Lesson 7 (The Queen)','Lesson 8 (The King)','Lesson 9 (Checkmate and Stalemate)','Lesson 10 (Castling)','Lesson 11 (Notation)','Lesson 12 (Ladder Mate)','Lesson 13 (Knight\'s Tour)','Lesson 14 (En Passant)','Lesson 15 (Crowded Queendom)','Lesson 16 (Patterns)','Lesson 17 (Tactics)','Lesson 18 (The Square)','Lesson 19 (Planning)','Lesson 20 (Make a Mate)'];

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignments__ = __webpack_require__(27);
var lessonConfig=[{id:0,previous:null,next:null,video:{src:'img/videos/pre-assessment/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,qa:{id:1,isAssessment:true,question:'How do you find a coordinate?',answer:['Draw a line to connect the stars','Go up a file and across a rank to meet','You need to use paper and scissors','I don’t know'],rightAnswer:'Go up a file and across a rank to meet',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__assignments__["a" /* preAssessmentBoard1 */])({showIndicators:true,squares:['.square-c2','.square-e6','.square-g2']}),hint:true}}},{id:2,previous:1,next:3,qa:{id:2,isAssessment:true,question:'What does analyze mean?',answer:['It doesn\'t matter','Take turns','Weigh your options','I don\'t know'],rightAnswer:'Weigh your options',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:3,previous:2,next:4,qa:{id:3,isAssessment:true,question:'Solve the equation: <b>__R + __P = Q',answer:['1R + 4p = Q','2R + 1p = Q','2R + 5p = Q','I don\'t know'],rightAnswer:'8',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:4,previous:3,next:5,qa:{id:4,isAssessment:true,question:'The Knight jumps to f2. How many moves will it take for the Knight to capture all eight pawns?',answer:['8','12','16','I don\'t know'],rightAnswer:'8',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/3PPP2/3PnP2/3PPP2/8/8',assignmentClass:'custom-sparepiece'}),canvas:{from:'square-e4',to:'square-f2'},hint:true}}},{id:5,previous:4,next:6,qa:{id:5,isAssessment:true,question:'Analyze the board to determine which team (black or white) has the advantage and why?',answer:['White is one move from checkmate','Black is one move from checkmate','Black and White are tied','I don\'t know'],rightAnswer:'Black is one move from checkmate',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createChessboard */])({showIndicators:true,position:'5r2/pkp3r1/1p6/8/8/2N2P2/PPP2P2/5RK1'}),hint:true}}},{id:6,previous:5,next:7,qa:{id:6,isAssessment:true,question:'Add one piece to this board so White will have checkmate.',answer:['White Rook on e7','White Knight on b6','White Bishop on e4','I don\'t know'],rightAnswer:'White Knight on b6',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createChessboard */])({showIndicators:true,position:'kb6/r7/2K5/8/8/8/8/8'}),hint:true}}},{id:7,previous:6,next:8,qa:{id:7,isAssessment:true,question:'Which team is stronger?',answer:['Team A: King, two Rooks, and 4 pawns','Team B: King, Knight, two Bishops and a pawn','Team C: King, Knight, Bishop and 4 pawns','I don\'t know'],rightAnswer:'Team A: King, two Rooks, and 4 pawns',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:8,previous:7,next:9,qa:{id:8,isAssessment:true,question:'How many black squares are missing from this board?',answer:['2','5','10','I don\'t know'],rightAnswer:'5',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__assignments__["b" /* preAssessmentBoard2 */])({showIndicators:true,squares:['.square-d6','.square-f6','.square-e5','.square-d4','.square-f4']}),hint:true}}},{id:9,previous:8,next:10,qa:{id:9,isAssessment:true,question:'Why are diagonal lines special?',answer:['They alternate dark and light squares','They have the most squares','They are only one color','I don\'t know'],rightAnswer:'They are only one color',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:10,previous:9,next:11,qa:{id:10,isAssessment:true,question:'What is the best move?',answer:['Check','Checkmate','Stalemate','I don\'t know'],rightAnswer:'Checkmate',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:0,next:null,audio:{src:null,stop:true},text:{data:'You are done!<br>Don\'t worry if you didn\'t<br>know all the answers, that\'s<br>what you will be learning.',position:'center',styleClass:'xxl'},qa:{position:'center',nextLesson:'Lesson One',result:true,isPreAssessment:true,styleClass:'xxl'}}];var assets=['img/background_0.png'];var config={assets:assets,config:lessonConfig};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = preAssessmentBoard1;
/* harmony export (immutable) */ __webpack_exports__["b"] = preAssessmentBoard2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/**
* @name preAssessmentBoard1
* @function
* @param {config}
* @description: Highlight Knights Move
*/function preAssessmentBoard1(config){var squares=config.squares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);squares.forEach(function(square){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(square).prepend('<img class="blue-star" src="img/blue-star.png" />');});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}/**
 * @name preAssessmentBoard2
 * @function
 * @param {config}
 * @description: Hide coordinates
 */function preAssessmentBoard2(config){var squares=config.squares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);squares.forEach(function(square){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(square).css('background-color','#F9F4ED').css('border','1px solid #6DA3D9');});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:3,video:{src:'img/videos/lesson_1/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:3,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the 10 <br/>squares that should <br/>be dark.',timeout:5000},audio:{src:'img/audio/lesson_1/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* selectCoordinates */])({squares:['.square-b6','.square-d6','.square-f6','.square-b4','.square-c3','.square-c5','.square-f2','.square-h8','.square-e3','.square-f4'],indicators:false,assignmentClass:'assignment-1-1',coordinateClass:'white-coordinate',next:2})}},{id:2,previous:0,next:5,video:{src:'img/videos/lesson_1/2.mp4',startTime:0,autoStartNext:true,next:4}},{id:3,previous:0,next:5,video:{src:'img/videos/lesson_1/2.1.mp4',startTime:0,autoStartNext:true,next:4}},{id:4,previous:3,next:5,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the 8 <br/>squares that make <br/>the other long <br/>diagonal.',timeout:6000},audio:{src:'img/audio/lesson_1/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* highlightCoordinates */])({showIndicators:{allSides:true},coordinates:['.square-a1','.square-b2','.square-c3','.square-d4','.square-e5','.square-f6','.square-g7','.square-h8'],prefilledCoordinates:['.square-h1','.square-g2','.square-f3','.square-e4','.square-d5','.square-c6','.square-b7','.square-a8'],coordinateClass:'filled-square',reminder:true,next:5})}},{id:5,previous:3,next:8,video:{src:'img/videos/lesson_1/3.mp4',startTime:0,autoStartNext:true,next:6}},{id:6,previous:5,next:8,text:{data:'Drag the <br/>coordinates to the <br/>correct square.',position:'left',styleClass:'md'},audio:{src:'img/audio/lesson_1/3.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* dragDropPieces */])({showIndicators:{allSides:true},singleSpare:true,piecesArray:['bK','bQ','bR','bB','wK','wQ','wR','wB'],validatePieces:{'bK':['b2'],'bQ':['g5'],'bR':['e7'],'bB':['d6'],'wK':['c4'],'wQ':['c2'],'wR':['d3'],'wB':['b7']},pieceLimit:{bK:1,bQ:1,bR:1,bB:1,wK:1,wQ:1,wR:1,wB:1},fen:'8/1B2r3/3b4/6q1/2K5/3R4/1kQ5/8',pieceTheme:'coordinate_transparent',celebrationSound:true,next:7})}},{id:7,previous:5,next:9,video:{src:'img/videos/lesson_1/4.mp4',startTime:0,autoStartNext:true,next:9}},{id:8,previous:5,next:9,video:{src:'img/videos/lesson_1/4.1.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:10,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'When was chess created?',answer:['In the beginning of time','About 1500 years ago','About 500 years ago','Just 15 years ago'],rightAnswer:'About 1500 years ago',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:10,previous:8,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'Where was chess created?',answer:['The United States of America','Western Europe','India','China'],rightAnswer:'India',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:11,previous:8,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'How many squares are on the chessboard?',answer:['8','32','48','64'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'64',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:12,previous:8,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'Which direction are vertical lines?',answer:['Across the board','Up and down the board','Diagonally on the board','All directions'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Up and down the board',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:13,previous:8,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'Which direction are horizontal lines?',answer:['Across the board','Up and down the board','Diagonally on the board','All directions'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Across the board',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:14,previous:8,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What are vertical lines called in chess?',answer:['Files','Ranks','Diagonals','Jojos'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Files',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:15,previous:8,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'What are horizontal lines called in chess?',answer:['Files','Ranks','Diagonals','Jojos'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Ranks',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:8,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Which is the correct way to write a coordinate?',answer:['Over e','Up 5','5E','e5'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'e5',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:17,previous:8,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Which of the coordinates is a corner square?',answer:['a1','b4','d6','h2'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'a1',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:18,previous:8,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},text:{data:'The board is missing <br/>three dark squares. Drag <br/>the correct coordinates <br/>to the three squares that <br/>should be dark.',position:'left',styleClass:'xxxl'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* dragDropPieces */])({id:9,isQA:true,singleSpare:true,position:'right',assignmentClass:'assignment-1-1',showIndicators:{allSides:true},piecesArray:['bK','bQ','bR'],validatePieces:{'bK':['b2'],'bQ':['g5'],'bR':['e7']},pieceLimit:{bK:1,bQ:1,bR:1},coordinates:['.square-b2','.square-g5','.square-e7'],fen:'8/4r3/8/6q1/8/8/1k6/8',pieceTheme:'coordinate_blue'})}},{id:19,previous:8,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Two',styleClass:'xl'}}];var assets=['/img/background_1.png','/img/background_2.png','/img/chesspieces/coordinate_transparent/bK.svg','/img/chesspieces/coordinate_transparent/bQ.svg','/img/chesspieces/coordinate_transparent/bR.svg','/img/chesspieces/coordinate_transparent/bB.svg','/img/chesspieces/coordinate_transparent/wK.svg','/img/chesspieces/coordinate_transparent/wQ.svg','/img/chesspieces/coordinate_transparent/wR.svg','/img/chesspieces/coordinate_transparent/wB.svg','/img/chesspieces/coordinate_blue/bK.svg','/img/chesspieces/coordinate_blue/bQ.svg','/img/chesspieces/coordinate_blue/bR.svg'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = selectCoordinates;
/* harmony export (immutable) */ __webpack_exports__["b"] = highlightCoordinates;
/* harmony export (immutable) */ __webpack_exports__["a"] = dragDropPieces;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
/**
* @name selectCoordinates
* @function
* @param {config}
* @description: Select the coordinates from the chess board
*/function selectCoordinates(config){var afterLoad=function afterLoad(){var squares=config.squares,coordinateClass='white-coordinate',next=config.next;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);var correctClick=false;var board=document.getElementsByClassName("chessboard-63f37");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(board[0]).click(function(e){e.preventDefault();if(!correctClick){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);}correctClick=false;});squares.map(function(k){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).addClass(coordinateClass);return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).click(function(e){e.preventDefault();correctClick=true;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass(coordinateClass);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* showReminder */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.'+coordinateClass).length);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("audio-play",__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* validateCoordinates */])(coordinateClass,next,0);});});};var chessConfig={config:{},afterLoad:afterLoad};return chessConfig;}/**
* @name highlightCoordinates
* @function
* @param {lessonConfig}
* @description: Highlight the coordinates
*/function highlightCoordinates(config){var afterLoad=function afterLoad(){var next=config.next,coordinates=config.coordinates?config.coordinates:[],prefilledCoordinates=config.prefilledCoordinates?config.prefilledCoordinates:[],coordinateCount=coordinates.length+prefilledCoordinates.length,coordinateClass=config.coordinateClass,count=0;var correctClick=false;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);var taskInterval=setInterval(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(prefilledCoordinates[count]).addClass(coordinateClass);if(count===7){clearInterval(taskInterval);}else{count++;}},100);var board=document.getElementsByClassName("chessboard-63f37");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(board[0]).click(function(e){e.preventDefault();if(!correctClick){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);}correctClick=false;});coordinates.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).click(function(e){e.preventDefault();correctClick=true;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass(coordinateClass);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* showReminder */])(16-__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.'+coordinateClass).length);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* validateCoordinates */])(coordinateClass,next,coordinateCount);});});};var chessConfig={config:{},afterLoad:afterLoad};return chessConfig;}/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/function dragDropPieces(config){var next=config.next,fen=config.fen,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[],pieceLimit=config.pieceLimit,celebrationSound=config.celebrationSound?config.celebrationSound:false;var afterLoad=function afterLoad(){var coordinates=config.coordinates;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);coordinates&&coordinates.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).addClass("white-coordinate");});};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* validatePosition */])(piecesArray.length,fen,next,null,config.isQA,celebrationSound);return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,celebrationSound);};var chessConfig={config:{draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_2/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_2/1.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Drag the pieces <br/>to their correct <br/>starting square. <br/>If you get it right, <br/>the piece will <br/>stay there, <br/>if you get it wrong, <br/>the piece will float <br/>back to the side.',timeout:10500},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* dragDropPieces */])({showIndicators:{allSides:true},piecesArray:['bK','bQ','bR','bB','bN','bP','wK','wQ','wR','wB','wN','wP'],validatePieces:{'bK':['e8'],'bQ':['d8'],'bR':['a8','h8'],'bB':['c8','f8'],'bN':['b8','g8'],'bP':['a7','b7','c7','d7','e7','f7','g7','h7'],'wK':['e1'],'wQ':['d1'],'wR':['a1','h1'],'wB':['c1','f1'],'wN':['b1','g1'],'wP':['a2','b2','c2','d2','e2','f2','g2','h2']},pieceLimit:{bK:1,bQ:1,bB:2,bN:2,bR:2,bP:8,wK:1,wQ:1,wB:2,wN:2,wR:2,wP:8},fen:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',pieceTheme:'simple_black_white',next:2})}},{id:2,previous:0,next:5,video:{src:'img/videos/lesson_2/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:5,directions:{data:'<b>DIRECTIONS:</b> <br/>Drag the icons <br/>and titles to the <br/>correct quadrant <br/>on the board.',timeout:0},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* dragDropPiecesBlackWhiteSide */])({showIndicators:{allSides:true},singleSpare:true,piecesArray:['bK','bQ','wK','wQ'],validatePieces:{'bK':['e8','f8','g8','h8','e7','f7','g7','h7','e6','f6','g6','h6','e5','f5','g5','h5'],'bQ':['a8','b8','c8','d8','a7','b7','c7','d7','a6','b6','c6','d6','a5','b5','c5','d5'],'wK':['e4','f4','g4','h4','e3','f3','g3','h3','e2','f2','g2','h2','e1','f1','g1','h1'],'wQ':['a4','b4','c4','d4','a3','b3','c3','d3','a2','b2','c2','d2','a1','b1','c1','d1']},pieceLimit:{bK:1,bQ:1,wK:1,wQ:1},fen:'3qk3/8/8/8/8/8/8/3QK3',pieceTheme:'assignment_2_2',assignmentClass:'assignment-2-2',next:4})}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_2/3.mp4',startTime:0,autoStartNext:true,next:6}},{id:5,previous:2,next:6,video:{src:'img/videos/lesson_2/3.1.mp4',startTime:0,autoStartNext:true,next:6}},{id:6,previous:5,next:7,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Which chess pieces are friendly consultants to the King and Queen and start on the <br/> f and c file?',answer:['Pawns','Knights','Bishops','Rooks'],rightAnswer:'Bishops',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:7,previous:5,next:8,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'Which chess pieces buck and gallop and start the game on the b and g files?',answer:['Pawns','Knights','Bishops','Rooks'],rightAnswer:'Knights',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:8,previous:5,next:9,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Which chess pieces stand high above approaching armies on the a and h files?',answer:['Pawns','Knights','Bishops','Rooks'],rightAnswer:'Rooks',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:9,previous:5,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'Which chess pieces stand in front of the other pieces filling the 2nd and 7th rank?',answer:['Pawns','Knights','Bishops','Rooks'],rightAnswer:'Pawns',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:10,previous:5,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'To set-up the board, it helps to remember the Queen loves...',answer:['Rubies','Emeralds','Diamonds','Coal'],rightAnswer:'Diamonds',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:11,previous:5,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'To set-up the board, it helps to remember the King oversees...',answer:['The castle','The farmland','The people','Everything'],rightAnswer:'Everything',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:12,previous:5,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Which is the white side of the board?',answer:['Ranks 1-4','Ranks 5-8','Files a-d','Files e-h'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Ranks 1-4',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:13,previous:5,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Which is the Queen side of the board?',answer:['Ranks 1-4','Ranks 5-8','Files a-d','Files e-h'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Files a-d',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:14,previous:5,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Which is the King side of the board?',answer:['Ranks 1-4','Ranks 5-8','Files a-d','Files e-h'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Files e-h',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:15,previous:5,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Which is the black side of the board?',answer:['Ranks 1-4','Ranks 5-8','Files a-d','Files e-h'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true},rightAnswer:'Ranks 5-8',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:5,next:null,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'Lesson Three',result:true,styleClass:'xl'}}];var assets=['/img/background_1.png','/img/background_2.png','/img/background_3.png','/img/chesspieces/assignment_2_2/bK.svg','/img/chesspieces/assignment_2_2/bQ.svg','/img/chesspieces/assignment_2_2/wK.svg','/img/chesspieces/assignment_2_2/wQ.svg'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dragDropPieces;
/* harmony export (immutable) */ __webpack_exports__["b"] = dragDropPiecesBlackWhiteSide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/function dragDropPieces(config){var next=config.next,fen=config.fen,pieceLimit=config.pieceLimit,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[];var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var bubbleConfig={data:'Good Job '+__WEBPACK_IMPORTED_MODULE_2__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'xs'};Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* validatePosition */])(piecesArray.length,fen,next,bubbleConfig,false,true);return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true);};var chessConfig={config:{draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}/**
* @name dragDropPiecesBlackWhiteSide 
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/function dragDropPiecesBlackWhiteSide(config){var next=config.next,pieceLimit=config.pieceLimit,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[];var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#chessBoard").append('<div class="cp bK"></div><div class="cp bQ"></div><div class="cp wK"></div><div class="cp wQ"></div>');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img, .piece-417db").css({'width':'80px','height':'120px'});};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){if(validatePieces[piece].filter(function(f){return f===target;}).length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("visibility","visible");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);return'trash';}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()("div."+piece).css("visibility","visible");__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".piece-417db").length>=12+piecesArray.length){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('next-config',next);},2000);}}};var chessConfig={config:{draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_3/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,// text: {
//   data: 'Here is a hint, there are six possible moves.',
//   position: 'left',
//   styleClass: 'md'
// },
directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>square the White <br/>b and c pawns <br/>could move, <br/>and every square <br/>the black <br/>e and f pawns <br/>could move.',timeout:11000},audio:{src:'img/audio/lesson_3/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{b2:'wP',c3:'wP',e6:'bP',f7:'bP'},coordinates:['.square-b3','.square-b4','.square-c4','.square-e5','.square-f5','.square-f6'],coordinateClass:'filled-square',bubbleConfig:{data:'Nice job userName!',position:'left',styleClass:'xs'},reminder:true,next:2})}},{id:2,previous:0,next:7,video:{src:'img/videos/lesson_3/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:7,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.',timeout:8000},audio:{src:'img/audio/lesson_3/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{a7:'bP',b7:'wN',c3:'bN',d2:'wP',d3:'bB',g5:'wP',g6:'bP'},coordinates:['.square-c3'],coordinateClass:'filled-square',reminder:true,next:4})}},{id:4,previous:3,next:7,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.',timeout:0},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{b5:'wP',c5:'wP',c6:'bP',d2:'bB',d3:'bB',d5:'wN',d6:'wB',e2:'wP',h4:'wN',h5:'bP'},coordinates:['.square-b5','.square-c6','.square-d3','.square-d5'],coordinateClass:'filled-square',reminder:true,next:5})}},{id:5,previous:4,next:7,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.',timeout:0},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{c4:'wP',c5:'bN',d4:'wP',d5:'bP',e5:'wP',e6:'bP',f6:'bP',g6:'wN'},coordinates:['.square-c4','.square-c5','.square-d5','.square-e5','.square-f6'],coordinateClass:'filled-square',next:6,reminder:true})}},{id:6,previous:5,next:7,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.',timeout:0},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{b3:'wP',b4:'wP',b5:'bP',b6:'wB',c3:'bN',e4:'wN',f4:'wP',f5:'bP',f6:'bP',g5:'wP',h4:'bB'},coordinates:['.square-e4','.square-f6','.square-g5'],coordinateClass:'filled-square',next:7,reminder:true})}},{id:7,previous:6,next:8,video:{src:'img/videos/lesson_3/3.mp4',startTime:0,autoStartNext:true,next:8}},{id:8,previous:7,next:9,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'How many pawns are on each team?',answer:['1','2','4','8'],rightAnswer:'8',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:9,previous:7,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'How many points is the pawn worth?',answer:['1','2','4','8'],rightAnswer:'1',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:10,previous:7,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'What is special about the pawn?',answer:['It can move across the board in one turn','It can be promoted to a Queen','It can jump other pieces','It can become a King'],rightAnswer:'It can be promoted to a Queen',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:7,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What is the pawn's symbol?",answer:['#','3','0','p (or no symbol)'],rightAnswer:'p (or no symbol)',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:12,previous:7,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'In general, how does the pawn move?',answer:['Side-to-side','One square anywhere','One square straight forward','One square forward, one square to the side'],rightAnswer:'One square straight forward',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:13,previous:7,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What can every pawn do on its first move only?',answer:['Become a Queen','Move forward two squares','Move backward one square','Capture another piece'],rightAnswer:'Move forward two squares',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:14,previous:7,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Who does the pawn represent from the Middle Ages?',answer:['A foot soldier','A land owner','A noble warrior','A King'],rightAnswer:'A foot soldier',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:15,previous:7,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Can a pawn move backwards?',answer:['Yes, but only if he is under attack','Yes, if he makes it across the board','Sometimes','No, never'],rightAnswer:'No, never',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:16,previous:7,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'How does a pawn capture?',answer:['By jumping over the piece','One square straight ahead','One square on the diagonal','One square behind him'],rightAnswer:'One square on the diagonal',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:17,previous:7,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Where do pawns start the game?',answer:['Filling the 1st and 8th ranks','Filling the 2nd and 7th ranks','Filling the a and h files','Filling the d and e files'],rightAnswer:'Filling the 2nd and 7th ranks',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:18,previous:7,next:null,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'Lesson Four',result:true,styleClass:'xl'}}];var assets=['/img/background_2.png','/img/background_3.png','/img/background_4.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_4/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_4/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{d4:'wN'},coordinates:['.square-b3','.square-b5','.square-c2','.square-c6','.square-e2','.square-e6','.square-f3','.square-f5'],coordinateClass:'filled-square',reminder:true,next:2})},directions:{timeout:13000,data:'<b>DIRECTIONS:</b> <br/>Click on the eight <br/>squares the Knight <br/>could move to from <br/>his d4 square.'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_4/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_4/2.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the 3 pieces <br/>the White Knight <br/>could capture from <br/>the d4 square.',timeout:9500},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},position:{b4:'bP',c3:'bP',c5:'bP',c6:'bP',d3:'bN',d4:'wN',e2:'bB',f5:'bP',f6:'bN',g5:'bP'},coordinates:['.square-c6','.square-e2','.square-f5'],coordinateClass:'filled-square',bubbleConfig:{data:'Nice job userName!',position:'left',styleClass:'xs'},reminder:true,next:4})}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_4/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/lesson_4/3.mp3',start:true,controls:false},text:{data:'The pawns are frozen, only the Knight moves.',position:'left',timeout:10000,styleClass:'md'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson4Assignment3 */])({showIndicators:{allSides:true},position:'8/8/3PPP2/3PnP2/3PPP2/8/8/8',coordinateClass:'.piece-417db[data-piece=wP]',assignmentClass:'custom-sparepiece',next:6}),positionFen:'8/8/3PPP2/3PnP2/3PPP2/8/8/8 b - - 0 1'},directions:{timeout:9000,data:'<b>DIRECTIONS:</b> <br/>You have nine <br/>moves, one move <br/>to jump out, <br/>and eight moves <br/>to capture <br/>all eight pawns.'}},{id:6,previous:4,next:7,video:{src:'img/videos/lesson_4/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:6,next:8,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"What is the Knight's special talent?",answer:['He can capture two pieces in one turn','He can change his color','He can get promoted to a Queen','He can jump over other pieces'],rightAnswer:'He can jump over other pieces',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:8,previous:6,next:9,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"What is the Knight's symbol?",answer:['K','N','T','B'],rightAnswer:'N',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:9,previous:6,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Which piece does the Knight capture?',answer:['The one he lands on','The one he jumps over','The one to his left','The one to his right'],rightAnswer:'The one he lands on',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:10,previous:6,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What phrase helps you remember how the Knight moves and captures?",answer:['One, two three, eyes on me','Hippity-hippity-hop',"Dark or light, it's alright",'One and done'],rightAnswer:'Hippity-hippity-hop',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:6,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'How many points is the Knight worth?',answer:['1','2','3','4'],rightAnswer:'3',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:12,previous:6,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'Where do the Knights stand at the start of the game?',answer:['A and H files','B and G files','C and F files','D and E files'],rightAnswer:'B and G files',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:13,previous:6,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'How were Knights in the Middle Ages equipped for battle?',answer:['They had a shield','They had protective armor','They rode horseback','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:14,previous:6,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What is the shape of a Knight move?',answer:['S','U','N','L'],rightAnswer:'L',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:15,previous:6,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'How often does a Knight change his square color?',answer:['Whenever he wants','Every time he moves','Only when he captures','He never changes square color'],rightAnswer:'Every time he moves',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:6,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Can a Knight move backwards?',answer:['No, he only moves straight ahead','No, he only moves sideways and forward','No, he only moves in a T shape across the board','Yes, he can move any direction he wants in an L shape'],rightAnswer:'Yes, he can move any direction he wants in an L shape',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:17,previous:6,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Five',styleClass:'xl'}}];var assets=['/img/background_3.png','/img/background_4.png','/img/background_5.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson4Assignment3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
var moveCount;/**
* @name lesson4Assignment3
* @function
* @param {config}
* @description: chess board related task
*/function lesson4Assignment3(config){var coordinateClass=config.coordinateClass,next=config.next,initialBoardPosition=config.position;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);moveCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_3__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,true);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();moveCount++;if(moveCount===9){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .chessboard-63f37').find(coordinateClass).length===0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}else{moveCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:"The pawns are frozen, only the Knight moves.",position:'left',styleClass:'lg'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';},4000);}}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);};var chessConfig={config:{position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_5/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,text:{data:'You have only 2 moves.',position:'left',styleClass:'sm',timeout:8000},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the correct <br/>Bishop and drag <br/>him to show the <br/>two moves to get <br/>the Bishop to a8.',timeout:7000},audio:{src:'img/audio/lesson_5/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson5Assignment1 */])({showIndicators:{allSides:true},position:'8/8/8/8/8/8/8/2B2B2',resultFen:'B7/8/8/8/8/8/8/2B5',assignmentClass:'custom-sparepiece show-center',next:2}),positionFen:'8/8/8/8/8/8/8/2B2B2 w - - 0 1'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_5/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,text:{data:'Capture the Knight last!',position:'left',styleClass:'sm',timeout:16000},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the Bishop, <br/>then drag him to the <br/>pawn you want him <br/>to capture. <br/>Remember, it has to <br/>be in  a straight <br/>diagonal line with <br/>the Bishop.',timeout:15000},audio:{src:'img/audio/lesson_5/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson5Assignment2 */])({showIndicators:{allSides:true},position:'8/1p3p2/p5p1/8/2p1p3/1p6/8/3n1B2',resultFen:'8/8/8/8/8/8/8/3B4',assignmentClass:'custom-sparepiece',next:4}),positionFen:'8/1p3p2/p5p1/8/2p1p3/1p6/8/3n1B2 w - - 0 1'}},{id:4,previous:2,next:5,video:{src:'img/videos/lesson_5/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"How does the Bishop move?",answer:['Across the ranks','Up and down files','On the diagonals','Any direction he wants'],rightAnswer:'On the diagonals',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:6,previous:4,next:7,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"On which files do Bishops start of a game?",answer:['A and H','B and G','F and C','E and D'],rightAnswer:'F and C',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:7,previous:4,next:8,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"What is the Bishop's symbol?",answer:['p','bi','B','He has no symbol'],rightAnswer:'B',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:8,previous:4,next:9,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What is special about the Bishops?",answer:['White Bishops stand on White squares, Black Bishops stand on Black squares','They only travel on one color square the entire game',"They can jump over other pieces",'They can be promoted to King'],rightAnswer:'They only travel on one color square the entire game',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl',rightAnswerTimeout:7000}},{id:9,previous:4,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'How many points is the Bishop worth?',answer:['1','2','3','4'],rightAnswer:'3',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:10,previous:4,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'How do Bishops capture?',answer:['On the diagonal','By jumping over a pawn','Along a file or rank','By getting to the other side of the board'],rightAnswer:'On the diagonal',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:11,previous:4,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'In the Middle Ages, Bishops...',answer:['Were the first line of defense in battle','Gave advice to the King and Queen','Rode horseback into battle','Lived in the castle as painters'],rightAnswer:'Gave advice to the King and Queen',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:12,previous:4,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What is unique about diagonal lines?',answer:["You can't see them",'They alternate colors','They are only one color','They can get you to any square'],rightAnswer:'They are only one color',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:13,previous:4,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the squares <br/>the Bishop could <br/>move to.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({id:8,isQA:true,reminder:true,showIndicators:{allSides:true},celebrationSound:false,position:{c6:'bB'},coordinates:['.square-a4','.square-a8','.square-b5','.square-b7','.square-d5','.square-d7','.square-e4','.square-e8','.square-f3','.square-g2','.square-h1'],coordinateClass:'filled-square',next:14})}},{id:14,previous:4,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the Bishop <br/>could capture.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({id:8,isQA:true,reminder:true,showIndicators:{allSides:true},celebrationSound:false,position:{b3:'wP',b7:'wR',d2:'wR',d5:'bB',d6:'wP',f3:'bP',g8:'wN',h1:'wN'},coordinates:['.square-b3','.square-b7','.square-g8'],coordinateClass:'filled-square',next:15})}},{id:15,previous:4,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Six',styleClass:'xl'}}];var assets=['/img/background_4.png','/img/background_5.png','/img/background_6.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson5Assignment1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson5Assignment2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(2);
var moveCount;/**
* @name lesson5Assignment1
* @function
* @param {config}
* @description: chess board related task
*/function lesson5Assignment1(config){var initialBoardPosition=config.position,next=config.next;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);moveCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_4__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,true);};var onSnapEnd=function onSnapEnd(){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();moveCount++;if(moveCount===2){if(boardFen===config.resultFen){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job '+__WEBPACK_IMPORTED_MODULE_3__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'xs'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...! Try again.',position:'left',styleClass:'xs'});// ChessBoard.game = new window.Chess(config.positionFen);
setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'You have only 2 moves.',position:'left',styleClass:'sm'});moveCount=0;__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_4__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},3000);}}else{__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_4__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);}};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson5Assignment2
* @function
* @param {config}
* @description: chess board related task
*/function lesson5Assignment2(config){var next=config.next,initialBoardPosition=config.position,tryCount=0,timeDelay=2000;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);tryCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_4__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_4__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(piece,move);}}};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();if(boardFen===config.resultFen){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}if(boardFen==='8/1p3p2/p5p1/8/4p3/8/8/3B4'||boardFen==='8/8/B7/8/8/8/8/3n4'||boardFen==='8/8/B7/8/8/1p6/8/3n4'||boardFen==='8/1p6/p5p1/8/4p3/8/8/3B4'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');var magnusMsg="";tryCount=tryCount+1;if(tryCount<=1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});timeDelay=4000;}else{timeDelay=1000;}if(tryCount>1){magnusMsg="Follow this path…<br/> c4-a6-b7-e4-g6-f7-b3-d1.";}else{magnusMsg="Capture the Knight last!";}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:magnusMsg,position:'left',styleClass:'lg'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_4__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},timeDelay);}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_4__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);};var chessConfig={config:{position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_6/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_6/1.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Take two moves to <br/>get the Rook from <br/>c2 to e6. Then from <br/>e6 to a7.',timeout:13000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson6Assignment1 */])({showIndicators:{allSides:true},prefilledCoordinates:['.square-e6','.square-a7'],position:'8/8/8/8/8/8/2R5/8',next:2}),positionFen:'8/8/8/8/8/8/2R5/8 w - - 0 1'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_6/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,text:{data:'Remember, <br/>you must capture a piece on every move!',position:'left',styleClass:'lg',timeout:11000},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the Rook, <br/>then drag him <br/>to the piece <br/>you want him <br/>to capture.',timeout:10000},audio:{src:'img/audio/lesson_6/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson6Assignment2 */])({showIndicators:{allSides:true},position:'8/3p4/1p2n3/3p2b1/4p3/8/1R6/4b1n1',assignmentClass:'custom-sparepiece',next:4}),positionFen:'8/3p4/1p2n3/3p2b1/4p3/8/1R6/4b1n1 w - - 0 1'}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_6/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,text:{data:"Here's a hint...<br/>the White King is the last piece you will capture.",position:'left',styleClass:'lg',timeout:2000},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the Rook, <br/>then drag him to <br/>the piece you want <br/>him to capture. <br/>Remember, if you <br/>take a wrong turn, <br/>you will hit <br/>a dead end.',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson6Assignment3 */])({showIndicators:{allSides:true},position:'8/3P1K2/2P3rP/8/8/P1P2P2/3P1P2/8',assignmentClass:'custom-sparepiece',next:6}),positionFen:'8/3P1K2/2P3rP/8/8/P1P2P2/3P1P2/8 b - - 0 1'}},{id:6,previous:4,next:7,video:{src:'img/videos/lesson_6/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:4,next:8,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"What does the Rook resemble from the Middle Ages?",answer:['The whole castle','The castle moat','The castle fence','The castle tower'],rightAnswer:'The castle tower',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:8,previous:4,next:9,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"How many points is the Rook worth?",answer:['1','3','5','7'],rightAnswer:'5',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:9,previous:4,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"What is the Rook's symbol?",answer:['RK','R',"r",'#'],rightAnswer:'R',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:10,previous:4,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"Where do the Rooks stand at the start of the game?",answer:['The a and h files','The b and g files','The c and f files','The d and e files'],rightAnswer:'The a and h files',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:11,previous:4,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:"How does the Rook move?",answer:['Only on files','Only on ranks','On both files and ranks','On diagonals'],rightAnswer:'On both files and ranks',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:12,previous:4,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'How many squares could this Rook move to from his position on d4?',answer:['12','14','16','18'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/8/3R4/8/8/8'}),hint:true},rightAnswer:'14',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:13,previous:4,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__commonActivities__["a" /* highlightCoordinates */])({isQA:true,showIndicators:{allSides:true},coordinates:['.square-a8','.square-b8','.square-c8','.square-d8','.square-e7','.square-f8'],position:'4r1k1/pp3pp1/4p2p/8/8/3P2P1/PP2PPK1/2R5',celebrationSound:false,coordinateClass:'filled-square',reminder:true})},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on all the <br/>squares the <br/>Black Rook on e8 <br/>could move to.'}},{id:14,previous:4,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'How does the Rook capture?',answer:['Along a file or rank','Along a diagonal','By moving backwards','By jumping over a piece'],rightAnswer:'Along a file or rank',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:15,previous:4,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__commonActivities__["a" /* highlightCoordinates */])({isQA:true,showIndicators:{allSides:true},coordinates:['.square-b4','.square-e3'],position:'8/8/8/8/1P2r1pP/3RP1P1/4N3/8',celebrationSound:false,coordinateClass:'filled-square',reminder:true})},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the pieces <br/>the Black Rook <br/>could capture.'}},{id:16,previous:4,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__commonActivities__["a" /* highlightCoordinates */])({isQA:true,showIndicators:{allSides:true},coordinates:['.square-e6','.square-g4','.square-c6'],position:'4r1k1/1p3pp1/pBn1r3/7p/4R1b1/3P2P1/PP2PPK1/2R5',celebrationSound:false,coordinateClass:'filled-square',reminder:true})},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the <br/>White Rooks <br/>could capture.'}},{id:17,previous:4,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Seven',styleClass:'xl'}}];var assets=['/img/background_5.png','/img/background_6.png','/img/background_7.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson6Assignment1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson6Assignment2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson6Assignment3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
var moveCount;/**
* @name lesson6Assignment1
* @function
* @param {config}
* @description: chess board related task
*/function lesson6Assignment1(config){var next=config.next,initialBoardPosition=config.position,firstLevelBoardPosition='8/8/4R3/8/8/8/8/8';var afterLoad=function afterLoad(){var prefilledCoordinates=config.prefilledCoordinates;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);moveCount=0;prefilledCoordinates.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(k).addClass('filled-square');});};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target);};var onSnapEnd=function onSnapEnd(source,target){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();moveCount++;if(moveCount===2){if(target==='e6'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-e6').addClass('success');}else{moveCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},4000);}}else if(moveCount===4){if(target==='a7'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-a7').addClass('success');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["b" /* ACTIVITY_SUCCESS_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3500,next,true);}else{moveCount=2;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Keep trying...',position:'left',styleClass:'xs'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(firstLevelBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(firstLevelBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},4000);}}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);};var chessConfig={config:{position:initialBoardPosition,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson6Assignment2
* @function
* @param {config}
* @description: chess board related task
*/function lesson6Assignment2(config){var next=config.next;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_3__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(piece,move);}}};var onSnapEnd=function onSnapEnd(source,target){if(target==='d7'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3500,next);}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson6Assignment3
* @function
* @param {config}
* @description: chess board related task
*/function lesson6Assignment3(config){var next=config.next,initialBoardPosition=config.position,tryCount=0,timeDelay=2000;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);tryCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_3__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(piece,move);}}};var onSnapEnd=function onSnapEnd(source,target){if(target==='f7'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37').find('.piece-417db').length===1){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3500,next);}if(target==='f7'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37').find('.piece-417db').length>1||target==='h6'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37 .square-c6').find('.piece-417db').length===0||target==='a3'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37 .square-c3').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37 .square-f3').find('.piece-417db').length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');var magnusMsg="";tryCount=tryCount+1;if(tryCount<=1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});timeDelay=4000;}else{timeDelay=1000;}if(tryCount>1){magnusMsg="Follow this path...<br/> h6-c6-c3-a3-f3-f2-d2-d7-f7.";}else{magnusMsg="Here's a hint...<br/>the White King is the last piece you will capture.";}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:magnusMsg,position:'left',styleClass:'lg'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';},timeDelay);}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);};var chessConfig={config:{position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_7/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,text:{data:'Here\'s a hint, <br/>7 of them equal the Queen!',position:'left',styleClass:'sm',timeout:5000},activity:{callback:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson7Assignment1 */])({next:2})},audio:{src:'img/audio/lesson_7/1.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Check the boxes <br/>for all the <br/>chess piece <br/>combinations <br/>equal to <br/>the Queen.',timeout:9000}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_7/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>square the Queen <br/>could move to.',timeout:8000},text:{data:'Remember, <br/>she only moves in straight lines',position:'left',styleClass:'md',timeout:8000},audio:{src:'img/audio/lesson_7/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({next:4,showIndicators:{allSides:true},coordinates:['.square-a2','.square-b3','.square-c4','.square-a5','.square-b5','.square-c5','.square-a8','.square-b7','.square-c6','.square-d1','.square-d2','.square-d3','.square-d4','.square-d6','.square-d7','.square-d8','.square-e4','.square-f3','.square-g2','.square-h1','.square-e5','.square-f5','.square-g5','.square-h5','.square-e6','.square-f7','.square-g8'],position:{d5:'bQ'},coordinateClass:'filled-cell',reminder:true})}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_7/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/lesson_7/3.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the <br/>Queen, then drag <br/>her to the <br/>piece you want her <br/>to capture. <br/>Remember, she <br/>must make <br/>a capture <br/>on every move.',timeout:12000},text:{data:"Here's a hint...<br/>the White King is the last piece you will capture.",position:'left',styleClass:'lg',timeout:13000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson7Assignment4 */])({showIndicators:{allSides:true},position:'KB6/3N3N/7P/6Pq/7P/8/3R1R2/1B5k',assignmentClass:'assignment-7-4 custom-sparepiece',next:6}),positionFen:'KB6/3N3N/7P/6Pq/7P/8/3R1R2/1B5k b - - 0 1'}},{id:6,previous:4,next:8,video:{src:'img/videos/lesson_7/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:6,next:8,directions:{data:'<b>DIRECTIONS:</b> <br/>Click on the <br/>Black Queen, then <br/>drag her to the <br/>piece you want her <br/>to capture. <br/>Remember, she <br/>must make <br/>a capture <br/>on every move.'},text:{data:"Here's a hint...<br/>the White Queen is the last piece you will capture.",position:'left',styleClass:'lg'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson7Assignment3 */])({showIndicators:{allSides:true},position:'1P1N1N2/P6P/1P6/7k/8/R5P1/q2Q1B2/1R6',assignmentClass:'assignment-7-3 custom-sparepiece',next:8}),positionFen:'1P1N1N2/P6P/1P6/7k/8/R5P1/q2Q1B2/1R6 b - - 0 1'}},{id:8,previous:6,next:9,video:{src:'img/videos/lesson_7/5.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:10,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"On which squares do the Queens start a game?",answer:['e1 and e8','e1 and d8','d1 and e8','d1 and d8'],rightAnswer:'d1 and d8',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:10,previous:9,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"What is the Queen's symbol?",answer:['D','Q','A crown','She has no symbol'],rightAnswer:'Q',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:9,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"How many points is the Queen worth?",answer:['5','9','7','20'],rightAnswer:'9',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:12,previous:9,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What is special about the Queen?",answer:['She is the most powerful piece on the chessboard','She can be demoted to a pawn',"She can move to any square she wants",'All of the above'],rightAnswer:'She is the most powerful piece on the chessboard',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xl',rightAnswerTimeout:7000}},{id:13,previous:9,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'How does the Queen move?',answer:['In circles','Four squares at a time','Any direction in a straight line','Wherever she wants'],rightAnswer:'Any direction in a straight line',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:14,previous:9,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'How do Queens capture?',answer:['By bumping a piece on a diagonal','By bumping a piece along a file','By bumping a piece along a rank','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:15,previous:9,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'In the Middle Ages, Queens...',answer:['Were the first line of defense in battle','Were very powerful','Rode horseback into every battle','Were low ranking royalty'],rightAnswer:'Were very powerful',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:9,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({isQA:true,showIndicators:{allSides:true},coordinates:['.square-a4','.square-b3','.square-c2','.square-d2','.square-d3'],position:'rnbqkbnr/1p3ppp/p1p1p3/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',celebrationSound:false,coordinateClass:'filled-square',reminder:true})},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on every <br/>square where <br/>the White Queen <br/>could move.'}},{id:17,previous:9,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({isQA:true,showIndicators:{allSides:true},coordinates:['.square-a8','.square-a5','.square-b3','.square-d2','.square-h1'],position:'R7/2p5/1p1kpBn1/R2q1p2/8/1N4P1/3PPP1P/5K1N',celebrationSound:false,coordinateClass:'filled-square',reminder:true})},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the <br/>Black Queen <br/>could capture.'}},{id:18,previous:9,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Which chess pieces equal the Queen?',answer:["1 Rook + 2 Knights",'1 Rook + 1 Knight + 1 Bishop','1 Rook + 1 Bishop','1 Rook + 4 pawns'],rightAnswer:'1 Rook + 4 pawns',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:19,previous:9,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Eight',styleClass:'xl'}}];var assets=['/img/background_6.png','/img/background_7.png','/img/background_8.png','/img/box.png','/img/tick.png','/img/cross.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson7Assignment1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson7Assignment3;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson7Assignment4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
var tryCount=0;/**
* @name lesson7Assignment1
* @function
* @param {config}
* @description: activity related task
*/function lesson7Assignment1(config){var callback=function callback(){var body='\n      <div class="card">\n        <div class="card-wrapper">\n          <ul class="options-table">\n            <li class="table-row flex-vertical-center" index="0"><span class="answer-img"></span><span class="answer">1R + 4p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="1"><span class="answer-img"></span><span class="answer">2N + 1B = Q</span></li>\n            <li class="table-row flex-vertical-center" index="2"><span class="answer-img"></span><span class="answer">1B + 1N + 3p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="3"><span class="answer-img"></span><span class="answer">1R + 1N + 3p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="4"><span class="answer-img"></span><span class="answer">2N + 3p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="5"><span class="answer-img"></span><span class="answer">1B+ 6p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="6"><span class="answer-img"></span><span class="answer">2B+ 1R = Q</span></li>\n            <li class="table-row flex-vertical-center" index="7"><span class="answer-img"></span><span class="answer">9p = Q</span></li>\n            <li class="table-row flex-vertical-center" index="8"><span class="answer-img"></span><span class="answer">2R = Q</span></li>\n            <li class="table-row flex-vertical-center" index="9"><span class="answer-img"></span><span class="answer">3B = Q</span></li>\n          </ul>\n        </div>\n      </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-content').html(body);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.table-row').click(function(){var index=parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('index'),10),correctCount=void 0;if(index===3||index===6||index===8){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('wrong');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('correct');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);}correctCount=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.table-row.correct').length;if(correctCount===7){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,config.next,true);}});};return callback;}/**
* @name lesson7Assignment3
* @function
* @param {config}
* @description: chess board related task
*/function lesson7Assignment3(config){var next=config.next,initialBoardPosition=config.position,timeDelay=2000;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);tryCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){if(piece.search(__WEBPACK_IMPORTED_MODULE_3__utils_constants__["d" /* BLACK_KING_SEARCH_KEY */])!==-1||piece.search(__WEBPACK_IMPORTED_MODULE_3__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */])!==-1){return false;}};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(piece,move);}}};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37').find('.piece-417db').length===2){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3500,next,true);}else if(target==='a3'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-g3').find('.piece-417db').length===0||target==='a7'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a3').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0||target==='b1'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h7').find('.piece-417db').length===0||target==='b6'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b1').find('.piece-417db').length===0||target==='b8'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b1').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-g3').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f8').find('.piece-417db').length===0||target==='d2'||target==='d8'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f8').find('.piece-417db').length===0||target==='f2'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-g3').find('.piece-417db').length===0||target==='f8'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d8').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a3').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f2').find('.piece-417db').length===0||target==='g3'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a3').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0||target==='h7'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b1').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-a7').find('.piece-417db').length===0){var msg='';tryCount++;if(tryCount<=1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});timeDelay=4000;}else{timeDelay=1000;}if(tryCount>1){msg="Follow this path...<br/> b1-h7-a7-a3-f8-d8-b6-b8-g3-f2-d2.";}else{msg="Here's a hint...<br/>the White Queen is the last piece you will capture.";}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:msg,position:'left',styleClass:'lg'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';},timeDelay);}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson7Assignment4
* @function
* @param {config}
* @description: chess board related task
*/function lesson7Assignment4(config){var next=config.next,initialBoardPosition=config.position,tryCount=0,timeDelay=2000;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);tryCount=0;};var onDragStart=function onDragStart(source,piece,position,orientation){if(piece.search(__WEBPACK_IMPORTED_MODULE_3__utils_constants__["d" /* BLACK_KING_SEARCH_KEY */])!==-1||piece.search(__WEBPACK_IMPORTED_MODULE_3__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */])!==-1){return false;}};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(piece,move);}}};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_0_jquery___default()("[data-piece=bK]")[0].style.display="none";if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37').find('.piece-417db').length===2){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3500,next,true);}else if(target==='a8'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-b8').find('.piece-417db').length===0||target==='d7'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h7').find('.piece-417db').length===0||target==='f2'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h4').find('.piece-417db').length===0||target==='g5'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h4').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0||target==='h4'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-f2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-g5').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h6').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h7').find('.piece-417db').length===0||target==='h6'&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h7').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-g5').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-d2').find('.piece-417db').length===0&&__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard .square-h4').find('.piece-417db').length===0){var msg='';tryCount++;if(tryCount<=1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again',position:'left',styleClass:'xs'});timeDelay=4000;}else{timeDelay=1000;}if(tryCount>1){msg="Follow this path...<br/> h6-g5-h4-f2-d2-d7-h7-b1-b8-a8.";}else{msg="Here's a hint...<br/>the White King is the last piece you will capture.";}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').addClass('no-action');setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:msg,position:'left',styleClass:'lg'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').removeClass('no-action');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';},timeDelay);}__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_3__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonActivities__ = __webpack_require__(5);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_8/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__commonActivities__["a" /* highlightCoordinates */])({next:2,showIndicators:{allSides:true},coordinates:['.square-c4','.square-c5','.square-d5','.square-e5','.square-e4','.square-e3','.square-d3','.square-c3'],position:{d4:'wK'},coordinateClass:'filled-cell',reminder:true})},audio:{src:'img/audio/lesson_8/1.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Click on all the <br/>squares adjacent, <br/>or next to, the King <br/>to see his <br/>Ring of Power.',timeout:9000}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_8/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_8/2.mp3',start:true,controls:false},directions:{timeout:16000,data:'<b>DIRECTIONS:</b> <br/>Click on the 7 <br/>squares closest <br/>to the white King <br/>where the Black <br/>King could stand.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__commonActivities__["a" /* highlightCoordinates */])({next:5,showIndicators:{allSides:true},coordinates:['.square-e1','.square-e2','.square-e3','.square-e4','.square-f4','.square-g4','.square-h4'],position:{g2:'wK'},coordinateClass:'filled-cell-red',reminder:true})}},{id:4,previous:2,next:18,video:{src:'img/videos/lesson_8/3.mp4',startTime:0,autoStartNext:true,next:6}},{id:5,previous:2,next:18,video:{src:'img/videos/lesson_8/3.1.mp4',startTime:0,autoStartNext:true,next:6}},{id:6,previous:4,next:8,audio:{src:'img/audio/lesson_8/3.mp3',start:true,controls:false},directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below',className:'no-animation'},options:{id:2,next:7,answer:['Capture','Block','Escape'],rightAnswer:'a "Capture"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually a "Capture".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'5qk1/5ppQ/5n1p/8/8/3B1N1P/2P2PP1/6K1',assignmentClass:'custom-sparepiece',from:"square-h7",to:"square-g8",offset:[3,3,9,9],next:7}),canvas:true}},{id:7,previous:4,next:8,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'5qk1/5ppQ/5n1p/8/8/3B1N1P/2P2PP1/6K1',finalPosition:'5qk1/5ppn/7p/8/8/3B1N1P/2P2PP1/6K1',assignmentClass:'custom-sparepiece',from:"square-f6",to:"square-h7",offset:[8,5,2,6],capture:{capturingPiece:'bN',capturedPiece:'wQ'},next:8}),canvas:true}},{id:8,previous:6,next:10,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below',className:'no-animation'},options:{id:2,next:9,answer:['Capture','Block','Escape'],rightAnswer:'a "Block"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually a "Block".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'3R2k1/5ppp/8/8/8/b7/5P2/6K1',assignmentClass:'custom-sparepiece',from:"square-d8",to:"square-g8",offset:[8,null,1,null],next:9}),canvas:true}},{id:9,previous:6,next:10,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'3R2k1/5ppp/8/8/8/b7/5P2/6K1',finalPosition:'3R1bk1/5ppp/8/8/8/8/5P2/6K1',assignmentClass:'custom-sparepiece',from:"square-a3",to:"square-f8",offset:[8,2,null,null],next:10}),canvas:true}},{id:10,previous:8,next:12,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below',className:'no-animation'},options:{id:2,next:11,answer:['Capture','Block','Escape'],rightAnswer:'a "Capture"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually a "Capture".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'6k1/5pp1/7p/8/7P/3r2P1/1nq2P2/2K1R3',assignmentClass:'custom-sparepiece',from:"square-c2",to:"square-c1",offset:[null,6,null,1],next:11}),canvas:true}},{id:11,previous:8,next:12,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'6k1/5pp1/7p/8/7P/3r2P1/1nq2P2/2K1R3',finalPosition:'6k1/5pp1/7p/8/7P/3r2P1/1nK2P2/4R3',assignmentClass:'custom-sparepiece',from:"square-c1",to:"square-c2",offset:[null,1,null,6],capture:{capturingPiece:'wK',capturedPiece:'bQ'},next:12}),canvas:true}},{id:12,previous:10,next:14,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below',className:'no-animation'},options:{id:2,next:13,answer:['Capture','Block','Escape'],rightAnswer:'a "Block"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually a "Block".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'6k1/5pp1/7p/8/8/5RN1/5PPP/1q4K1',assignmentClass:'custom-sparepiece',from:"square-b1",to:"square-g1",offset:[8,null,1,null],next:13}),canvas:true}},{id:13,previous:10,next:14,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'6k1/5pp1/7p/8/8/5RN1/5PPP/1q4K1',finalPosition:'6k1/5pp1/7p/8/8/5R2/5PPP/1q3NK1',assignmentClass:'custom-sparepiece',from:"square-g3",to:"square-f1",offset:[2,8,null,null],next:14}),canvas:true}},{id:14,previous:12,next:16,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below',className:'no-animation'},options:{id:2,next:15,answer:['Capture','Block','Escape'],rightAnswer:'an "Escape"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually an "Escape".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'4R1k1/1p3p2/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',assignmentClass:'custom-sparepiece',from:"square-e8",to:"square-g8",offset:[8,null,1,null],next:15}),canvas:true}},{id:15,previous:12,next:16,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'4R1k1/1p3p2/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',finalPosition:'4R3/1p3p1k/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',assignmentClass:'custom-sparepiece',from:"square-g8",to:"square-h7",offset:[8,8,null,null],next:16}),canvas:true}},{id:16,previous:14,next:18,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below.',className:'no-animation'},options:{id:2,next:17,answer:['Capture','Block','Escape'],rightAnswer:'an "Escape"',magnusWrongAnswer:{data:'Oops...!!!<br/>It is actually an "Escape".',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson8Assignment2 */])({showIndicators:{allSides:true},position:'4r1k1/5p2/2p2bpp/1b6/3K4/P1P3P1/1P3P2/3R3R',assignmentClass:'custom-sparepiece',from:"square-f6",to:"square-d4",offset:[2,8,8,2],next:17}),canvas:true}},{id:17,previous:14,next:19,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson8Assignment3 */])({showIndicators:{allSides:true},position:'4r1k1/5p2/2p2bpp/1b6/3K4/P1P3P1/1P3P2/3R3R',finalPosition:'4r1k1/5p2/2p2bpp/1bK5/8/P1P3P1/1P3P2/3R3R',assignmentClass:'custom-sparepiece',from:"square-d4",to:"square-c5",offset:[2,2,6,6],next:19}),canvas:true}},{id:18,previous:4,next:20,video:{src:'img/videos/lesson_8/4.mp4',startTime:0,autoStartNext:true,next:20}},{id:19,previous:4,next:20,video:{src:'img/videos/lesson_8/4.1.mp4',startTime:0,autoStartNext:true,next:20}},{id:20,previous:18,next:21,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"On which files do the Kings start a game?",answer:['d','b','f','e'],rightAnswer:'e',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:21,previous:18,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"How many points is the King worth?",answer:['10','25','50','Priceless'],rightAnswer:'Priceless',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:22,previous:18,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"What is the King's symbol?",answer:['C','K','B','He has no symbol'],rightAnswer:'K',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:23,previous:18,next:24,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What does the King represent from the Middle Ages?",answer:['The land owners','The church',"The peasants",'The entire kingdom'],rightAnswer:'The entire kingdom',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',rightAnswerTimeout:7000}},{id:24,previous:18,next:25,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'How does the King move?',answer:['Across the ranks','Up and down files','On the diagonal','One square any direction'],rightAnswer:'One square any direction',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:25,previous:18,next:26,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What are the squares around the King called?',answer:['The Guard House','The Corral','The Ring of Power','The Castle'],rightAnswer:'The Ring of Power',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:26,previous:18,next:27,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'How do Kings Capture?',answer:['On the diagonal','By jumping over a pawn','Along a file or rank','One square any direction'],rightAnswer:'One square any direction',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:27,previous:18,next:28,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Analyze the board to decide what is wrong about this setup',answer:['There are too many pawns','The Kings can\'t stand next to each other','The black Bishop should be on a black diagonal','The white Knight can\'t stand next to his own King'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'2r5/p4p1p/1p2k1p1/2pNK3/8/6P1/1PP2PBP/8'}),hint:true},rightAnswer:'The Kings can\'t stand next to each other',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'}},{id:28,previous:18,next:29,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Which piece could you move to put the white King in check?',answer:['Have the e1 Knight capture the f3 pawn','Move the d6 Rook to d3','Have the e7 Queen capture the b7 Queen','Move the Bishop to e5'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/1Q2q1k1/3r4/1R5P/2P3P1/1P3PK1/Pb6/4n3'}),hint:true},rightAnswer:'Move the Bishop to e5',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:29,previous:18,next:30,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'How can the black King get out of check?',answer:['Use the Queen to capture the a7 Rook','Have the King escape to h5','Have the King escape to h6','Move the Rook to e4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/R7/6k1/4P3/8/3B4/4P3/1KB1r1q1'}),hint:true},rightAnswer:'Have the King escape to h5',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:30,previous:18,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Nine',styleClass:'xl'}}];var assets=['/img/background_7.png','/img/background_8.png','/img/background_9.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson8Assignment2;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson8Assignment3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/**
* @name lesson7Assignment2
* @function
* @param {config}
* @description: chess board related task
*/function lesson8Assignment2(config){var offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];}var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.from,config.to,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,"#cc0000");};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson7Assignment3
* @function
* @param {config}
* @description: chess board related task
*/function lesson8Assignment3(config){var moveSpeed=1000,offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];};var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.from,config.to,offsetFromx,offsetFromy,offsetTox,offsetToy);setTimeout(function(){ctx.clearRect(0,0,c.width,c.height);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(config.from.substr(7,9)+"-"+config.to.substr(7,9));if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move);},moveSpeed);}},1000);};var chessConfig={config:{position:config.position,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:1,video:{src:'img/videos/lesson_9/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_9/1.mp3',start:true,controls:false},directions:{timeout:0,data:'<b>ANALYSIS :</b> <br/>Here are four <br/>options for the <br/>Knight on f3. <br/>Click on the <br/>best option.',className:'no-animation'},options:{answer:['Knight captures e5 Rook','Knight captures d4 Bishop','Knight moves to d2','Knight moves to e1'],validateAnswer:{rightAnswer:1,userAnswer:-1},magnusCorrectAnswer:{data:'Correct, White would win the Bishop worth 3 points.',styleClass:'md',waitTime:6000},magnusWrongAnswer:{data:'Oops! The best choice is to safely capture the Bishop, worth 3 points, and not risk being captured.',styleClass:'xl',waitTime:7000}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson9Assignment1 */])({showIndicators:{allSides:true},position:'r5k1/pb3ppp/1pp5/3pr3/3b3B/2NP1N2/PPP2PPP/R4RK1',assignmentClass:'custom-sparepiece',next:2}),canvas:true}},{id:2,previous:1,next:3,video:{src:'img/videos/lesson_9/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_9/2 .mp3',start:true,controls:false},directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:'Oops! This is a Stalemate. The King is not in check but there is no legal move to make.',styleClass:'xl',waitTime:8000},validateAnswer:{rightAnswer:1,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'7k/6rP/5BB1/8/8/8/1K6/8',assignmentClass:'custom-sparepiece',next:4})}},{id:4,previous:3,next:5,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:'Oops! It’s Play On! The King is not in check, and there are several moves that can be made.',styleClass:'xxl',waitTime:8000},validateAnswer:{rightAnswer:2,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'7k/1p5P/p6K/P2p4/3P4/8/8/8',assignmentClass:'custom-sparepiece',next:5})}},{id:5,previous:4,next:6,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:'Oops! It’s checkmate. The white pawn is attacking the Black King and there is no way to capture, block or escape.',styleClass:'xxxl',waitTime:8000},validateAnswer:{rightAnswer:0,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'2R3qk/1p4P1/p6K/P2p4/3P4/8/8/2R5',assignmentClass:'custom-sparepiece',next:6})}},{id:6,previous:5,next:7,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:"Oops! It's a Play On! The Rook has the King in check, but the black Bishop can move to c8 to block the attack.",styleClass:'xl',waitTime:8000},validateAnswer:{rightAnswer:2,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'1k3R2/1pp5/pP6/8/4P3/4P2b/1K6/8',assignmentClass:'custom-sparepiece',next:7})}},{id:7,previous:6,next:8,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:"Oops! It's checkmate. The white Bishop and Rook have the black King in checkmate, there is no way to capture, block or escape.",styleClass:'xxxl',waitTime:8000},validateAnswer:{rightAnswer:0,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'2r1R2k/1p1b1p1p/p5p1/8/8/2B3P1/1PP2P1P/6K1',assignmentClass:'custom-sparepiece',next:8})}},{id:8,previous:7,next:9,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It\'s Black\'s turn <br/>to move.<br/>Click on the <br/>correct answer.',className:'no-animation'},options:{answer:['CHECKMATE','STALEMATE','PLAY ON!'],magnusWrongAnswer:{data:"Oops, it’s a stalemate. The King is not in check, but the Knight and pawn are attacking every square the King could move to.",styleClass:'xxxl',waitTime:8000},validateAnswer:{rightAnswer:1,userAnswer:-1}},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'7k/8/5N1P/8/3K4/8/8/8',assignmentClass:'custom-sparepiece',next:9})}},{id:9,previous:8,next:10,video:{src:'img/videos/lesson_9/3.mp4',startTime:0,autoStartNext:true,next:10}},{id:10,previous:9,next:11,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"If a King is in check and there is no way to capture or block the attacking piece, and no way for the King to escape, it's called...",answer:["Scholar's Mate",'Checkmate','Stalemate',"Fool's Mate"],rightAnswer:'Checkmate',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:9,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"What is 'Check'?",answer:['When the King is under attack','When the King is captured','When the Queen is under attack','When the Queen is captured'],rightAnswer:'When the King is under attack',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:12,previous:9,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"What is Fool's Mate?",answer:['When you accidentally checkmate the King','The slowest checkmate possible','The fastest checkmate possible','Not really a checkmate'],rightAnswer:'The fastest checkmate possible',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:13,previous:9,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"What is Stalemate?",answer:['When you accidentally checkmate the King','The slowest checkmate possible',"When a player cannot move but isn't in check",'A King without any pieces to help'],rightAnswer:"When a player cannot move but isn't in check",validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',rightAnswerTimeout:7000}},{id:14,previous:9,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'Analyze the game; what is happening?',answer:['White is checkmated','Black is checkmated','It is a stalemate','They should play on'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'rrk5/ppp5/8/8/2p4B/1Q4PB/2p2P2/K7'}),hint:true},rightAnswer:'Black is checkmated',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:15,previous:9,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'Analyze the game; what is happening?',answer:['White is checkmated','Black is checkmated','It is a stalemate','They should play on'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'rn1qkb1r/pp1bpp1p/3p1Np1/1Bn5/3N4/8/PPP1QPPP/R1B1K2R'}),hint:true},rightAnswer:'Black is checkmated',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:9,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Queen to c7 is a bad move. Why?',answer:['The Black King can capture the White Queen','It causes stalemate','The White King should move first',"It's check, not checkmate"],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'k7/7Q/8/8/1K6/8/8/8'}),hint:true,canvas:{from:"square-h7",to:"square-c7"}},rightAnswer:'It causes stalemate',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:17,previous:9,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Black Queen to c2 a good idea. Why?',answer:['It is trapping the White King','It creates a stalemate','It creates a checkmate','There are no other options'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/8/8/3q2k1/8/4K3'}),hint:true,canvas:{from:"square-d3",to:"square-c2"}},rightAnswer:'It is trapping the White King',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:18,previous:9,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Which of these squares can Black move to checkmate White?',answer:['Queen to c4','Queen to g2','Queen to f5','Queen to d1'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/8/8/6k1/2q5/5K2'}),hint:true},rightAnswer:'Queen to d1',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:19,previous:9,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Which of these squares can White move to checkmate Black?',answer:['Bishop to g8','King to g6','Bishop to e5','Bishop to b8'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'7k/5B2/7K/8/8/8/7B/8'}),hint:true},rightAnswer:'Bishop to e5',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:20,previous:9,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Ten',styleClass:'xl'}}];var assets=['/img/background_8.png','/img/background_9.png','/img/background_10.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson9Assignment1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/**
* @name lesson9Assignment1
* @function
* @param {config}
* @description: chess board related task
*/function lesson9Assignment1(config){var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas"),ctx=c.getContext("2d");var from=document.getElementsByClassName("square-a1"),fromx=from[0].offsetParent.offsetLeft+from[0].offsetLeft,to=document.getElementsByClassName("square-b1"),tox=to[0].offsetParent.offsetLeft+to[0].offsetLeft;var squareEdge=tox-fromx;var arrowTail=squareEdge/7;var arrowHead=squareEdge/8;var arrowCompletion=arrowTail/squareEdge*10/2;ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-f3","square-f5",null,null,null,5-arrowCompletion,0,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-f3","square-d3",null,null,null,null,0,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-f3","square-f1",null,null,null,5+arrowCompletion,0,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-f5","square-e5",null,null,null,null,arrowHead,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-d3","square-d4",null,null,null,null,arrowHead,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-d3","square-d2",null,null,null,null,arrowHead,arrowTail);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,"square-f1","square-e1",null,null,null,null,arrowHead,arrowTail);};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_10/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_10/1.mp3',start:true,controls:false},directions:{timeout:5000,data:'<b>DIRECTIONS:</b> <br/>Match the chess <br/>piece with the <br/>correct feature <br>or talent.'},activity:{assignmentClass:'assignment-10-1',callback:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson10Assignment1 */])({next:3})},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* dragDropPieces */])({singleSpare:true,assignmentClass:'assignment-10-1',piecesArray:['bK','bQ','bR','bB','bN','bP'],validatePieces:{'bK':['a4'],'bQ':['a6'],'bR':['a2'],'bB':['a7'],'bN':['a5'],'bP':['a3']},pieceLimit:{bK:1,bQ:1,bR:1,bB:1,bN:1,bP:1},resultFen:'8/b7/q7/n7/k7/p7/r7/8',pieceTheme:'assignment_10_1',next:3})}},{id:2,previous:0,next:6,video:{src:'img/videos/lesson_10/2.mp4',startTime:0,autoStartNext:true,next:4}},{id:3,previous:0,next:6,video:{src:'img/videos/lesson_10/2.1.mp4',startTime:0,autoStartNext:true,next:4}},{id:4,previous:2,next:5,audio:{src:'img/audio/lesson_10/2.mp3',start:true,controls:false},directions:{timeout:5000,data:'<b>DIRECTIONS:</b> <br/>Move the King <br/>and Rook to castle <br/>on the white <br/>King\u2019s side.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson10Assignment2 */])({showIndicators:{allSides:true},position:'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R',finalPosition:'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1',startChance:' w KQkq - 0 1',assignmentClass:'custom-sparepiece',kingTarget:'g1',rookTarget:'f1',source:'e1',target:'g1',next:5}),positionFen:'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQkq - 0 1'}},{id:5,previous:4,next:6,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the King <br/>and Rook to castle <br/>on the black <br/>Queen\u2019s side.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson10Assignment2 */])({showIndicators:{allSides:true},position:'r3kbnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R',finalPosition:'2kr1bnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R',startChance:' b KQkq - 0 1',assignmentClass:'custom-sparepiece',kingTarget:'c8',rookTarget:'d8',source:'e8',target:'c8',next:7}),positionFen:'r3kbnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R b KQkq - 0 1'}},{id:6,previous:2,next:13,video:{src:'img/videos/lesson_10/3.mp4',startTime:0,autoStartNext:true,next:8}},{id:7,previous:2,next:13,video:{src:'img/videos/lesson_10/3.1.mp4',startTime:0,autoStartNext:true,next:8}},{id:8,previous:6,next:9,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can\u2019t castle.',className:'no-animation'},options:{id:0,answer:['Yes, I can castle','No, the King or Rook already moved','No, squares between them aren’t empty','No, the King would pass through or end in check'],rightAnswer:'a "Block"',magnusWrongAnswer:{data:'Oops! The King and Rook can’t castle because there is a Knight in the way.',styleClass:'lg',waitTime:4000},highlightSquare:"square-g8",validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'r1bqk1nr/pppp1ppp/2n5/2b1p3/4P3/P1N2N2/1PPP1PPP/R1BQKB1R',next:9}),heading:'Black Kingside Castle'}},{id:9,previous:8,next:11,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can\u2019t castle.',className:'no-animation'},options:{id:1,answer:['Yes, I can castle','No, the King or Rook already moved','No, squares between them aren’t empty','No, the King would pass through or end in check'],next:10,rightAnswer:'a "Block"',magnusWrongAnswer:{data:'It’s all good, the King and Rook can castle!',styleClass:'lg',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R',next:10}),heading:'White Kingside Castle'}},{id:10,previous:8,next:11,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson10Assignment3 */])({showIndicators:{allSides:true},position:'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R',finalPosition:'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1',next:11}),heading:'White Kingside Castle'}},{id:11,previous:9,next:12,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can\u2019t castle.',className:'no-animation'},options:{id:2,answer:['Yes, I can castle','No, the King or Rook already moved','No, squares between them aren’t empty','No, the King would pass through or end in check'],rightAnswer:'a "Block"',magnusWrongAnswer:{data:'Oops! The King would pass through the Bishop’s attack on d1',styleClass:'lg',waitTime:4000},canvas:{from:'square-g4',to:'square-d1',offset:[2,8,null,null],color:'#cc0000'},validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'r2qk2r/pp2ppbp/2np1np1/8/3NP1b1/2N1B3/PPPQ1PPP/R3KB1R',next:12}),heading:'White Queenside Castle'}},{id:12,previous:11,next:13,directions:{timeout:0,data:'<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can\u2019t castle.',className:'no-animation'},options:{id:3,answer:['Yes, I can castle','No, the King or Rook already moved','No, squares between them aren’t empty','No, the King would pass through or end in check'],rightAnswer:'a "Block"',magnusWrongAnswer:{data:'Oops! It looks like the King is not on his starting square.',styleClass:'lg',waitTime:4000},highlightSquare:"square-e8",validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'r2k1bnr/pppb1ppp/2n5/1B2p3/4P3/2N2N2/PPP2PPP/R1B1K2R',next:13}),heading:'Black Queenside Castle'}},{id:13,previous:6,next:14,video:{src:'img/videos/lesson_10/4.mp4',startTime:0,autoStartNext:true,next:14}},{id:14,previous:13,next:15,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Castling is a special move using which two pieces?',answer:['Pawn and Queen','Knight and Queen','Bishop and King','Rook and King'],rightAnswer:'Rook and King',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:15,previous:13,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'What is one of the rules of castling?',answer:['The Rook has to be in the center of the board','The Rook and King cannot have moved yet','The King has to switch places with the Queen','The Knight has to be on his starting square'],rightAnswer:'The Rook and King cannot have moved yet',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:16,previous:13,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'What is the second rule of castling?',answer:['The squares between the King and Rook must be empty','The Bishop and Knight must be on their starting squares','The pawn in front of the King must have moved','The Queen must be between the King and Rook'],rightAnswer:'The squares between the King and Rook must be empty',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:17,previous:13,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'What is the third rule of castling?',answer:['The Rook has to be in the center of the board','The Rook and King must have already moved','The King cannot pass through or land in check','The Queen has to be on her starting square'],rightAnswer:'The King cannot pass through or land in check',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:18,previous:13,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'What is one reason you castle?',answer:['To checkmate the King','To give the King more power','To prevent your Rook being captured','To move the King to a safer place'],rightAnswer:'To move the King to a safer place',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:19,previous:13,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What is the second reason you castle?',answer:['To promote your pawn','To move the Rook to a more central place','To prevent the Queen being captured','To create a stalemate'],rightAnswer:'To move the Rook to a more central place',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'}},{id:20,previous:13,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'What does a “Queen side castle” mean?',answer:['You castle on the Queen’s side of the board','The Queen and Rook castle together','The Queen and King castle together','The Queen has to be on her starting square'],rightAnswer:'You castle on the Queen’s side of the board',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:21,previous:13,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Why is castling a unique move?',answer:['Only White gets to castle','Only Black gets to castle',"It's the only time Black and White move together","It's the only time two pieces move at the same time"],rightAnswer:'It’s the only time two pieces move at the same time',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:22,previous:13,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'A King side castle happens on what part of the board?',answer:['Files a-d','Files e-h','Ranks 1-4','Ranks 5-8'],rightAnswer:'Files e-h',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true}}},{id:23,previous:13,next:24,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'A Queen side castle happens on what part of the board?',answer:['Files a-d','Files e-h','Ranks 1-4','Ranks 5-8'],rightAnswer:'Files a-d',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true}),hint:true}}},{id:24,previous:13,next:25,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'First Move 202',result:true,styleClass:'xl',timeout:7000}},{id:25,previous:13,next:null,video:{src:'img/videos/lesson_10/5.mp4',startTime:0,autoStartNext:true,next:null}}];var assets=['/img/background_9.png','/img/background_10.png','/img/box.png','/img/chesspieces/assignment_10_1/bK.svg','/img/chesspieces/assignment_10_1/bQ.svg','/img/chesspieces/assignment_10_1/bR.svg','/img/chesspieces/assignment_10_1/bB.svg','/img/chesspieces/assignment_10_1/bN.svg','/img/chesspieces/assignment_10_1/bP.svg'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson10Assignment1;
/* harmony export (immutable) */ __webpack_exports__["a"] = dragDropPieces;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson10Assignment2;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson10Assignment3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/**
* @name lesson10Assignment1
* @function
* @param {config}
* @description: activity related task
*/function lesson10Assignment1(config){var callback=function callback(){var body='\n      <div class="card flex-center">\n        <div class="card-wrapper full-width">\n          <ul class="options-table">\n            <li class="table-row flex-vertical-center" index="0"><span class="answer-img"></span><span class="answer">This piece only travels on diagonal lines</span></li>\n            <li class="table-row flex-vertical-center" index="1"><span class="answer-img"></span><span class="answer">This piece is the most powerful</span></li>\n            <li class="table-row flex-vertical-center" index="2"><span class="answer-img"></span><span class="answer">This piece can jump over other pieces</span></li>\n            <li class="table-row flex-vertical-center" index="3"><span class="answer-img"></span><span class="answer">If you trap this piece then you win</span></li>\n            <li class="table-row flex-vertical-center" index="4"><span class="answer-img"></span><span class="answer">This piece moves and captures differently</span></li>\n            <li class="table-row flex-vertical-center" index="5"><span class="answer-img"></span><span class="answer">This piece is part of a castle</span></li>\n          </ul>\n        </div>\n      </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-content').html(body);};return callback;}/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/function dragDropPieces(config){var next=config.next,validatePieces=config.validatePieces?config.validatePieces:[],pieceLimit=config.pieceLimit;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true);};var onSnapEnd=function onSnapEnd(source,target,piece){if(config.resultFen===__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen()){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}};var chessConfig={config:{draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,onSnapEnd:onSnapEnd,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson10Assignment2
* @function
* @param {config}
* @description: chess board related task
*/function lesson10Assignment2(config){var next=config.next,moveCount=0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onSnapbackEnd=function onSnapbackEnd(piece,square,position,orientation){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+config.startChance);};var onSnapEnd=function onSnapEnd(source,target,piece){};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(piece.search("K")===-1&&piece.search("R")===-1){return'snapback';}if(piece.search("R")!==-1&&target===config.rookTarget){// continue
}else if(piece.search("R")!==-1&&move===null){return'snapback';}if(piece.search("K")!==-1&&target===config.kingTarget){// continue
}else if(piece.search("K")!==-1&&move===null){return'snapback';}moveCount=moveCount+1;if(moveCount===2){if(window.ChessBoard.objToFen(newPos)!==config.finalPosition){moveCount=0;__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);return'snapback';}else{moveCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}}};var chessConfig={config:{position:config.position,onDrop:onDrop,onSnapEnd:onSnapEnd,onSnapbackEnd:onSnapbackEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson10Assignment3
* @function
* @param {config}
* @description: chess board related task
*/function lesson10Assignment3(config){var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.finalPosition);};var chessConfig={config:{position:config.position,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonActivities__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_11/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_11/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__commonActivities__["a" /* highlightCoordinates */])({showIndicators:{allSides:true},coordinates:['.square-b2','.square-d5','.square-f6','.square-a8'],coordinateClass:'filled-square',position:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',reminder:true,bubbleConfig:{data:'Good job!',position:'left'},next:2})},directions:{data:'<b>DIRECTIONS:</b><br/>For quick practice, click on b2, d5, f6, and a8.'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_11/2.mp4',autoStartNext:true,next:3}},{id:3,previous:2,next:4,text:{data:'Make the moves according to the Notation sheet <br/>on the right.<br/>You are playing White.',styleClass:'xxl'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["e" /* notationTable */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',resultFen:'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],moves:{studentMove:{from:['d2','c2','b1','c1','e2'],to:['d4','c4','c3','g5','e3']},computerMove:{from:['d7','e7','g8','f8'],to:['d5','e6','f6','e7']}},assignmentClass:'custom-sparepiece',next:4}),positionFen:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w - - 0 1'},directions:{data:'<table style="width:100%;">\n                    <colgroup>\n                        <col />\n                        <col />\n                        <col style="background-color:#D3D3D3;"/>\n                    </colgroup>\n                    <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>\n                    <tbody>\n                        <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>\n                        <tr><td style="padding:10px;">1</td><td>d2-d4</td><td>d7-d5</td></tr>\n                        <tr><td style="padding:10px;">2</td><td>c2-c4</td><td>e7-e6</td></tr>\n                        <tr><td style="padding:10px;">3</td><td>Nb1-c3</td><td>Ng8-f6</td></tr>\n                        <tr><td style="padding:10px;">4</td><td>Bc1-g5</td><td>Bf8-e7</td></tr>\n                        <tr><td style="padding:10px;">5</td><td>e2-e3</td><td>0-0</td></tr>\n                    </tbody>\n            </table>'}},{id:4,previous:2,next:7,video:{src:'img/videos/lesson_11/3.mp4',autoStartNext:true,next:5}},{id:5,previous:4,next:7,text:{data:'Make the moves according to the Notation sheet <br/>on the right.<br/>You are playing Black.',styleClass:'xxl'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["e" /* notationTable */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',resultFen:'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],firstMove:'black',blackCastle:6,moves:{studentMove:{from:['e7','b8','f8','g8'],to:['e5','c6','c5','f6']},computerMove:{from:['e2','g1','f1','c2','d2'],to:['e4','f3','c4','c3','d3']}},assignmentClass:'custom-sparepiece',next:6}),positionFen:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w - - 0 1'},directions:{data:'<table style="width:100%;">\n            <colgroup>\n                <col />\n                <col />\n                <col style="background-color:#D3D3D3;"/>\n            </colgroup>\n            <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>\n            <tbody>\n                <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>\n                <tr><td style="padding:10px;">1</td><td>e2-e4</td><td>e7-e5</td></tr>\n                <tr><td style="padding:10px;">2</td><td>Ng1-f3</td><td>Nb8-c6</td></tr>\n                <tr><td style="padding:10px;">3</td><td>Bf1-c4</td><td>Bf8-c5</td></tr>\n                <tr><td style="padding:10px;">4</td><td>c2-c3</td><td>Ng8-f6</td></tr>\n                <tr><td style="padding:10px;">5</td><td>d2-d3</td><td>0-0</td></tr>\n            </tbody>\n    </table>'}},{id:6,previous:4,next:7,text:{data:'Do a King\'s side castle.',timeout:4000,position:'left',styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* activity3StudentMoveCastle */])({showIndicators:{allSides:true},position:'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R',finalPosition:'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R',assignmentClass:'custom-sparepiece',next:7,startChance:'b KQkq - 0 1',kingTarget:'g8',rookTarget:'f8',source:'e8',target:'g8'}),positionFen:'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R b KQkq - 0 1'},directions:{data:'<table style="width:100%;">\n            <colgroup>\n                <col />\n                <col />\n                <col style="background-color:#D3D3D3;"/>\n            </colgroup>\n            <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>\n            <tbody>\n                <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>\n                <tr><td style="padding:10px;">1</td><td>e2-e4</td><td>e7-e5</td></tr>\n                <tr><td style="padding:10px;">2</td><td>Ng1-f3</td><td>Nb8-c6</td></tr>\n                <tr><td style="padding:10px;">3</td><td>Bf1-c4</td><td>Bf8-c5</td></tr>\n                <tr><td style="padding:10px;">4</td><td>c2-c3</td><td>Ng8-f6</td></tr>\n                <tr><td style="padding:10px;">5</td><td>d2-d3</td><td>0-0</td></tr>\n            </tbody>\n    </table>'}},{id:7,previous:4,next:16,video:{src:'img/videos/lesson_11/4.mp4',autoStartNext:true,next:8}},{id:8,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:0,answer:['PE4','e2-e4','d4'],validateCounter:true,count:0,rightAnswer:'e2-e4',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>e2-e4</b>',styleClass:'lg'},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',finalPosition:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',from:'e2',to:'e4',next:9})}},{id:9,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:1,answer:['e2-e4','e4-e5','e7-e5'],validateCounter:true,count:0,rightAnswer:'e7-e5',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>e7-e5</b>',styleClass:'lg'},validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',finalPosition:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',from:'e7',to:'e5',next:10})}},{id:10,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:2,answer:['K-f3','Ng1-f3','f3-e4'],validateCounter:true,count:0,rightAnswer:'Ng1-f3',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>Ng1-f3</b>',styleClass:'lg'},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',finalPosition:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',from:'g1',to:'f3',next:11})}},{id:11,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:3,answer:['Nb8-c6','Kt-qb6','C6-B8'],validateCounter:true,count:0,rightAnswer:'Nb8-c6',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>Nb8-c6</b>',styleClass:'lg'},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',finalPosition:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',from:'b8',to:'c6',next:12})}},{id:12,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:4,answer:['bb6','Bf1-b5','Nf3-Bb5'],validateCounter:true,count:0,rightAnswer:'Bf1-b5',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>Bf1-b5</b>',styleClass:'lg'},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',finalPosition:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',from:'f1',to:'b5',next:13})}},{id:13,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:5,answer:['A6C6','a7-a6','A6-B5'],validateCounter:true,count:0,rightAnswer:'a7-a6',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>a7-a6</b>',styleClass:'lg'},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',finalPosition:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',from:'a7',to:'a6',next:14})}},{id:14,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:6,answer:['XBN','c6b5x','Bb5xc6'],validateCounter:true,count:0,rightAnswer:'Bb5xc6',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>Bb5xc6</b>',styleClass:'lg'},validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',finalPosition:'r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',assignmentClass:'custom-sparepiece',from:"b5",to:"c6",capture:{capturingPiece:'wB',capturedPiece:'bN'},next:15})}},{id:15,previous:7,next:16,directions:{data:'<b>DIRECTIONS</b><br/>Select the correct notation for the move',timeout:0,className:'no-animation'},options:{id:7,answer:['Pdx6c','d7xc6','PXP'],validateCounter:true,count:0,rightAnswer:'d7xc6',magnusWrongAnswer:{data:'Oops!, The notation looks like this --> <b>d7xc6</b>',styleClass:'lg'},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* activity4ComputerMove */])({showIndicators:{allSides:true},position:'r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',finalPosition:'r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',assignmentClass:'custom-sparepiece',from:'d7',to:'c6',capture:{capturingPiece:'bP',capturedPiece:'wB'},next:16})}},{id:16,previous:7,next:17,video:{src:'img/videos/lesson_11/5.mp4',autoStartNext:true,next:17}},{id:17,previous:16,next:18,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:"What part of chess notation uses capital letters?",answer:['The captures','The squares','The pieces','Checkmate'],rightAnswer:'The pieces',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:18,previous:16,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:"When you are playing as Black, where do your moves get recorded?",answer:['On the right','On the left','On the top','On the bottom'],rightAnswer:'On the right',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'},directions:{data:'<table style="width: 100%;">\n                <colgroup>\n                <col />\n                <col />\n                <col />\n                </colgroup>\n                <thead><tr><th colspan=3>Notation Sheet</th></tr></thead>\n                <tbody><tr><th style="width: 33%;">Moves</th><th></th><th></th></tr>\n                    <tr><td>1</td><td></td><td></td></tr>\n                    <tr><td>2</td><td></td><td></td></tr>\n                    <tr><td>3</td><td></td><td></td></tr>\n                    <tr><td>4</td><td></td><td></td></tr>\n                    <tr><td>5</td><td></td><td></td></tr></tbody>\n            </table>'}},{id:19,previous:16,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:"What is the Knight's symbol?",answer:['K','@','#','N'],rightAnswer:'N',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:20,previous:16,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:"Why is it a good idea to record your game?",answer:['You can review your game later','It helps you become a better player','Most tournaments require it','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:21,previous:16,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:"What does <b>Nf3xe5</b> mean?",answer:['Notation starts on f3','The Knight on f3 is capturing the piece on e5','The Knight on f3 has the e5 King in check','Three times five is fifteen Knights'],rightAnswer:'The Knight on f3 is capturing the piece on e5',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:22,previous:16,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:"How would you record White’s last move?",answer:['f6-g7','f6xg7','f6xg7+','f6xg7#'],rightAnswer:'f6xg7#',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson11QA6 */])({showIndicators:true,position:'2R3qk/1p4p1/p4P1K/P2p4/3P4/8/8/2R5',finalPosition:'2R3qk/1p4P1/p6K/P2p4/3P4/8/8/2R5',assignmentClass:'custom-sparepiece',from:"f6",to:"g7",capture:{capturingPiece:'wP',capturedPiece:'bP'}}),hint:true}}},{id:23,previous:16,next:24,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:"Which of these moves is the correct way to record a checkmate?",answer:['Qd1-d8x','Qd1-d8+','Qd1-d8#','Qd1-d8$'],rightAnswer:'Qd1-d8#',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:24,previous:16,next:25,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:"Which of these is the correct way to record Black’s move ?",answer:['Ke8-c8','0-0','Ra8-d8','0-0-0'],rightAnswer:'0-0-0',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson11QA8 */])({showIndicators:true,position:'r3kbnr/ppqn1pp1/2p1p2p/7P/2PP4/3Q1NN1/PP1B1PP1/R3K2R',finalPosition:'2kr1bnr/ppqn1pp1/2p1p2p/7P/2PP4/3Q1NN1/PP1B1PP1/R3K2R'}),hint:true}}},{id:25,previous:16,next:26,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:"The White and Black Kings both start on…",answer:['The 1st rank, e1 and d1','The d-file, d1 and d8 Kings are dangerous','The e-file e1 and e8 Kings oversee Everything','Their own colored square, just like the Queens'],rightAnswer:'The e-file e1 and e8 Kings oversee Everything',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xl'}},{id:26,previous:16,next:27,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:"Using chess notation is a good idea because:",answer:['You can review your game later to improve your play','Writing down the moves helps you to focus','If you decide to play in tournaments it is required','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg'}},{id:27,previous:16,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Twelve',styleClass:'xl'}}];var assets=['/img/background_10.png','/img/background_11.png','/img/background_12.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = notationTable;
/* harmony export (immutable) */ __webpack_exports__["a"] = activity3StudentMoveCastle;
/* harmony export (immutable) */ __webpack_exports__["b"] = activity4ComputerMove;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson11QA6;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson11QA8;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
var tableValues=[];/**
 * @name notationTable
 * @function
 * @param { config }
 * @description Student makes move according to Notation Table.
 */function notationTable(config){var next=config.next,moveSpeed=1000,initialBoardPosition=config.position,moves=config.moves,totalStudentMoves=config.moves.studentMove.from.length,totalComputerMoves=config.moves.computerMove.from.length,studentFromCount=0,studentToCount=0,computerFromCount=0,computerToCount=0,board=void 0,timer=void 0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').css('width','100%');});if(config.firstMove){computerMove();}};var onDragStart=function onDragStart(source,piece,position,orientation){board=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){studentFromCount=0;studentToCount=0;clearTimeout(timer);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){studentFromCount=0;studentToCount=0;clearTimeout(timer);});if(studentFromCount<totalStudentMoves&&studentToCount<totalStudentMoves){if(source===moves.studentMove.from[studentFromCount]&&target===moves.studentMove.to[studentToCount]){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');studentFromCount++;studentToCount++;computerMove();}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s not the right move',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(board);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(board+config.initialMoveOf);}}};function computerMove(){if(computerFromCount<totalComputerMoves&&computerToCount<totalComputerMoves){timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(moves.computerMove.from[computerFromCount]+'-'+moves.computerMove.to[computerToCount]);computerFromCount++;computerToCount++;},2000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){computerFromCount=0;computerToCount=0;clearTimeout(timer);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){computerFromCount=0;computerToCount=0;clearTimeout(timer);});}if(!moves.computerMove.from[computerFromCount]){setTimeout(function(){studentFromCount=studentToCount=computerFromCount=computerToCount===0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job!',position:'left'});__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.resultFen);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);},2000);}else if(!moves.studentMove.from[studentFromCount]){setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(1000,config.blackCastle,false);},2000);}else{var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+config.initialMoveOf);}}var chessConfig={config:{position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name activity3StudentMoveCastle
* @function
* @param {config}
* @description: Student doing a Castle
*/function activity3StudentMoveCastle(config){var next=config.next,moveCount=0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').css('width','100%');});};var onSnapEnd=function onSnapEnd(piece,square,position,orientation){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+config.startChance);};var onSnapbackEnd=function onSnapbackEnd(source,target,piece){};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(piece.search("K")===-1&&piece.search("R")===-1){return'snapback';}if(piece.search("R")!==-1&&target===config.rookTarget){// continue
}else if(piece.search("R")!==-1&&move===null){return'snapback';}if(piece.search("K")!==-1&&target===config.kingTarget){// continue
}else if(piece.search("K")!==-1&&move===null){return'snapback';}moveCount=moveCount+1;if(moveCount===2){if(window.ChessBoard.objToFen(newPos)!==config.finalPosition){moveCount=0;__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);return'snapback';}else{moveCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job!',position:'left'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);}}};var chessConfig={config:{position:config.position,onDrop:onDrop,onSnapEnd:onSnapEnd,onSnapbackEnd:onSnapbackEnd,draggable:true,sparePieces:true},afterLoad:afterLoad};return chessConfig;}/**
 * @name activity4ComputerMove
 * @function
 * @param { config }
 * @description: Student need to click on correct move.
 */function activity4ComputerMove(config){var moveSpeed=1000,from=config.from,to=config.to,position=config.position,body='<button id="repeat-btn" type="button">Repeat Move</button>';var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){tableValues.length=0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).unbind('get-value');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){tableValues.length=0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).unbind('get-value');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').css('pointer-events','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('table-show',[tableValues]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#repeat-btn').length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.options').append(body);}if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#repeat-btn').length>=2){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#repeat-btn').remove();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).bind('get-value',update);});function update(e,value,flag){tableValues.push(value);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).unbind('get-value');if(tableValues.length===8&&flag){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job!',position:'left'});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,config.next,true);},1000);}else if(!flag){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(5000,config.next,false);}else if(flag){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(1000,config.next,false);}}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(from+"-"+to);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#repeat-btn').click(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(position);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(from+"-"+to);if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move,false);},moveSpeed);}},2000);});if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move,false);},moveSpeed);}},1000);};var chessConfig={config:{position:config.position,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson11QA6
 * @function
 * @param { config }
 * @description: Question 6s Computer Move
 */function lesson11QA6(config){var moveSpeed=1000,initialBoardPosition=config.position,timer=void 0,repeatTimer=void 0,body='<button class="repeat-btn-qa" type="button">Repeat Move</button>';var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append(body);}if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').length>=2){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-top-4028b').addClass('custom-margin');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.custom-margin').css('margin-left','6px').css('margin-top','13px');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').css('opacity','0');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();},4000);});});repeatTimer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').click(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move,false);},moveSpeed);}},2000);});},3000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();});timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').css('cursor','pointer');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move,false);},moveSpeed);}},3000);};var chessConfig={config:{position:initialBoardPosition,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson11QA8
 * @function
 * @param {config}
 * @description: Computer does a castle
 */function lesson11QA8(config){var body='<button class="repeat-btn-qa" type="button">Repeat Move</button>';var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append(body);}if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').length>=2){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').css('opacity','0');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();},4000);});});var repeatTimer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').click(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.finalPosition);},2000);});},3000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').remove();});var timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.repeat-btn-qa').css('cursor','pointer');__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.finalPosition);},3000);};var chessConfig={config:{position:config.position,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
var lessonConfig=[{id:0,previous:null,next:18,video:{src:'img/videos/lesson_12/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:18,audio:{src:'img/audio/lesson_12/1.mp3',start:true,controls:false},directions:{timeout:8000,data:'<b>DIRECTIONS:</b> </br>Move the Black Rook so that he is checking the White King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/5k1r/6r1/2K5/8/8/8/8',final:'8/5k2/6r1/2K4r/8/8/8/8',next:2,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],wrongMessage:'Oops! <br/> That Rook was building a wall.'}),positionFen:'8/5k1r/6r1/2K5/8/8/8/8 b - - 0 1'}},{id:2,previous:0,next:18,video:{src:'img/videos/lesson_12/activty1_1.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:0,next:18,audio:{src:'img/audio/lesson_12/Activty1_1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/6r1/2K4r/8/8/8/8',final:'8/5k2/6r1/7r/3K4/8/8/8',assignmentClass:'custom-sparepiece',from:'c5',to:'d4',next:4,computerMoveIn:16000})}},{id:4,previous:0,next:18,directions:{data:'<b>DIRECTIONS:</b> </br>Click on the Rook who isn\'t doing <br/> anything and move him to check the King',position:'left',styleClass:'xxl',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/5k2/6r1/7r/3K4/8/8/8',final:'8/5k2/8/7r/3K2r1/8/8/8',next:5,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],wrongMessage:'oops, <br/> that won’t check the King',otherRookMovementMessage:'That Rook was busy building a wall.<br/> Move the other Rook'}),positionFen:'8/5k2/6r1/7r/3K4/8/8/8 b - - 0 1'}},{id:5,previous:0,next:18,audio:{src:'img/audio/lesson_12/7.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/7r/3K2r1/8/8/8',final:'8/5k2/8/7r/6r1/4K3/8/8',assignmentClass:'custom-sparepiece',from:'d4',to:'e3',next:6,computerMoveIn:5000})}},{id:6,previous:0,next:18,video:{src:'img/videos/lesson_12/activity1_2.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:0,next:18,directions:{data:'<b>DIRECTIONS:</b> </br>Click on the Rook who isn’t doing <br/> anything and move him to check the King.',styleClass:'md'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/5k2/8/7r/6r1/4K3/8/8',final:'8/5k2/8/8/6r1/4K2r/8/8',next:8,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],wrongMessage:'oops, <br/> that won’t check the King',otherRookMovementMessage:'oops <br/> That wont check the king'}),positionFen:'8/5k2/8/7r/6r1/4K3/8/8 b - - 0 1'}},{id:8,previous:0,next:18,audio:{src:'img/audio/lesson_12/7.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/6r1/4K2r/8/8',final:'8/5k2/8/8/6r1/7r/5K2/8',assignmentClass:'custom-sparepiece',from:'e3',to:'f2',next:9,computerMoveIn:5000})}},{id:9,previous:0,next:18,audio:{src:'img/audio/lesson_12/activity1_5.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/6r1/7r/5K2/8',final:'8/5k2/8/8/r7/7r/5K2/8',assignmentClass:'custom-sparepiece',from:'g4',to:'a4',next:10,prefilledCoordinates:['.square-g2'],filledSquareTimeOut:1000,computerMoveIn:12000})}},{id:10,previous:0,next:18,audio:{src:'img/audio/lesson_12/activity1_3.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/r7/7r/5K2/8',final:'8/5k2/8/8/r7/7r/6K1/8',assignmentClass:'custom-sparepiece',from:'f2',to:'g2',next:11,computerMoveIn:5000})}},{id:11,previous:0,next:18,video:{src:'img/videos/lesson_12/activity1_3.mp4',startTime:0,autoStartNext:true,next:12}},{id:12,previous:0,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/r7/7r/6K1/8',final:'8/5k2/8/8/r7/1r6/6K1/8',assignmentClass:'custom-sparepiece',from:'h3',to:'b3',next:13,computerMoveIn:2000})}},{id:13,previous:0,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/r7/1r6/6K1/8',final:'8/5k2/8/8/r7/1r6/5K2/8',assignmentClass:'custom-sparepiece',from:'g2',to:'f2',next:14,computerMoveIn:3000})}},{id:14,previous:0,next:18,audio:{src:'img/audio/lesson_12/activity1_4.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/r7/1r6/5K2/8',final:'8/5k2/8/8/8/1r6/r4K2/8',assignmentClass:'custom-sparepiece',from:'a4',to:'a2',next:15,prefilledCoordinates:['.square-a4','.square-b3'],filledSquareTimeOut:200,newFilledSquares:true,fromCanvas:'square-a2',toCanvas:'square-b3',offset:[5,5,5,2],computerMoveIn:8000}),canvas:true}},{id:15,previous:0,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/5k2/8/8/8/1r6/r4K2/8',final:'8/5k2/8/8/8/1r6/r7/4K3',assignmentClass:'custom-sparepiece',from:'f2',to:'e1',next:16,computerMoveIn:5000})}},{id:16,previous:0,next:18,video:{src:'img/videos/lesson_12/activity1_4.mp4',startTime:0,autoStartNext:true,next:17}},{id:17,previous:0,next:18,directions:{data:'<b>DIRECTIONS:</b> <br/>Now choose the Rook that is not building the  wall, and finally checkmate the  King!',styleClass:'xl'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/5k2/8/8/8/1r6/r7/4K3',final:'8/5k2/8/8/8/8/r7/1r2K3',next:18,showIndicators:{allSides:true},MagnusText:'LadderMate',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],filledSquareTimeOut:1000,wrongMessage:'Oops! That’s the wrong Rook for checkmate.',magnusPopUp:true}),positionFen:'8/5k2/8/8/8/1r6/r7/4K3 b - - 0 1'}},{id:18,previous:0,next:32,video:{src:'img/videos/lesson_12/3.mp4',startTime:0,autoStartNext:true,next:19}},{id:19,previous:18,next:32,audio:{src:'img/audio/lesson_12/10.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b> <br/>Alternate the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/8/8/8/1k6/6R1/5K1R/8',final:'8/8/8/8/1k5R/6R1/5K2/8',next:20,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'8/8/8/8/1k6/6R1/5K1R/8 w - - 0 1'}},{id:20,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/8/8/8/1k5R/6R1/5K2/8',final:'8/8/8/2k5/7R/6R1/5K2/8',assignmentClass:'custom-sparepiece',from:'b4',to:'c5',next:21})}},{id:21,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/8/8/2k5/7R/6R1/5K2/8',final:'8/8/8/2k3R1/7R/8/5K2/8',next:22,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'8/8/8/2k5/7R/6R1/5K2/8 w - - 0 1'}},{id:22,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/8/8/2k3R1/7R/8/5K2/8',final:'8/8/3k4/6R1/7R/8/5K2/8',assignmentClass:'custom-sparepiece',from:'c5',to:'d6',next:23})}},{id:23,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/8/3k4/6R1/7R/8/5K2/8',final:'8/8/3k3R/6R1/8/8/5K2/8',next:24,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'8/8/3k4/6R1/7R/8/5K2/8 w - - 0 1'}},{id:24,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/8/3k3R/6R1/8/8/5K2/8',final:'8/4k3/7R/6R1/8/8/5K2/8',assignmentClass:'custom-sparepiece',from:'d6',to:'e7',next:25})}},{id:25,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'8/4k3/7R/6R1/8/8/5K2/8',final:'8/4k1R1/7R/8/8/8/5K2/8',next:26,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'8/4k3/7R/6R1/8/8/5K2/8 w - - 0 1'}},{id:26,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'8/4k1R1/7R/8/8/8/5K2/8',final:'5k2/6R1/7R/8/8/8/5K2/8',assignmentClass:'custom-sparepiece',from:'e7',to:'f8',next:27})}},{id:27,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'5k2/6R1/7R/8/8/8/5K2/8',final:'5k2/R7/7R/8/8/8/5K2/8',next:28,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'5k2/6R1/7R/8/8/8/5K2/8 w - - 0 1'}},{id:28,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'5k2/R7/7R/8/8/8/5K2/8',final:'6k1/R7/7R/8/8/8/5K2/8',assignmentClass:'custom-sparepiece',from:'f8',to:'g8',next:29})}},{id:29,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'6k1/R7/7R/8/8/8/5K2/8',final:'6k1/R7/1R6/8/8/8/5K2/8',next:30,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.'}),positionFen:'6k1/R7/7R/8/8/8/5K2/8 w - - 0 1'}},{id:30,previous:18,next:32,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({showIndicators:{allSides:true},position:'6k1/R7/1R6/8/8/8/5K2/8',final:'5k2/R7/1R6/8/8/8/5K2/8',assignmentClass:'custom-sparepiece',from:'g8',to:'f8',next:31})}},{id:31,previous:18,next:32,directions:{data:'<b>DIRECTIONS:</b> <br/>Move the Rooks so they are both busy building walls, and one checks the King.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson12Assignment */])({position:'5k2/R7/1R6/8/8/8/5K2/8',final:'1R3k2/R7/8/8/8/8/5K2/8',next:32,showIndicators:{allSides:true},timeout:5000,MagnusText:'Ladder Mate',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],wrongMessage:'oops!That\'s not the correct move.',magnusPopUp:true}),positionFen:'5k2/R7/1R6/8/8/8/5K2/8 w - - 0 1'}},{id:32,previous:18,next:33,video:{src:'img/videos/lesson_12/4.mp4',startTime:0,autoStartNext:true,next:33}},{id:33,previous:32,next:34,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Which are your “wall building” pieces?',answer:['Bishops and Rooks','Rooks and Queens','Knights and Bishops','Queens and Knights'],rightAnswer:'Rooks and Queens',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:34,previous:32,next:35,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'Where can your Queen or Rooks build a wall?',answer:['On a file and a rank','Only on a file','Only on a rank','Only on the diagonal'],rightAnswer:'On a file and a rank',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xl'}},{id:35,previous:32,next:36,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Which pieces can be used in a ladder mate?',answer:['A Rook and a Knight','A Bishop and a Knight','Two Bishops','Two Rooks'],rightAnswer:'Two Rooks',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:36,previous:32,next:37,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'When creating a ladder mate you should...',answer:['Play as quickly as possible','Only move one Rook','Be patient and move slowly','Move both Rooks at the same time'],rightAnswer:'Be patient and move slowly',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xl'}},{id:37,previous:32,next:38,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'The White King just moved to f2. What should Black do next?',answer:['Move to g2 for check','Move to h2 for check','Move to a4','Offer a draw'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/5k2/8/8/6r1/7r/5K2/8'}),hint:true,canvas:{from:'square-e3',to:'square-f2'}},rightAnswer:'Move to a4',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:38,previous:32,next:39,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'The White King has just moved to b1. Which move will checkmate the White King?',answer:['Rb2#','Kb2#','Rg1#','Rd2#'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/8/8/1k6/6r1/1K6'}),hint:true,canvas:{from:'square-a1',to:'square-b1'}},rightAnswer:'Rg1#',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:39,previous:32,next:40,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'How many moves will it take for White to checkmate Black?',answer:['1','2','3','4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/7k/1R6/R7/7K/8/8/8'}),hint:true},rightAnswer:'2',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'sm'}},{id:40,previous:32,next:41,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'When creating a Ladder Mate with two Rooks, the Rooks should…',answer:['Stay on the same file a-h','Stay on the same color','Stay on the same rank 1-8','Stay on opposite colors'],rightAnswer:'Stay on the same color',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:41,previous:32,next:42,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'One of the rules of ladder mate is…',answer:['Move away if the King bothers you','Keep your Queen a square away','Light on the right','Stay on opposite colors'],rightAnswer:'Move away if the King bothers you',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xxl'}},{id:42,previous:32,next:43,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:' In ladder mate, one of your Rooks builds a wall while the other Rook...',answer:['Builds a second wall','Protects your King','Sneaks past the opposing King','Checks the opposing King'],rightAnswer:'Checks the opposing King',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:43,previous:32,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson 13',styleClass:'xl',timeout:7000}}];// ToDo: Add lesson 11 and lesson 13 images for preloading
var assets=['/img/background_12.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson12Assignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(2);
/**
* @name lesson12Assignment
* @function
* @param {config}
* @description: activity related task
*/function lesson12Assignment(config){var moveSpeed=1000,next=config.next,coordinates=config.prefilledCoordinates,computerTime=config.computerMoveIn,nextComputerMoveIn=computerTime?computerTime:2000,//nextStudentMoveIn = config.studentTime ? config.studentTime : 2000, 
newFilledSquares=config.newFilledSquares?true:false,magnusPopUp=config.magnusPopUp?true:false,offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];}var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);if(config.prefilledCoordinates){setTimeout(function(){coordinates.forEach(function(element){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(element).addClass('filled-yellow-square');});},config.filledSquareTimeOut);}if(config.from&&config.to){setTimeout(function(){if(newFilledSquares){coordinates.forEach(function(element){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(element).removeClass('filled-yellow-square');});}__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);},1000);setTimeout(function(){if(newFilledSquares){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById('myCanvas');var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* plotArrow */])(ctx,config.fromCanvas,config.toCanvas,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,'#FFA500');}},3500);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(nextComputerMoveIn,next,false);}};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.fen();if(boardFen===config.final){if(magnusPopUp){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:config.MagnusText+' '+__WEBPACK_IMPORTED_MODULE_3__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'sm'});}Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(2000,next,true);}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_4__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);if(source==='h5'&&target==='h4'){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:config.otherRookMovementMessage,styleClass:'md',position:'left'});}else{Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:config.wrongMessage,position:'left',styleClass:'sm'});}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Move the piece to the correct position.',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+config.initialMove);return'snapback';},3000);}};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_13/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_13/1.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>He only has 5 more squares to visit! Finish his tour with c3 as your LAST square.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson13Activity2 */])({showIndicators:{allSides:true},position:'8/8/8/8/n7/8/8/8',assignmentClass:'custom-sparepiece',next:2}),positionFen:'8/8/8/8/n7/8/8/8 b - - 0 1'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_13/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_13/2.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>Move the Knight to all the squares on the board.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson13Activity1 */])({showIndicators:{allSides:true},position:'8/8/8/8/8/8/8/N7',assignmentClass:'custom-sparepiece',next:4}),positionFen:'8/8/8/8/8/8/8/N7 w - - 0 1'}},{id:4,previous:2,next:7,video:{src:'img/videos/lesson_13/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:7,audio:{src:'img/audio/lesson_13/3.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>Select a piece and make a move to checkmate the Black king.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson13Activity3 */])({showIndicators:{allSides:true},position:'rr5k/4N1pp/p4p2/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4',resultFen:'rr5k/6pp/p4pN1/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],move:'e7-g6',from:'e7',to:'g6',next:6}),positionFen:'rr5k/4N1pp/p4p2/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4 w - - 0 1'}},{id:6,previous:4,next:7,audio:{src:'img/audio/lesson_13/4.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>Select a piece and make a move to checkmate the White king.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson13Activity3 */])({showIndicators:{allSides:true},position:'6k1/1p3p2/p4Rnp/6p1/2nP2b1/1NP3P1/PP3RKP/4r3',resultFen:'6k1/1p3p2/p4Rnp/6p1/3P2b1/1NP1n1P1/PP3RKP/4r3',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],move:'c4-e3',from:'c4',to:'e3',next:7}),positionFen:'6k1/1p3p2/p4Rnp/6p1/2nP2b1/1NP3P1/PP3RKP/4r3 b - - 0 1'}},{id:7,previous:4,next:8,video:{src:'img/videos/lesson_13/4.mp4',startTime:0,autoStartNext:true,next:8}},{id:8,previous:7,next:9,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'What is the Knight\'s Tour?',answer:['A video game about the middle ages','When Knights give castle tours','A very old chess puzzle','A way to describe a busy Knight'],rightAnswer:'A very old chess puzzle',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg'}},{id:9,previous:7,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'What is the goal of the Knight\'s Tour?',answer:['To get to your opponent\'s side of the board','To land on every square on the board','To jump over every piece on the board','For a Knight in the middle ages to travel to another country'],rightAnswer:'To land on every square on the board',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:10,previous:7,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'In a Closed Knight’s Tour...',answer:['The Knight begins and ends on the same square','The Knight starts on a1 and ends on h8','The Knight begins and ends on a different square','No one is allowed to watch because it is a private event'],rightAnswer:'The Knight begins and ends on the same square',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xl'}},{id:11,previous:7,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'In an Open Knight\'s Tour...',answer:['The Knight begins and ends on the same square','The Knight starts on a1 and ends on h8','The Knight begins and ends on a different square','Everyone is allowed to watch because it is a public event'],rightAnswer:'The Knight begins and ends on a different square',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xl'}},{id:12,previous:7,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'The Knight is a unique chess piece because...',answer:['He is the only chess piece that can travel across the board in one move','He is the only piece that can capture the King','He is the only piece that can move two times in a row','He is the only piece (other than a pawn) that can start a chess game'],rightAnswer:'He is the only piece (other than a pawn) that can start a chess game',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:13,previous:7,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'The Knight can play well on a crowded board because...',answer:['He doesn’t need much space','He can jump into open areas','He only moves one square at a time','He can stick to the edges away from other pieces'],rightAnswer:'He can jump into open areas',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:14,previous:7,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'How many squares could a Knight reach from the middle of a completely open board?',answer:['4','8','12','16'],rightAnswer:'8',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:15,previous:7,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What is White\'s best move?',answer:['Nxb8','Nc5','Nc7','Nb4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'kn6/8/NK6/8/6p1/6P1/8/8'}),hint:true},rightAnswer:'Nc7',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:16,previous:7,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'What is Black\'s best move?',answer:['Na6','Nc6','Nd7','b5'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'kn6/8/1K6/2N5/6p1/6P1/8/8'}),hint:true},rightAnswer:'Nd7',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:17,previous:7,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'How many possible Knight moves or captures does White have?',highlightSquares:true,answer:['4','6','8','10'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson13QA */])({showIndicators:true,position:'r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',squares:['.square-b1','.square-a4','.square-b5','.square-d5','.square-e2','.square-d4','.square-e5','.square-g5','.square-h4','.square-g1']}),hint:true},rightAnswer:'10',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:18,previous:7,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Fourteen',styleClass:'xl'}}];var assets=['/img/background_12.png','/img/background_13.png','/img/background_14.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson13Activity1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson13Activity2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson13Activity3;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson13QA;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chessBoard__ = __webpack_require__(3);
/**
* @name lesson13Assignment1
* @function
* @param {config}
* @description: activity related task
*/function lesson13Activity1(config){var position=config.position,next=config.next,count=2,allCoordinates=new Set();var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').addClass('custom-background-image-5x5');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+3)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display','none');});};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-'+source).prepend('<img class="star-icon" src="/img/star.png" />');var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(allCoordinates.has(target)){--count;if(count<1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Don\'t worry, it\'s tough.',position:'left',styleClass:'md'});count=2;allCoordinates.clear();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,false);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops! Try again. You have '+count+' more try!',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.star-icon').remove();allCoordinates.clear();__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},2000);}}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);allCoordinates.add(source);if(allCoordinates.size>=24){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Wow! You did it.',position:'left',styleClass:'xs'});count=2;allCoordinates.clear();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,config.next,true);}else{var msg='Looks like you are stuck! Try again.';if(target==='a5'&&allCoordinates.has('b3')&&allCoordinates.has('c4')){}else if(target==='e5'&&allCoordinates.has('c4')&&allCoordinates.has('d3')){}else if(target==='e1'&&allCoordinates.has('c2')&&allCoordinates.has('d3')){}else if(target==='a4'&&allCoordinates.has('b2')&&allCoordinates.has('c3')&&allCoordinates.has('c5')){}else if(target==='e4'&&allCoordinates.has('d2')&&allCoordinates.has('c3')&&allCoordinates.has('c5')){}else if(target==='a3'&&allCoordinates.has('b1')&&allCoordinates.has('b5')&&allCoordinates.has('c2')&&allCoordinates.has('c4')){}else if(target==='e3'&&allCoordinates.has('c2')&&allCoordinates.has('c4')&&allCoordinates.has('d1')&&allCoordinates.has('d5')){}else if(target==='a2'&&allCoordinates.has('b4')&&allCoordinates.has('c1')&&allCoordinates.has('c3')){}else if(target==='e2'&&allCoordinates.has('c1')&&allCoordinates.has('c3')&&allCoordinates.has('d4')){}else if(target==='b5'&&allCoordinates.has('a3')&&allCoordinates.has('c3')&&allCoordinates.has('d4')){}else if(target==='d5'&&allCoordinates.has('b4')&&allCoordinates.has('c3')&&allCoordinates.has('e3')){}else if(target==='b4'&&allCoordinates.has('a2')&&allCoordinates.has('c2')&&allCoordinates.has('d3')&&allCoordinates.has('d5')){}else if(target==='d4'&&allCoordinates.has('b3')&&allCoordinates.has('b5')&&allCoordinates.has('c2')&&allCoordinates.has('e2')){}else if(target==='b3'&&allCoordinates.has('a5')&&allCoordinates.has('c1')&&allCoordinates.has('c5')&&allCoordinates.has('d2')&&allCoordinates.has('d4')){}else if(target==='d3'&&allCoordinates.has('b2')&&allCoordinates.has('b4')&&allCoordinates.has('c1')&&allCoordinates.has('c5')&&allCoordinates.has('e1')&&allCoordinates.has('e5')){}else if(target==='b2'&&allCoordinates.has('a4')&&allCoordinates.has('c4')&&allCoordinates.has('d1')&&allCoordinates.has('d3')){}else if(target==='d2'&&allCoordinates.has('b1')&&allCoordinates.has('b3')&&allCoordinates.has('c4')&&allCoordinates.has('e4')){}else if(target==='b1'&&allCoordinates.has('a3')&&allCoordinates.has('c3')&&allCoordinates.has('d2')){}else if(target==='d1'&&allCoordinates.has('b2')&&allCoordinates.has('c3')&&allCoordinates.has('e3')){}else if(target==='c5'&&allCoordinates.has('a4')&&allCoordinates.has('b3')&&allCoordinates.has('d3')&&allCoordinates.has('e4')){}else if(target==='c4'&&allCoordinates.has('a3')&&allCoordinates.has('a5')&&allCoordinates.has('b2')&&allCoordinates.has('d2')&&allCoordinates.has('e3')&&allCoordinates.has('e5')){}else if(target==='c3'&&allCoordinates.has('a2')&&allCoordinates.has('a4')&&allCoordinates.has('b1')&&allCoordinates.has('b5')&&allCoordinates.has('d1')&&allCoordinates.has('d5')&&allCoordinates.has('e2')&&allCoordinates.has('e4')){}else if(target==='c2'&&allCoordinates.has('a3')&&allCoordinates.has('b4')&&allCoordinates.has('d4')&&allCoordinates.has('e1')&&allCoordinates.has('e3')){}else if(target==='c1'&&allCoordinates.has('a2')&&allCoordinates.has('b3')&&allCoordinates.has('d3')&&allCoordinates.has('e2')){}else{msg='';}if(msg){--count;if(count<1){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s okay, it\'s harder than it looks.',position:'left',styleClass:'md'});count=2;allCoordinates.clear();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,false);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:msg+'You have '+count+' more try!',position:'left',styleClass:'lg'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.star-icon').remove();allCoordinates.clear();__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},4000);}}}}__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);};var chessConfig={config:{sparePieces:true,position:position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson13Activity2
 * @function
 * @param { config }
 * @description: Complete the Knight's tour
 */function lesson13Activity2(config){var position=config.position,next=config.next,boardFen=position,highlightCoordinates=new Set(['a1','a2','a3','a5','b2','b3','b4','b5','c1','c2','c4','d1','d3','d4','d5','e1','e2','e3','e5']);var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').addClass('custom-background-image-5x5');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+3)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display','none');highlightCoordinates.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-'+element).prepend('<img class="star-icon" src="/img/star.png" />');});});};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){if(source==='a4'&&target==='c5'||source==='c5'&&target==='e4'||source==='e4'&&target==='d2'||source==='d2'&&target==='b1'||source==='b1'&&target==='c3'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-'+source).prepend('<img class="star-icon" src="/img/star.png" />');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(boardFen==='8/8/8/8/8/2n5/8/8'){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Well done!',position:'left',styleClass:'xs'});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);},1000);}__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);}else if(source==='a4'&&target==='c3'||source==='e4'&&target==='c3'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'This move will not complete the Knight\'s tour on c3',position:'left',styleClass:'lg'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);},3000);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'This is not a legal move! You need to end the tour on c3.',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);},3000);}};var chessConfig={config:{sparePieces:true,draggable:true,position:position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson13Activity3
 * @function
 * @param { config }
 * @description: Knight does a checkmate
 */function lesson13Activity3(config){var position=config.position,next=config.next,finalPosition=config.resultFen,count=2,moveSpeed=1000;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();--count;if(boardFen===finalPosition){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job!',position:'left',styleClass:'xs'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,true);}else if(count>0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s not a checkmate!',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position+config.initialMoveOf);}else{__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'The correct move is <b>'+config.move+'</b>',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(config.from+'-'+config.to);},4000);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(7000,next,false);}};var chessConfig={config:{sparePieces:true,draggable:true,position:position,moveSpeed:moveSpeed,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson13Activity3
 * @function
 * @param { config }
 * @description: Knight does a checkmate
 */function lesson13QA(config){var squares=config.squares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.answer').click(function(){squares.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('border','1px solid red');});});});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
var lessonConfig=[{id:0,previous:null,next:7,video:{src:'img/videos/lesson_14/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:3,directions:{timeout:0,data:'Can you Capture en passant?',className:'no-animation'},options:{id:1,next:2,answer:['Yes','No'],rightAnswer:'Yes',magnusWrongAnswer:{data:'Oops...!!!<br/>The correct answer is YES.',styleClass:'sm',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson14Assignment1 */])({showIndicators:{allSides:true},position:'rnbqkb1r/ppp2ppp/8/3pP3/3Qn3/5N2/PPP2PPP/RNB1KB1R',assignmentClass:'custom-sparepiece',from:'square-d7',to:'square-d5',offset:[5,5,5,2],next:2}),canvas:true}},{id:2,previous:0,next:null,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson14Assignment1MovePieces */])({showIndicators:{allSides:true},position:'rnbqkb1r/ppp2ppp/8/3pP3/3Qn3/5N2/PPP2PPP/RNB1KB1R',finalPosition:'rnbqkb1r/ppp2ppp/3P4/8/3Qn3/5N2/PPP2PPP/RNB1KB1R',assignmentClass:'custom-sparepiece',from:'square-e5',to:'square-d6',offset:[5,5,5,4],capture:{capturingPiece:'wP',capturedPiece:'bp'},next:3}),canvas:true}},{id:3,previous:0,next:4,directions:{timeout:0,data:'Can you Capture en passant?',className:'no-animation'},options:{id:2,next:4,answer:['Yes','No'],rightAnswer:'No',magnusWrongAnswer:{data:'Oops! The correct answer is NO.</br>Only pawns moving two squares might </br> be involved in en passant captures.',styleClass:'xxxl',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson14Assignment1 */])({showIndicators:{allSides:true},position:'rnbqkbnr/ppp2ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR',assignmentClass:'custom-sparepiece',from:'square-e4',to:'square-e5',offset:[5,6,5,7],next:4}),canvas:true}},{id:4,previous:0,next:5,directions:{timeout:0,data:'Can you Capture en passant?',className:'no-animation'},options:{id:3,next:5,answer:['Yes','No'],rightAnswer:'No',magnusWrongAnswer:{data:'Oops! The correct answer is NO.<br/>Only pawns are involved in en passant <br/> captures, no other pieces.',styleClass:'xxl',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson14Assignment1 */])({showIndicators:{allSides:true},position:'rnbq2k1/ppp1n1pp/4p3/3pPr2/3P4/5N2/PP2BPPP/RN1Q1RK1',assignmentClass:'custom-sparepiece',from:'square-f8',to:'square-f5',offset:[5,5,5,4],next:5}),canvas:true}},{id:5,previous:0,next:7,directions:{timeout:0,data:'Can you Capture en passant?',className:'no-animation'},options:{id:4,next:6,answer:['Yes','No'],rightAnswer:'Yes',magnusWrongAnswer:{data:'OOPS! White can capture en passant.',styleClass:'xl',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xs'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson14Assignment1 */])({showIndicators:{allSides:true},position:'r4rk1/1ppqnpb1/3pbnpp/pP2p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',assignmentClass:'custom-sparepiece',from:'square-a7',to:'square-a5',offset:[5,5,5,3],next:6}),canvas:true}},{id:6,previous:0,next:7,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson14Assignment1MovePieces */])({showIndicators:{allSides:true},position:'r4rk1/1ppqnpb1/3pbnpp/pP2p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',finalPosition:'r4rk1/1ppqnpb1/P2pbnpp/4p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',assignmentClass:'custom-sparepiece',from:'square-b5',to:'square-a6',offset:[5,5,5,4],capture:{capturingPiece:'wP',capturedPiece:'bp'},next:7}),canvas:true}},{id:7,previous:0,next:12,video:{src:'img/videos/lesson_14/2.mp4',startTime:0,autoStartNext:true,next:8}},{id:8,previous:7,next:9,directions:{data:'<b> DIRECTIONS: </b> </br>Move a White pawn to create a pawn chain.</br> And save your Queen.',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({position:'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1',final:['r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB1P2/PPP3PP/R1BQNRK1'],next:9,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],failedAttemptMove:24}),positionFen:'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1 w - - 0 1'}},{id:9,previous:7,next:10,directions:{data:'<b> DIRECTIONS: </b> </br>Move a Black pawn to create a pawn chain.',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({position:'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',final:['rnbqkbnr/p2p1ppp/1p2p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R','rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R','rnbqkbnr/pp1p2pp/4p3/2p2p2/4P3/2P2N2/PP1P1PPP/RNBQKB1R'],next:10,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],failedAttemptMove:25}),positionFen:'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b - - 0 1'}},{id:10,previous:7,next:11,directions:{data:'<b> DIRECTIONS: </b> </br>Move a White pawn to create a pawn chain.',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({position:'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',final:['r1bqkbnr/pp1p1ppp/2n1p3/2p5/1P2P3/2P2N2/P2P1PPP/RNBQKB1R','r1bqkbnr/pp1p1ppp/2n1p3/2p5/3PP3/2P2N2/PP3PPP/RNBQKB1R'],next:11,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],failedAttemptMove:26}),positionFen:'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R w - - 0 1'}},{id:11,previous:7,next:12,directions:{data:'<b> DIRECTIONS: </b> </br>Move a Black pawn to create a pawn chain.',timeout:1000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({position:'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',final:['r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1','r1bq1rk1/ppp1ppb1/2np1np1/7p/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1'],next:12,showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMove:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */],failedAttemptMove:27}),positionFen:'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - 0 1'}},{id:12,previous:7,next:13,video:{src:'img/videos/lesson_14/3.mp4',startTime:0,autoStartNext:true,next:13}},{id:13,previous:12,next:14,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'En passant is French for…',answer:['What’s happening?','In passing','The pawn','Tie game'],rightAnswer:'In passing',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',rightAnswerTimeout:7000}},{id:14,previous:12,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'En passant is a move using…',answer:['pawns','Knights','Bishops','The King and a Rook'],rightAnswer:'pawns',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md',rightAnswerTimeout:7000}},{id:15,previous:12,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'What is one of the questions you </br> have to ask before you move en passant?',answer:['Do I still have both of my Knights?','Is my Bishop on a White square?','Did my opponent just move a pawn two squares?','Are the squares between my King and Rook open?'],rightAnswer:'Did my opponent just move a pawn two squares?',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xxl',rightAnswerTimeout:7000}},{id:16,previous:12,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'What is the other question you have to ask </br> before you move en passant?',answer:['Is my Knight checking my opponent\'s King?','Is my opponent’s pawn standing next to my pawn?','Does my opponent still have a Queen?','Did my opponent just castle?'],rightAnswer:'Is my opponent’s pawn standing next to my pawn?',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xxl',rightAnswerTimeout:7000}},{id:17,previous:12,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'White cannot capture en passant because;',answer:['The Black pawn did not move two squares.','En passant only happens before you castle.','The pawn that moved two squares is not BESIDE any pawn.','The pawn is pinned'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'r4rk1/2qbb1pp/pn1pp1P1/1pn2p1P/3NP3/2N1BP2/PPPQ4/2KR1B1R'}),hint:true,canvas:{from:'square-f7',to:'square-f5'}},rightAnswer:'The pawn that moved two squares is not BESIDE any pawn.',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xxl'}},{id:18,previous:12,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'The black h-pawn just moved two squares.<br/>Think carefully, what is the best move for white?',answer:['g5xh6 (en passant)','b2xBc3','Bf7xh5','Rh1xh5#'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'7k/5Bp1/1pp5/6Pp/8/q1b5/PP6/K4R1R'}),hint:true,canvas:{from:'square-h7',to:'square-h5'}},rightAnswer:'Rh1xh5#',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:19,previous:12,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'The White b pawn just moved TWO squares.What should Black do?',answer:['Congratulate White on winning','Declare the game a tie since black can’t move.','Capture en passant and get a new Queen two moves later.','all of the above'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/6P1/6K1/8/pP6/P7/8/8'}),hint:true,canvas:{from:'square-b2',to:'square-b4'}},rightAnswer:'Capture en passant and get <br/> a new Queen two moves later,',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xxl'}},{id:20,previous:12,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'The White b pawn just moved ONE square.<br/>What should Black do?',answer:['Congratulate White on winning','Declare the game a tie because he cannot move.','Capture en passant and get a new Queen two moves later.','all of the above'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/6P1/6K1/8/pP6/P7/8/8'}),hint:true,canvas:{from:'square-b3',to:'square-b4'}},rightAnswer:'Declare the game a tie because he cannot move.',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xxl'}},{id:21,previous:12,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'En passant usually happens...',answer:['as an opening move for pawns','any time during the game','when there are only pawns on the board','to checkmate the King'],rightAnswer:'any time during the game',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:22,previous:12,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'The White pawn just moved c2-c4, Black can capture en passant. Is there a better move?',answer:['No, en passant is the best move.','Yes, Black could move Nh3#','Yes, Black could move h4xg3','Yes, Black could move Bd6xg3'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'2k5/5p2/3b2p1/3b4/2Pp3p/3P2P1/5n1P/2R2RK1'}),hint:true},rightAnswer:'Yes, Black could move Nh3#',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:23,previous:12,next:null,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'Lesson Fifteen',result:true,styleClass:'xl'}},{id:24,previous:0,next:9,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({showIndicators:{allSides:true},position:'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1',final:'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB1P2/PPP3PP/R1BQNRK1',assignmentClass:'custom-sparepiece',from:'f2',to:'f3',next:9})}},{id:25,previous:0,next:9,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({showIndicators:{allSides:true},position:'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',final:'rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R',assignmentClass:'custom-sparepiece',from:'d7',to:'d5',next:10})}},{id:26,previous:0,next:9,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({showIndicators:{allSides:true},position:'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',final:'r1bqkbnr/pp1p1ppp/2n1p3/2p5/1P2P3/2P2N2/P2P1PPP/RNBQKB1R',assignmentClass:'custom-sparepiece',from:'b2',to:'b4',next:11})}},{id:27,previous:0,next:9,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson14Assignment2 */])({showIndicators:{allSides:true},position:'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',final:'r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',assignmentClass:'custom-sparepiece',from:'e7',to:'e5',next:12})}}];// ToDo: add images for 13 and 15
var assets=['/img/background_14.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson14Assignment1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson14Assignment1MovePieces;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson14Assignment2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(2);
/**
* @name lesson14Assignment1
* @function
* @param {config}
* @description: activity related task
*/function lesson14Assignment1(config){var offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];}var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById('myCanvas');var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.from,config.to,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,'#FFA500');};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson14AssignmentMovePieces
* @function
* @param {config}
* @description: chess board related task
*/function lesson14Assignment1MovePieces(config){var moveSpeed=1000,offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];};var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById('myCanvas');var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.from,config.to,offsetFromx,offsetFromy,offsetTox,offsetToy);setTimeout(function(){ctx.clearRect(0,0,c.width,c.height);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getSubstring */])(config.from,config.to));if(config.capture){var move={captured:config.capture.capturedPiece.charAt(1),color:config.capture.capturingPiece.charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* showCapturedPieces */])(config.capture.capturingPiece,move);},moveSpeed);}},1000);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(config.finalPosition);},2000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);// showMagnus({
//   data: `nice job ${User.user.name}!`,
//   styleClass: 'sm',
//   position: 'left'
// })
Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,config.next,false);};var chessConfig={config:{position:config.position,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson14Assignment2
* @function
* @param {config}
* @description: activity related task
*/function lesson14Assignment2(config){var next=config.next,finalMoves=config.final,attemptsMade=2,moveSpeed=1000,from=config.from,to=config.to;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);if(config.from!=null){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(from+'-'+to);},1000);if(config.MagnusText){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:config.MagnusText,position:'left'});}Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);}};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(finalMoves.includes(boardFen)){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:config.MagnusText+' '+__WEBPACK_IMPORTED_MODULE_2__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'xs'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}else if(attemptsMade>0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_4__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'This is not a pawn chain.<br/> Try again.<br/> Chances remaining: '+attemptsMade+' ',position:'left',styleClass:'xl'});--attemptsMade;setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Move the piece to the correct <br/> position to create a pawn chain.',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+config.initialMove);return'snapback';},3000);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,config.failedAttemptMove,false);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+config.initialMove);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'This could be one of the moves.',position:'left'});},3000);}};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_15/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_15/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson15Activity1 */])({showIndicators:{allSides:true},piecesArray:['bQ','bR'],validatePieces:{'bQ':['c4','d2'],'bR':['d2','c4']},pieceLimit:{bQ:3,bR:1},position:'8/8/8/8/8/q7/8/1q6',fen:['8/8/8/8/2q5/q7/3r4/1q6','8/8/8/8/2r5/q7/3q4/1q6'],pieceTheme:'assignment_15_1',assignmentClass:'custom-sparepiece',next:2})},directions:{data:'<b>DIRECTIONS</b><br/>Drag the queens to square on board such that none of them see each other.'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_15/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_15/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson15Activity2 */])({showIndicators:{allSides:true},piecesArray:['bQ','bR','bB','bN','wQ','wR','wB','wN'],pieceLimit:{bQ:1,bR:1,bB:1,bN:1,wQ:1,wR:1,wB:1,wN:1},position:'8/8/8/8/8/8/8/8',pieceTheme:'assignment_15_1',assignmentClass:'custom-sparepiece',next:4})},directions:{data:'<b>DIRECTIONS</b><br/>Drag the Queens and place them on the board so none of them see each other.'}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_15/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/lesson_15/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson15Activity3 */])({showIndicators:{allSides:true},position:'8/5pk1/8/RP2q3/8/7P/5PP1/6K1',resultFen:'8/5pk1/8/RP6/8/7P/5PP1/4q1K1',assignmentClass:'custom-sparepiece',from:'a5',to:'a1',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],next:6}),positionFen:'8/5pk1/8/RP2q3/8/7P/5PP1/6K1 b - - 0 1'}},{id:6,previous:4,next:8,video:{src:'img/videos/lesson_15/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:6,next:8,audio:{src:'img/audio/lesson_15/3.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson15Activity3 */])({showIndicators:{allSides:true},position:'1k6/8/8/8/1K4Q1/8/8/8',resultFen:'1k6/3Q4/8/8/1K6/8/8/8',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],next:8}),positionFen:'1k6/8/8/8/1K4Q1/8/8/8 w - - 0 1'}},{id:8,previous:6,next:9,video:{src:'img/videos/lesson_15/5.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:10,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'The Crowded Queendom is a make believe land where...',answer:['Too many peasants fill the castle','Too many Queens fill the castle','There are many Kings and Queens','There are many apartments and no farm land'],rightAnswer:'Too many Queens fill the castle',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xl'}},{id:10,previous:8,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'The Crowded Queendom is a chess puzzle using...',answer:['8 Queens','8 Kings','16 Queens','16 Kings'],rightAnswer:'8 Queens',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:11,previous:8,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'The goal of the Crowded Queendom is...',answer:['To promote all of your pawns to Queens','To have your Queen capture the King in five moves','To promote your Queens to Knights, Bishops or Rooks','To place 8 Queens so none of them see each other'],rightAnswer:'To place 8 Queens so none of them see each other',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:12,previous:8,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'In the Crowded Queendom, the Queens cannot...',answer:['Share a file','Share a rank','Share a diagonal','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:13,previous:8,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'What does, "Keep the Queens a Knight move away" mean?',answer:['There should be a Knight in between the King and Queen','The Queen should always stand next to a Knight','The Queens should be an L-shape away from each other','The Queens only move after the Knight moves'],rightAnswer:'The Queens should be an L-shape away from each other',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xl'}},{id:14,previous:8,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'In the end game, your Queen should try to...',answer:['Use her double attack skills','Get promoted','Move to the corners of the board','All of the above'],rightAnswer:'Use her double attack skills',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:15,previous:8,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Since Queens don\'t like competition, what should they do in the end game?',answer:['Avoid going to the opposite side of the board','Capture their opponents Knights','Capture pawns close to promoting','All of the above'],rightAnswer:'Capture pawns close to promoting',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg'}},{id:16,previous:8,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What does "equestrian Queen" mean in chess?',answer:['A Queen that rides a horse','Having too many Queens','Having your Queen jump over other pieces','Keeping your Queen a Knight move away from the King'],rightAnswer:'Keeping your Queen a Knight move away from the King',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xl'}},{id:17,previous:8,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Where can you place one more Queen to complete the "Crowded Queendom"',answer:['Qe4','Qe2','Qf3','Qg2'],rightAnswer:'Qe2',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'5Q2/3Q4/6Q1/Q7/7Q/1Q6/8/2Q5'}),hint:true}}},{id:18,previous:8,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Look at this board carefully. White has two great moves. Which ones are both good?',answer:['Bg2+ and Nd6+','Ng7 and Ba6','Nf6+ and Be2','Bg2+ and Ng7'],rightAnswer:'Bg2+ and Nd6+',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'xl',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'4N3/1q6/8/7p/4k3/8/5P2/5BK1'}),hint:true}}},{id:19,previous:8,next:null,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'Lesson Sixteen',result:true,styleClass:'xl',timeout:7000}}];var assets=['img/background_14.png','img/background_15.png','img/background_16.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson15Activity1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson15Activity2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson15Activity3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_user__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(2);
/**
 * @name lesson15Activity1
 * @function
 * @param { config }
 * @description: Drag queens 4x4.
 */function lesson15Activity1(config){var position=config.position,next=config.next,fen=config.fen,pieceLimit=config.pieceLimit,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[];var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').addClass('custom-background-image-4x4');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+4), .row-5277c .square-55d63:nth-last-child(-n+5)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-a3, .square-b1').css('pointer-events','none');};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var bubbleConfig={data:'Good Job '+__WEBPACK_IMPORTED_MODULE_2__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'xs'};validatePosition(piecesArray.length,fen,next,bubbleConfig,false,true);return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true);};function validatePosition(pieceLimit,resultFen,next){var bubbleConfig=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var isQA=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var celebrationSound=arguments[5];if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".piece-417db").length>=12+pieceLimit){setTimeout(function(){var fen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(resultFen.includes(fen)){if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* ACTIVITY_SUCCESS_AUDIO */]);}if(bubbleConfig){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])(bubbleConfig);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,celebrationSound);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,celebrationSound);}}},100);}}var chessConfig={config:{position:position,draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson15Activity2
 * @function
 * @param { config }
 * @description: Drag queens 8x8.
 */function lesson15Activity2(config){var position=config.position,pieceLimit=config.pieceLimit,next=config.next,count=0,board='',limit=2,queens=0,letters=/^[A-Za-z]+$/;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').css('pointer-events','auto');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next, .back-btn-container #previous').click(function(){count=0;board='';limit=2;});};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return validateQueenDrop(piece);};function validateQueenDrop(piece){setTimeout(function(){var pieceCount=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".board-b72b1 img[data-piece = "+piece+"]").length;if(pieceCount<=0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("audio-play",__WEBPACK_IMPORTED_MODULE_4__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sparepieces_container img[data-piece = "+piece+"]").css("visibility","visible");return'trash';}},100);}var onSnapEnd=function onSnapEnd(source,target,piece){count++;queens=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".board-b72b1 img").length;var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();var str=boardFen.split("/");for(var i=0;i<str.length;i++){for(var k=0;k<str[i].length;k++){if(!str[i][k].match(letters)){var num=parseInt(str[i][k],10);for(var j=0;j<num;j++){board=board+'0';}}else{board=board+'1';}}board=board+'/';}var boardArr=board.split('/');boardArr.pop();var check=validateBoard(boardArr);if(check===true){board='';}if(check===true&&count>=8&&queens===8){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Wow, that was awesome!',position:'left',styleClass:'md'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(5000,next,true);}else if(check===false){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-55d63').css('pointer-events','none');count=0;board='';limit--;if(limit<=0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s ok. It is a challenge.',position:'left',styleClass:'md'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,false);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops! Queens can attack each other. Try again',position:'left',styleClass:'lg'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(500,next-1,false);},4500);}}};function validateBoard(board){var firstValue=0,fourthValue=0;for(var i=0;i<8;i++){for(var j=0;j<8;j++){if(board[i][j]==='1'){firstValue++;}if(board[j][i]==='1'){fourthValue++;}}if(firstValue>1||fourthValue>1){return false;}firstValue=0;fourthValue=0;}if(!diagonal(board)){return false;}if(!diagonal(board,true)){return false;}return true;}function diagonal(board,bottomToTop){var Ylength=board.length;var Xlength=board[0].length;var maxLength=Math.max(Xlength,Ylength);var temp;var returnArray=[];var value=0;for(var k=0;k<=2*(maxLength-1);++k){temp=[];for(var y=Ylength-1;y>=0;--y){var x=k-(bottomToTop?Ylength-y:y);if(x>=0&&x<Xlength){temp.push(board[y][x]);}}if(temp.length>1){returnArray.push(temp.join(''));}}for(var i=0;i<returnArray.length;i++){for(var j=0;j<returnArray[i].length;j++){if(returnArray[i][j]==='1'){value++;}}if(value>1){return false;}value=0;}return true;}var chessConfig={config:{position:position,sparePieces:true,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson15Activity3
 * @function
 * @param { config }
 * @description: End game
 */function lesson15Activity3(config){var position=config.position,next=config.next,finalPosition=config.resultFen,boardFen=void 0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,true);};var onSnapEnd=function onSnapEnd(source,target,piece){boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(boardFen===finalPosition){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job!',position:'left',styleClass:'md'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}else if(source==='e5'&&target==='a1'){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops, that wasn\'t safe double attack! Try again',position:'left',styleClass:'lg'});__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(config.from+'-'+config.to);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position+config.initialMoveOf);},3000);}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops! That\'s not the right move',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(position+config.initialMoveOf);}};var chessConfig={config:{position:position,next:next,draggable:true,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_16/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,directions:{data:'<b>DIRECTIONS:</b> <br/>Enter the correct numbers </br> in the boxes </br> to continue the pattern.',timeout:3000},audio:{src:'img/audio/lesson_16/1.mp3',start:true,controls:false},activity:{assignmentClass:'assignment-16-1',callback:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson16Assignment1 */])({next:2})}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_16/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_16/2.mp3',start:true,controls:false},directions:{data:'<b> DIRECTIONS </b> </br> Drag the numbers to the buttons to <br/>create a pattern that makes sense in the elevator.',timeout:8000},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson16Activity2 */])({piecesArray:['bK','bR','bB','bP','wK','wQ','wR','wP','wN'],validatePieces:{'bK':['e5','e6'],'bR':['e4','c6'],'bB':['c6','e4'],'wN':['c7','c5'],'bP':['e6','c7'],'wK':['c5','c4'],'wQ':['e7'],'wR':['c4','e3'],'wP':['e3','e5']},pieceLimit:{bK:1,bB:1,bR:1,bP:1,wK:1,wQ:1,wR:1,wP:1,wN:1},pieceTheme:'assignment_16_2',next:4,assignmentClass:'assignment-16-2',resultFen:['8/2p1Q3/2r1k3/2N1P3/2K1b3/4R3/8/8','8/2N1Q3/2b1p3/2K1k3/2R1r3/4P3/8/8'],repeatActivity:3})}},{id:4,previous:2,next:8,video:{src:'img/videos/lesson_16/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:8,audio:{src:'img/audio/lesson_16/3.mp3',start:true,controls:false},directions:{data:'<b> DIRECTIONS: </b> <br/>Find one pattern in this diagram. ',timeout:100},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson16Assignment3 */])({showIndicators:{allSides:true},coordinatesGreen:['.square-a6','.square-b7','.square-c7','.square-d6'],position:'1k1rr3/1pp1qpp1/p1npbb1p/8/6P1/1PP1BN1P/PKPQRPB1/3R4',reminder:true,next:6})}},{id:6,previous:4,next:8,directions:{data:'<b> DIRECTIONS: </b> <br/>Find two patterns in this diagram. ',timeout:100,position:'left'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson16Assignment3 */])({idCommon:false,showIndicators:{allSides:true},coordinatesGreen:['.square-f7','.square-g7','.square-h7','.square-g6'],coordinateNonePointerGreen:['.square-f7','.square-g7','.square-h7','.square-g6'],coordinatesYellow:['.square-d5','.square-e4','.square-f3','.square-g2'],coordinateNonePointerYellow:['square-d5','.square-e4','.square-f3','.square-g2'],position:'r1brq1k/1pp1ppbp/pn4p1/n2P4/4P3/2N1BP2/PP4PP/1KQR1BNR',reminder:true,next:7})}},{id:7,previous:4,next:8,directions:{data:'<b> DIRECTIONS: </b> <br/>Find three patterns in this diagram. ',timeout:100,position:'left'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson16Assignment3 */])({idCommon:true,showIndicators:{allSides:true},coordinatesGreen:['.square-d4','.square-e3','.square-f2'],coordinateNonePointerGreen:['.square-d4','.square-e3','.square-f2'],coordinatesYellow:['.square-e6','.square-f7','.square-g7','.square-h6'],coordinateNonePointerYellow:['.square-h6','.square-g7'],coordinatesPurple:['.square-d5','.square-e6','.square-f7'],coordinateNonePointerPurple:['.square-d5'],position:'rnbq1rk1/p1p1bpp1/1p2pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R',reminder:true,next:null})}},{id:8,previous:4,next:14,video:{src:'img/videos/lesson_16/4.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:14,audio:{src:'img/audio/lesson_16/4.mp3',start:true,controls:false},directions:{timeout:4000,data:'<b>DIRECTIONS:</b> <br/>Find a zig zag path <br/>for White to checkmate Black in 3 moves.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["e" /* lesson16Assignment4 */])({position:'k4b2/p1B4n/P2p1p2/3Pp1pp/1p2P3/1P3P2/2B3PP/1K6',resultFen:'k2b4/p1B4n/P1Bp1p2/3Pp1pp/1p2P3/1P3P2/6PP/1K6',next:10,moves:{studentMove:{from:['c2','d3','b5'],to:['d3','b5','c6']},computerMove:{from:['f8','e7'],to:['e7','d8']}},showIndicators:{allSides:true},MagnusText:'nice job',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_2__utils_constants__["i" /* WHITE_INITIAL_MOVE */],fromArrow:'square-c6',toArrow:'square-a8',offset:[5,5,5,4]}),positionFen:'k4b2/p1B4n/P2p1p2/3Pp1pp/1p2P3/1P3P2/2B3PP/1K6 w - - 0 1',canvas:true}},{id:10,previous:8,next:11,video:{src:'img/videos/lesson_16/5.mp4',startTime:0,autoStartNext:true,next:11}},{id:11,previous:10,next:12,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Where can you find patterns?',answer:['In numbers','In nature','On the chessboard','All of the above'],rightAnswer:'All of the above',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md'}},{id:12,previous:10,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'What is the purpose of this pattern?',answer:['It helps protect the King','The pawns protect each other','The pawns protect the Bishop','It gets you checkmate'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson16Activity5 */])({showIndicators:true,position:'r1brq1k1/1pp2pbp/pn4p1/n2P4/4PP2/2N1B3/PP4PP/1KQR1BNR',highlightSquares:['.square-f7','.square-g7','.square-h7','.square-g6']}),hint:true},rightAnswer:'It helps protect the King',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:13,previous:10,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'What is the purpose of this pattern?',answer:['It helps protect the King','The pawns protect each other','It builds a wall','It gets you checkmate'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson16Activity5 */])({showIndicators:true,position:'6k1/p2p3p/8/1p2P3/3P4/2P5/1P5P/6K1',highlightSquares:['.square-b2','.square-c3','.square-d4','.square-e5']}),hint:true},rightAnswer:'The pawns protect each other',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:14,previous:10,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'What is the purpose of this pattern?',answer:['It helps protect the King','The pawns protect each other','It builds a wall','It gets you checkmate'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson16Activity5 */])({showIndicators:true,position:'1k1rr3/1pp1kpp1/p1npbb1p/8/6P1/1PP1BN1P/PKPQRPB1/3R4',highlightSquares:['.square-a6','.square-b7','.square-c7','.square-d6']}),hint:true},rightAnswer:'It helps protect the King',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:15,previous:10,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'How many patterns can you count in this diagram?',answer:['1','2','3','4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'rn1q1rk1/pb1pbpp1/1p2pn1p/2p5/2P5/2NP1NP1/PP1BPPBP/R2Q1RK1'}),hint:true},rightAnswer:'4',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xs'}},{id:16,previous:10,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'White has a familiar pattern. What one move <br/> can White make to create a different pattern?',answer:['b2-b4','g3-g4','Bg2-e4','h2-h4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/2p5/1b4pk/1p5p/8/6P1/1P3PBP/6K1'}),hint:true},rightAnswer:'h2-h4',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xs'}},{id:17,previous:10,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Both Black and White have a familiar pattern.<br/> With White to move, which pattern is safer?',answer:['White is much safer','They are equally safe','Black is a little safer','It doesn’t matter because Black is ahead in points'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson16Activity5 */])({showIndicators:true,position:'r7/5pp1/4pBkp/4P2n/8/p5P1/5PBP/6K1',highlightSquares:['.square-e6','.square-f7','.square-g7','.square-h6','.square-f2','.square-g3','.square-h2']}),hint:true},rightAnswer:'White is much safer',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:18,previous:10,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What is the best move for White?',answer:['Bg2xa8','Bf6-e7','Bg2-e4','f2-f4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'r7/5pp1/4pBkp/4P2n/8/p5P1/5PBP/6K1'}),hint:true},rightAnswer:'Bg2-e4',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:19,previous:10,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Black has an excellent pattern of defense,<br/> only one square is unprotected. Which <br/>square is unprotected?',answer:['h8','h5','e5','a4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'rn1q1rk1/1bp1bpp1/pp2pn1p/3p4/8/8/8/8'}),hint:true},rightAnswer:'e5',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md'}},{id:20,previous:10,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'What move can White make to create a pattern? ',answer:['Castle','d2-d3','d2-d4','Nb1-c3'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R'}),hint:true},rightAnswer:'d2-d3',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:21,previous:10,next:null,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'Lesson 17',result:true,styleClass:'xl',timeout:7000}}];var assets=['/img/background_6.png','/img/box.png','/img/numbers/assignment_16_2/one.png','/img/numbers/assignment_16_2/two.png','/img/numbers/assignment_16_2/thress.png','/img/numbers/assignment_16_2/four.png','/img/numbers/assignment_16_2/five.png','/img/numbers/assignment_16_2/six.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson16Assignment1;
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson16Activity2;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson16Assignment3;
/* harmony export (immutable) */ __webpack_exports__["e"] = lesson16Assignment4;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson16Activity5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_user__ = __webpack_require__(4);
/**
* @name lesson16Assignment1
* @function
* @param {config}
* @description: activity related task
*/function lesson16Assignment1(config){var next=config.next;var callback=function callback(){var body='\n        <div class=\'card flex-center\'>\n          <div class=\'card-wrapper full-width\'>\n            <ul class=\'options-table\'>\n            <span><img class=\'imgArrows\' src=\'/img/lesson16Activity.png\'></span>\n            <div class=\'question-mark\'>\n            <span id=\'AnswerOne\'> ? </span>\n            <span id=\'AnswerTwo\'> ? </span>\n            </div>\n            <span class=\'checkbox1\'><input type=\'text\' id=\'checkbox1\' class=\'NumberBoxInput\'></span>\n              <span class=\'plus1\'>+</span>\n              <span class=\'checkbox2\'><input type =\'text\' id=\'checkbox2\' class=\'NumberBoxInput\'></span>\n              <span class=\'equal-1\'>=</span>\n              <span class=\'checkbox3\'><input type =\'text\' id=\'checkbox3\' class=\'NumberBoxInput\'></span>\n              <span><img class=\'imgArrow\' id=\'imgSix\' src=\'/img/arrow_six.png\'></span>\n              <span class=\'checkbox4\'><input type=\'text\' id=\'checkbox4\' class=\'NumberBoxInput\'></span>\n              <span class=\'plus2\'>+</span>\n              <span class=\'checkbox5\'><input type =\'text\' id=\'checkbox5\' class=\'NumberBoxInput\'></span>\n              <span class=\'equal-2\'>=</span>\n              <span class=\'checkbox6\'><input type =\'text\' id=\'checkbox6\' class=\'NumberBoxInput\'></span>\n              <span><img class=\'imgArrow\' id=\'imgSeven\'src=\'/img/arrow_seven.png\'></span>\n            </ul>\n          </div>\n        </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-section-content').html(body);var inputOne,inputTwo,resultOne,inputThree,inputFour,resultTwo;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').addClass('directions-lesson16-activity1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').addClass('right-box-lesson16-activity1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox4').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox5').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox6').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox1').keyup(function(){inputOne=this.value;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox2').keyup(function(){inputTwo=this.value;GetValuesOf();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox4').keyup(function(){inputThree=this.value;});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox5').keyup(function(){inputFour=this.value;ResultValue();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next, .back-btn-container #previous').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').removeClass('directions-lesson16-activity1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').removeClass('right-box-lesson16-activity1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').removeClass();});function GetValuesOf(){if(inputOne&&inputTwo){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox3').on("input",function(event){resultOne=this.value;if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val().length>=2){resultOneValue();}});}}function resultOneValue(){if(resultOne==='13'){if(inputOne==='5'&&inputTwo==='8'&&resultOne==='13'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#AnswerOne').text(resultOne);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job!'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name+'<br/>Fill the next series <br/> to continue the pattern',position:'right',styleClass:'sm'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox4').prop('disabled',false);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox5').prop('disabled',false);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox6').prop('disabled',false);}else if((inputOne!=='5'||inputTwo!=='8')&&resultOne==='13'){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!Try again. Look at the series and give appropriate values',position:'right',styleClass:'md',timeout:1000});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();},5000);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox1').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox2').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox3').val('');},3000);}}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!Try again. Look at the series and give appropriate values',position:'right',styleClass:'md',timeout:1000});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();},5000);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox1').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox2').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox3').val('');},3000);}}function ResultValue(){if(inputThree&&inputFour){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox6').on("input",function(event){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val().length>=2){resultTwo=this.value;resultTwoValue();}});}}function resultTwoValue(){if(resultTwo==='21'){if(inputThree==='8'&&inputFour==='13'&&resultTwo==='21'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#AnswerTwo').text(resultTwo);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job!'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,position:'right',styleClass:'sm'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').removeClass('right-box-lesson16-activity1');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').removeClass();},3000);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);}else if((inputThree!=='8'||inputFour!=='13')&&resultTwo==='21'){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again. Look at the series and give appropriate values',position:'right',styleClass:'sm',timeout:1000});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();},5000);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox4').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox5').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox6').val('');},3000);}}else{Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Oops...!!!<br/> Try again. Look at the series and give appropriate values',position:'right',styleClass:'sm',timeout:1000});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();},5000);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox4').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox5').val('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkbox6').val('');},3000);}}});};return callback;}/**
* @name lesson16Activity2
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/function lesson16Activity2(config){var next=config.next,pieceLimit=config.pieceLimit,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[],draggedNumbersCount=0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card-wrapper.activity').remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card-wrapper.activity').remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-c3').prepend('<img id="imgOne" src="/img/chesspieces/assignment_16_2/bQ.png" />');var body='<div class=\'card flex-center\'>\n    <div class=\'card-wrapper activity\'>\n    </div>\n  </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard').addClass('flex-display');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.left-box-content').html(body);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card.flex-center').addClass('left-section-lesson16');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-7492f.spare-pieces-top-4028b').addClass('margin-lesson16');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.spare-pieces-7492f.spare-pieces-bottom-ae20f').addClass('margin-left-lesson16');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.chessboard-63f37').addClass('margin-right-lesson16');};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var bubbleConfig={data:'Good Job',position:'left',styleClass:'xs'};Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* validatePosition */])(piecesArray.length,next,bubbleConfig,false,true);var dropValidation=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true);if(dropValidation==='trash'&&draggedNumbersCount===8){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Try again! <br/>That was not the correct order.',position:'left',styleClass:'sm',timeout:'500'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.piece-417db').remove();draggedNumbersCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,config.repeatActivity,true);}return dropValidation;};var onSnapEnd=function onSnapEnd(source,target,piece){draggedNumbersCount++;if(config.resultFen.includes(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen())){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job! <br/>'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,position:'left',styleClass:'xs',timeout:1000});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card-wrapper.activity').remove();}else if(!config.resultFen.includes(__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen())&&draggedNumbersCount===9){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Try again!<br/>That was not the correct order.',position:'left',styleClass:'sm',timeout:500});draggedNumbersCount=0;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,config.repeatActivity,true);}};var chessConfig={config:{draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,onSnapEnd:onSnapEnd,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.png'},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson16Assignment3
* @function
* @param {config}
* @description: activity related task
*/function lesson16Assignment3(config){var afterLoad=function afterLoad(){var next=config.next,coordinatesGreen=config.coordinatesGreen?config.coordinatesGreen:[],coordinatesYellow=config.coordinatesYellow?config.coordinatesYellow:[],coordinatesPurple=config.coordinatesPurple?config.coordinatesPurple:[],coordinateCountGreen=coordinatesGreen.length,coordinateCountYellow=coordinatesYellow.length,coordinateCountPurple=coordinatesPurple.length,nonePointerGreen=config.coordinateNonePointerGreen?config.coordinateNonePointerGreen:[],nonePointerYellow=config.coordinateNonePointerYellow?config.coordinateNonePointerYellow:[],nonePointerPurple=config.coordinateNonePointerPurple?config.coordinateNonePointerPurple:[];var correctClick=false,CheckedGreen=false,CheckedYellow=false,CheckedPurple=false;var board=document.getElementsByClassName('chessboard-63f37');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(board[0]).click(function(e){e.preventDefault();if(!correctClick){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'oops! <br/> Wrong square',styleClass:'xs'});}correctClick=false;});var body='\n            <div class = "wrapActivity3">\n            <div class=\'flex-display flex-column\'>\n            <label id=\'labelOne\' class=\'container\'><p class=\'hideLabel\'>1.</p>\n            <input class=\'checkBoxAssignment16\' type=\'checkbox\' id =\'checkBox1\' disabled=\'disabled\'>\n            <span class=\'checkmark\'><div class=\'numbersCheckbox\' id=\'numbersCheckbox1\'>1.</div></span>\n            </label>\n            <label id=\'labelTwo\' class=\'container\'><p class=\'hideLabel\'>2.</p>\n            <input class=\'checkBoxAssignment16\' type=\'checkbox\' id =\'checkBox2\' disabled=\'disabled\'>\n            <span class=\'checkmark\'><div class=\'numbersCheckbox\' id=\'numbersCheckbox2\'>2.</div></span>\n            </label>\n            <label id =\'labelThree\' class=\'container\'><p class=\'hideLabel\'>3.</p>\n            <input class=\'checkBoxAssignment16\' type=\'checkbox\' id =\'checkBox3\' disabled=\'disabled\'>\n            <span class=\'checkmark\'><div class=\'numbersCheckbox\' id=\'numbersCheckbox3\'>3.</div></span>\n            </label>\n            </div>\n            </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').append(body);});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);if(coordinateCountYellow===0){CheckedYellow=true;checkBoxes(CheckedYellow);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkBox2').attr('checked',true);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelTwo').hide();});});}if(coordinateCountPurple===0){CheckedPurple=true;checkBoxes(CheckedPurple);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkBox3').attr('checked',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelThree').hide();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelThree').hide();});});}coordinatesGreen.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('none-pointer-event');correctClick=true;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css('background-color','#FFDF00');--coordinateCountGreen;if(coordinateCountGreen===0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job! <br/>'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,styleClass:'xs'});}if(coordinateCountGreen===0){nonePointerGreen.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).addClass('none-pointer-event');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkBox1').attr('checked',true);addTick();setTimeout(function(){coordinatesGreen.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('background','');});},500);CheckedGreen=true;checkBoxes(CheckedGreen);}});});coordinatesYellow.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).click(function(){correctClick=true;if(config.idCommon===false){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('none-pointer-event');}if(element==='.square-h6'||element==='.square-g7'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d5').addClass('none-pointer-event');}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css('background-color','#FFDF00');--coordinateCountYellow;if(coordinateCountYellow===0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job! <br/>'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,styleClass:'xs'});}if(coordinateCountYellow===0){if(config.idCommon){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d5').addClass('auto-pointer-event');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d5').addClass('none-pointer-event');}nonePointerYellow.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).addClass('none-pointer-event');});coordinateCountPurple=4;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkBox2').attr('checked',true);addTick();setTimeout(function(){coordinatesYellow.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('background','');});},500);CheckedYellow=true;checkBoxes(CheckedYellow);}});});coordinatesPurple.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).click(function(){correctClick=true;if(element==='.square-d5'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-h6').addClass('none-pointer-event');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-g7').addClass('none-pointer-event');}__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css('background-color','#FFDF00');--coordinateCountPurple;if(coordinateCountPurple===0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job! <br/>'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,styleClass:'xs'});}if(coordinateCountPurple===0){nonePointerPurple.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).addClass('none-pointer-event');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-h6').addClass('auto-pointer-event');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-g7').addClass('auto-pointer-event');coordinateCountYellow=4;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#checkBox3').attr('checked',true);addTick();setTimeout(function(){coordinatesPurple.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('background','');});},500);CheckedPurple=true;checkBoxes(CheckedPurple);}});});function checkBoxes(){if(CheckedGreen===true&&CheckedYellow===true&&CheckedPurple===true){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelOne').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelTwo').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelThree').remove();},2000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* ACTIVITY_COMPLETION_AUDIO */]);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wrapActivity3').remove();},2000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tick').removeClass();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next,true);}}function addTick(){if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tick').length===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox1').html('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox1').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');;}else if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tick').length===1){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox2').html('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox2').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox3').html('');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#numbersCheckbox3').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');}}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#previous').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wrapActivity3').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelOne').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelTwo').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelThree').hide();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#next').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.directions').addClass('.directions-lesson16-activity3');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wrapActivity3').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelOne').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelTwo').hide();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#labelThree').hide();});};var chessConfig={config:{position:config.position,draggable:false,sparePieces:false},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson16Assignment4
* @function
* @param {config}
* @description: activity related task
*/function lesson16Assignment4(config){var next=config.next,moveSpeed=1000,initialBoardPosition=config.position,moves=config.moves,totalStudentMoves=config.moves.studentMove.from.length,totalComputerMoves=config.moves.computerMove.from.length,studentFromCount=0,studentToCount=0,computerFromCount=0,computerToCount=0,board=void 0,timer=void 0,offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];};var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('width-lesson16Activity4');if(config.firstMove){computerMove();}};var onDragStart=function onDragStart(source,piece,position,orientation){board=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){studentFromCount=0;studentToCount=0;clearTimeout(timer);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){studentFromCount=0;studentToCount=0;clearTimeout(timer);});if(studentFromCount<totalStudentMoves&&studentToCount<totalStudentMoves){if(source===moves.studentMove.from[studentFromCount]&&target===moves.studentMove.to[studentToCount]){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);if(studentToCount===2){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').removeClass('width-lesson16Activity4');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.fromArrow,config.toArrow,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,"#cc0000");Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job '+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name+'! <br/> You made it checkmate'});}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},2000);studentFromCount++;studentToCount++;computerMove();}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s not the right move',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(board);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(board+config.initialMoveOf);}}};function computerMove(){if(computerFromCount<totalComputerMoves&&computerToCount<totalComputerMoves){timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(moves.computerMove.from[computerFromCount]+'-'+moves.computerMove.to[computerToCount]);computerFromCount++;computerToCount++;},2000);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){computerFromCount=0;computerToCount=0;clearTimeout(timer);});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){computerFromCount=0;computerToCount=0;clearTimeout(timer);});}if(!moves.computerMove.from[computerFromCount]){setTimeout(function(){studentFromCount=studentToCount=computerFromCount=computerToCount===0;__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.resultFen);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);},2000);}else{var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+config.initialMoveOf);}}var chessConfig={config:{position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson16Activity5
* @function
* @param {config}
* @description: to fill squares with color
*/function lesson16Activity5(config){var square=config.highlightSquares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);square.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).addClass('background-red');});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:4,video:{src:'img/videos/lesson_17/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:4,audio:{src:'img/audio/lesson_17/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'rnb1kbrn/ppp1pppp/2q5/8/8/2N5/PPPP1PPP/R1BQKBNR',resultFen:'rnb1kbrn/ppp1pppp/2q5/1B6/8/2N5/PPPP1PPP/R1BQK1NR',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'Oops! That doesn\'t pin the Queen to the King.',magnusWrongMessage:'It\'s the absolute pin by the Bishop!',from:'f1',to:'b5',next:2}),positionFen:'rnb1kbrn/ppp1pppp/2q5/8/8/2N5/PPPP1PPP/R1BQKBNR w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Make a move to pin opposite Queen to King.'}},{id:2,previous:0,next:4,audio:{src:'img/audio/lesson_17/2.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQ1RK1',resultFen:'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQR1K1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'Oops! That doesn\'t pin the Queen to the King.',magnusWrongMessage:'The Rook is the BEST pin.',from:'f1',to:'e1',next:3}),positionFen:'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQ1RK1 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Make the BEST move to pin the Black Queen to King.'}},{id:3,previous:0,next:4,audio:{src:'img/audio/lesson_17/3.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'r4rk1/ppp2qbp/2np2p1/4pp2/2P5/P1NP2P1/1P2PPBP/R2Q1RK1',resultFen:'r4rk1/ppp2qbp/2np2p1/3Bpp2/2P5/P1NP2P1/1P2PP1P/R2Q1RK1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'Oops! That doesn\'t pin the Queen to the King.',magnusWrongMessage:'It\'s the absolute pin by the Bishop!',from:'g2',to:'d5',next:4}),positionFen:'r4rk1/ppp2qbp/2np2p1/4pp2/2P5/P1NP2P1/1P2PPBP/R2Q1RK1 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Make a move to pin the Black Queen to King.'}},{id:4,previous:0,next:8,video:{src:'img/videos/lesson_17/2.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:8,audio:{src:'img/audio/lesson_17/4.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'5nk1/2p2bp1/4pp1p/8/1R1R1P1P/6P1/5P2/6K1',resultFen:'5nk1/5bp1/4pp1p/2p5/1R1R1P1P/6P1/5P2/6K1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'That\'s not a Fork.',magnusWrongMessage:'It\'s a Fork by the pawn!',from:'c7',to:'c5',next:6}),positionFen:'5nk1/2p2bn1/4pp1p/8/1R1R1P1P/6P1/5P2/6K1 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Find a successful fork.'}},{id:6,previous:4,next:8,audio:{src:'img/audio/lesson_17/5.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'3r1rk1/1pp2pp1/p3pn1p/2q1n3/8/2PP2N1/PP1NQPPP/R2R2K1',resultFen:'3r1rk1/1pp2pp1/p3pn1p/2q1n3/3P4/2P3N1/PP1NQPPP/R2R2K1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'That\'s not a Fork.',magnusWrongMessage:'It\'s a Fork by the pawn!',from:'d3',to:'d4',next:7}),positionFen:'3r1rk1/1pp2pp1/p3pn1p/2q1n3/8/2PP2N1/PP1NQPPP/R2R2K1 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Find a successful fork.'}},{id:7,previous:4,next:8,audio:{src:'img/audio/lesson_17/6.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'6k1/1pp2ppp/p2p2q1/4n3/8/2PP4/PP3PPP/4QBK1',resultFen:'6k1/1pp2ppp/p2p2q1/8/8/2PP1n2/PP3PPP/4QBK1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'That\'s not a Fork.',magnusWrongMessage:'It\' a Fork by the Knight!',from:'e5',to:'f3',next:8}),positionFen:'6k1/1pp2ppp/p2p2q1/4n3/8/2PP4/PP3PPP/4QBK1 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Find a successful fork.'}},{id:8,previous:4,next:12,video:{src:'img/videos/lesson_17/3.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:12,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'r2q1rk1/1ppb1p1p/p2p2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R',resultFen:'r2q1rk1/1pp2p1p/p1bp2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'That\'s not a Skewer.',magnusWrongMessage:'It\'s a Skewer by the Bishop!',from:'d7',to:'c6',next:10}),positionFen:'r2q1rk1/1ppb1p1p/p2p2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a Black piece to skewer the White Queen and Rook.'}},{id:10,previous:8,next:12,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/5RK1',resultFen:'4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/4R1K1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'That\'s not a Skewer.',magnusWrongMessage:'It\'s a Skewer by the Rook!',from:'f1',to:'e1',next:11}),positionFen:'4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/5RK1 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a White piece to skewer the Black King and Rook.'}},{id:11,previous:8,next:12,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson17Activity3 */])({showIndicators:{allSides:true},position:'2r4r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4',resultFen:['2r5/5pk1/8/1p6/1P6/5PP1/R2K3r/3R4','2rr4/5pk1/8/1p6/1P6/5PP1/R2K4/3R4','3r3r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4'],assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'That\'s not a Skewer.',magnusWrongMessage:'It\'s a Skewer by the Rook!',from:'h8',to:'h2',next:12}),positionFen:'2r4r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a Black piece to skewer the White King and Rook.'}},{id:12,previous:8,next:18,video:{src:'img/videos/lesson_17/4.mp4',startTime:0,autoStartNext:true,next:13}},{id:13,previous:12,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'2r2k2/5p1p/5bpn/2p5/5P2/2P1Q1P1/5K2/3R4',resultFen:'2r2k2/5p1p/5bp1/2p5/5Pn1/2P1Q1P1/5K2/3R4',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'Try Again!',magnusWrongMessage:'It\'s a double attack by the Knight!',from:'h6',to:'g4',next:14}),positionFen:'2r2k2/5p1p/5bpn/2p5/5P2/2P1Q1P1/5K2/3R4 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'}},{id:14,previous:12,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/5K2/4R3',resultFen:'2r2k2/5p1p/6pn/2p5/3b1P2/4Q1PP/5K2/4R3',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'Try Again!',magnusWrongMessage:'It\'s an absolute pin attack by the Bishop!',from:'f6',to:'d4',next:15}),positionFen:'2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/5K2/4R3 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'}},{id:15,previous:12,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4',resultFen:'4rk2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],magnusMessage:'Try Again!',magnusWrongMessage:'Rook to e8 is an absolute pin!',from:'c8',to:'e8',next:16}),positionFen:'2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4 b - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'}},{id:16,previous:12,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'2r5/5k1p/4qbp1/2p5/5P2/4Q1PP/6BK/3R4',resultFen:'2r5/5k1p/4qbp1/2pB4/5P2/4Q1PP/7K/3R4',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'Try Again!',magnusWrongMessage:'It\'s an absolute pin attack by the Bishop!',from:'g2',to:'d5',next:17}),positionFen:'2r5/5k1p/4qbp1/2p5/5P2/4Q1PP/6BK/3R4 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a White piece to create a successful pin, skewer or fork.'}},{id:17,previous:12,next:18,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson17Activity1 */])({showIndicators:{allSides:true},position:'2r5/5p1p/4qbk1/2p5/5PP1/4Q2P/6BK/3R4',resultFen:'2r5/5p1p/4qbk1/2p2P2/6P1/4Q2P/6BK/3R4',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],magnusMessage:'Try Again!',magnusWrongMessage:'The pawn can make a Royal Fork!',from:'f4',to:'f5',next:18}),positionFen:'2r5/5p1p/4qbk1/2p5/5PP1/4Q2P/6BK/3R4 w - - 0 1'},directions:{data:'<b>DIRECTIONS</b><br/>Move a White piece to create a successful pin, skewer or fork.'}},{id:18,previous:12,next:19,video:{src:'img/videos/lesson_17/5.mp4',startTime:0,autoStartNext:true,next:19}},{id:19,previous:18,next:20,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Which pieces can create Pins?',answer:['Kings','Knights and pawns','Queens, Rooks and Bishops','Any piece'],rightAnswer:'Queens, Rooks and Bishops',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg'}},{id:20,previous:18,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'Which pieces can create Forks?',answer:['Kings and Queens','Knights and pawns','Queens, Rooks and Bishops','Any piece'],rightAnswer:'Knights and pawns',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'}},{id:21,previous:18,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'What is a pin?',answer:['A sneaky double attack','A line of pawns on the diagonal','Two pieces attacking one piece','When no piece is captured'],rightAnswer:'A sneaky double attack',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:22,previous:18,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'In an absolute pin...',answer:['The pinned piece can’t move','A piece is pinned to the Queen','Two pieces will be captured','No piece is captured'],rightAnswer:'The pinned piece can’t move',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'}},{id:23,previous:18,next:24,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'In a relative pin...',answer:['A piece is pinned to the King','The pawns are the pins','It is illegal for the pinned piece to move','It is not a good idea for the pinned piece to move'],rightAnswer:'It is not a good idea for the pinned piece to move',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg'}},{id:24,previous:18,next:25,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What is this move called?',answer:['Pin','Skewer','Fork','Royal fork'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson17Activity2 */])({showIndicators:true,position:'3r2k1/1pp2p2/p1n3pp/3N1b1q/2P5/1P3N2/P4PPP/4RQK1',resultFen:'3r2k1/1pp2p2/p1n2Npp/5b1q/2P5/1P3N2/P4PPP/4RQK1',from:'d5',to:'f6'}),hint:true},rightAnswer:'Royal fork',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg'}},{id:25,previous:18,next:26,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'What move can Black make to create a skewer?',answer:['Ra4-c4+','Ra4-a1+','Ra4xd4','d5xe4 (en passant)'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/3pP2k/r2P2pP/6P1/8/2K2R2'}),hint:true},rightAnswer:'Ra4-a1+',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'}},{id:26,previous:18,next:27,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'What tactic is the Bishop on e4 using?',answer:['A skewer','A fork','An absolute pin','A relative pin'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'4r3/2p2ppk/6qp/8/4B2P/P1PQ2P1/1P2KP2/8',assignmentClass:'custom-sparepiece',from:"square-h7",to:"square-g8",offset:[3,3,9,9]}),hint:true},rightAnswer:'An absolute pin',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg'}},{id:27,previous:18,next:28,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'Which move creates a Royal Fork?',answer:['Nd3-e5+','Nd3-f4+','Nh7-f8+','Nh7-g5+'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/3q1p1N/4k3/8/8/3N2P1/3K1P2/8'}),hint:true},rightAnswer:'Nh7-f8+',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg'}},{id:28,previous:18,next:29,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'Which move creates a skewer?',answer:['Bg7-h6','Bg7-d4','Bf7-d5','Bf7-c4'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'2rr2k1/5bbp/R5p1/8/8/4RNP1/4KP2/4N3'}),hint:true},rightAnswer:'Bf7-c4',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg'}},{id:29,previous:18,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Eighteen',styleClass:'xl'}}];var assets=['/img/background_16.png','/img/background_17.png','/img/background_18.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson17Activity1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson17Activity2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson17Activity3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/**
 * @name lesson17Activity1
 * @function
 * @param { config }
 * @description: Pins, Forks, Skewers
 */function lesson17Activity1(config){var position=config.position,next=config.next,finalPosition=config.resultFen,message=config.magnusMessage,wrongMessage=config.magnusWrongMessage,count=2;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.fen();--count;if(boardFen===finalPosition){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:"Nice job!",position:'left',styleClass:'xs'});Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(4000,next,true);}else if(count>0){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:message,position:'left',styleClass:'xl'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].game=new window.Chess(position+config.initialMoveOf);}else{__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(position);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:wrongMessage,position:'left',styleClass:'lg'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);},2000);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(6000,next,false);}};var chessConfig={config:{sparePieces:true,draggable:true,position:position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson17Activity2
 * @function
 * @param { config }
 * @description: chessboard related task
 */function lesson17Activity2(config){var body='<button class="repeat-btn-qa" type="button">Repeat Move</button>';var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);if(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').length===0){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.right-box-content').append(body);}if(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').length>=2){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').remove();}__WEBPACK_IMPORTED_MODULE_2_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.answer').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').css('opacity','0');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').remove();},4000);});});var repeatTimer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').click(function(){__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(config.position);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);},2000);});},3000);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.next-btn-container #next').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').remove();});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.back-btn-container #previous').click(function(){clearTimeout(timer);clearTimeout(repeatTimer);__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').remove();});var timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.repeat-btn-qa').css('cursor','pointer');__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);},3000);};var chessConfig={config:{position:config.position,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson17Activity3
 * @function
 * @param { config }
 * @description: Pins, Forks, Skewers
 */function lesson17Activity3(config){var position=config.position,next=config.next,finalPosition=config.resultFen,message=config.magnusMessage,wrongMessage=config.magnusWrongMessage,count=2;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* validateMove */])(source,target,piece,false);};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.fen();--count;if(finalPosition.includes(boardFen)){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:"Nice job!",position:'left',styleClass:'xs'});Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(4000,next,true);}else if(count>0){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:message,position:'left',styleClass:'xl'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(position);__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].game=new window.Chess(position+config.initialMoveOf);}else{__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.position(position);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:wrongMessage,position:'left',styleClass:'lg'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_1__components_chessBoard__["a" /* default */].board.move(config.from+"-"+config.to);},2000);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(6000,next,false);}};var chessConfig={config:{sparePieces:true,draggable:true,position:position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_18/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_18/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson18Activity1 */])({showIndicators:{allSides:true},position:'8/8/8/8/8/8/8/8',assignmentClass:'custom-sparepieces',next:2})}},{id:2,previous:0,next:11,video:{src:'img/videos/lesson_18/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:11,audio:{src:'img/audio/lesson_18/2.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br/>Select the correct option.',timeout:0,className:'no-animation'},options:{id:0,next:4,answer:['YES, the White pawn can sucessfully promote.','NO, the White pawn can\'t successfully promote.'],rightAnswer:'NO, the White pawn can\'t successfully promote.',magnusWrongAnswer:{data:'Oops! Take a look.',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'8/3k4/8/8/7P/8/3K4/8',assignmentClass:'custom-sparepiece'})}},{id:4,previous:2,next:null,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson18Activity2 */])({showIndicators:{allSides:true},position:'8/3k4/8/8/7P/8/3K4/8',assignmentClass:'custom-sparepiece',from:['h4','d7','h5','e7','h6','f7','h7','g7'],to:['h5','e7','h6','f7','h7','g7','h8','h8'],next:5})}},{id:5,previous:2,next:11,audio:{src:'img/audio/lesson_18/3.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br/>Select the correct option.',timeout:0,className:'no-animation'},options:{id:1,next:6,answer:['YES, the Black pawn can sucessfully promote.','No, the Black pawn can\'t successfully promote.'],rightAnswer:'YES, the Black pawn can sucessfully promote.',magnusWrongAnswer:{data:'Oops! Take a look.',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'8/8/4k3/8/8/6p1/3K4/8',assignmentClass:'custom-sparepiece'})}},{id:6,previous:2,next:null,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson18Activity2 */])({showIndicators:{allSides:true},position:'8/8/4k3/8/8/6p1/3K4/8',resultFen:'8/8/4k3/8/8/8/4K3/6q1',assignmentClass:'custom-sparepiece',from:['g3','d2','g2'],to:['g2','e2','g1'],next:7})}},{id:7,previous:2,next:11,audio:{src:'img/audio/lesson_18/4.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br/>Select the correct option.',timeout:0,className:'no-animation'},options:{id:2,next:8,answer:['YES, the Black pawn can sucessfully promote.','No, the Black pawn can\'t successfully promote.'],rightAnswer:'No, the Black pawn can\'t successfully promote.',magnusWrongAnswer:{data:'Oops! Take a look.',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'8/8/8/2K1kp2/7P/8/8/8',assignmentClass:'custom-sparepiece'})}},{id:8,previous:2,next:null,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson18Activity2 */])({showIndicators:{allSides:true},position:'8/8/8/2K1kp2/7P/8/8/8',resultFen:'8/8/8/4k3/7P/8/8/5K2',assignmentClass:'custom-sparepiece',from:['c5','f5','c4','f4','d3','f3','d2','f2','e2'],to:['c4','f4','d3','f3','d2','f2','e2','f1','f1'],next:9})}},{id:9,previous:2,next:11,audio:{src:'img/audio/lesson_18/4.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br/>Select the correct option.',timeout:0,className:'no-animation'},options:{id:3,next:10,answer:['YES, the White pawn can sucessfully promote.','No, the White pawn can\'t successfully promote.'],rightAnswer:'No, the White pawn can\'t successfully promote.',magnusWrongAnswer:{data:'Oops! Take a look.',styleClass:'xs',waitTime:4000},validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:{allSides:true},position:'8/8/8/2K1kp2/7P/8/8/8',assignmentClass:'custom-sparepiece'})}},{id:10,previous:2,next:null,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson18Activity2 */])({showIndicators:{allSides:true},position:'8/8/8/2K1kp2/7P/8/8/8',resultFen:'7k/8/8/2K2p2/8/8/8/8',assignmentClass:'custom-sparepiece',from:['h4','e5','h5','f6','h6','f7','h7','g7'],to:['h5','f6','h6','f7','h7','g7','h8','h8'],next:11})}},{id:11,previous:2,next:12,video:{src:'img/videos/lesson_18/3.mp4',startTime:0,autoStartNext:true,next:12}},{id:12,previous:11,next:13,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'What is Black\'s best move?',answer:['pawn to h8 = Q','pawn to h6','pawn to h5','King to c6'],rightAnswer:'pawn to h5',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/2k1K2p/8/8/8/8/4P3/8'}),hint:true}}},{id:13,previous:11,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'It is Black\'s turn to move and White cannot stop Black from getting a new Queen only if;',answer:['Black plays Kf7','Black plays pawn to a7','Black plays pawn to e2','Black plays pawn to a5'],rightAnswer:'Black plays pawn to a5',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/8/p7/8/8/4p1K1/8/8'}),hint:true}}},{id:14,previous:11,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Black to move will get a new Queen only if;',answer:['Black moves his King to d6','White makes a big mistake','Black plays pawn captures pawn','Black pushes his pawn to a3'],rightAnswer:'Black pushes his pawn to a3',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/4k3/8/p3K3/1P6/8/8'}),hint:true}}},{id:15,previous:11,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'Black moves his King to f2 and then;',answer:['The White pawn moves one square and Black cannot catch him.','The White King will block the Black King out of the action.','The White pawn moves two squares and Black cannot catch him.','The White pawn moves two squares and Black can catch him.'],rightAnswer:'The White pawn moves two squares and Black cannot catch him.',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'xl',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/8/8/8/8/7K/P7/6k1'}),hint:true}}},{id:16,previous:11,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'What is the missing number in this sequence?',answer:['12','15','16','18'],rightAnswer:'16',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson18Activity3 */])({position:'8/8/8/8/8/8/8/8',squares:['.square-a5','.square-b4','.square-c3','.square-d2','.square-e1']}),hint:true}}},{id:17,previous:11,next:18,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'What is the last number in this sequence?',answer:['27','30','36','41'],rightAnswer:'36',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson18Activity4 */])({position:'8/8/8/8/8/8/8/8',squares:['.square-f6','.square-e5','.square-d4','.square-c3','.square-b2','.square-a1']}),hint:true}}},{id:18,previous:11,next:19,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'It is White\'s turn. Which pawn should she move RIGHT NOW?',answer:['a-pawn','b-pawn','c-pawn','d-pawn'],rightAnswer:'b-pawn',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/5k2/3p2p1/pPp2p2/5K2/2P3P1/P2P4/8'}),hint:true}}},{id:19,previous:11,next:20,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'Which player has more points on the board?',answer:['White has two more points','Black has two more points','Black has one more point','White has one more point'],rightAnswer:'Black has one more point',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'r2qkb1r/pppppppp/8/8/8/8/PPPPPPPP/NNNNKNNN'}),hint:true}}},{id:20,previous:11,next:21,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'After all the Rooks, all the Bishops, all the Knights and both the Queens in a chess game have been captured the situation is called:',answer:['Dinnertime!','Almost the end','A King and pawn endgame','The Middle Ages'],rightAnswer:'A King and pawn endgame',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/ppp2p1p/3p2p1/8/4PP2/P5P1/1PP4P/2K5'}),hint:true}}},{id:21,previous:11,next:22,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'After a King and pawn endgame appears on the board which winning plan makes sense?',answer:['Try to checkmate with just pawns.','Move in circles to tire out your opponent.','Suggest your opponent give up.','Work to promote a pawn into a new Queen.'],rightAnswer:'Work to promote a pawn into a new Queen.',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/ppp2p1p/3p2p1/8/4PP2/P5P1/1PP4P/2K5'}),hint:true}}},{id:22,previous:11,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Nineteen',styleClass:'xl'}}];var assets=['/img/background_17.png','/img/background_18.png','/img/background_19.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson18Activity1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson18Activity2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson18Activity3;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson18Activity4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__(2);
/**
 * @name lesson18Activity1
 * @function
 * @param { config }
 * @description: Number of squares
 */function lesson18Activity1(config){var position=config.position;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#chessBoard').addClass('custom-background-image-5x5');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+3)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display','none');var body='\n            <div class=\'activity-1-lesson-18\'>\n                <div class=\'first-column\'>\n                    <h4 class=\'input-rows\' id=\'tbl-cell-0\'></h4>\n                </div>\n                <div class=\'first-column\'>\n                    <h4 class=\'input-rows\' id=\'tbl-cell-1\'></h4>\n                </div>\n                <div class=\'first-column\'>\n                    <h4 class=\'input-rows\' id=\'tbl-cell-2\'></h4>\n                </div>\n                <div class=\'first-column\'>\n                    <h4 class=\'input-rows\' id=\'tbl-cell-3\'></h4>\n                </div>\n                <div class=\'first-column\'>\n                    <h4 class=\'input-rows\' id=\'tbl-cell-4\'></h4>\n                </div>\n            </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.left-box-content').html(body);var count=0;var timer=setInterval(function(){if(count>5){clearInterval(timer);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tbl-cell-'+count).html(count+1);count++;}},500);var timerTwo=setTimeout(function(){var count=0;var timer=setInterval(function(){if(count>5){clearInterval(timer);}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tbl-cell-'+count).html(count+1+' x '+(count+1)+' =   ');count++;}},500);},2500);var timerThree=setTimeout(function(){var count=0;var timer=setInterval(function(){if(count>5){clearInterval(timer);}if(count===0){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tbl-cell-'+count).html(count+1+' x '+(count+1)+' =  <input id="custom-input-'+(count+1)+'" class="custom-input" type="text" value="1"> <img src="img/yellow-arrow.svg" id="yellow-arrow"/>');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-e5').html('<h4 class="header-4">'+(count+1)+'</h4>');count++;}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tbl-cell-'+count).html(count+1+' x '+(count+1)+' =   <input id="custom-input-'+(count+1)+'" class="custom-input" type="text" placeholder="?">');count++;}},200);},5000);var timerFour=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-2').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-3').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-4').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-5').prop('disabled',true);});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-2').prop('disabled',false);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-3').prop('disabled',false);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-4').prop('disabled',false);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-5').prop('disabled',false);},22000);var firstInput,secondInput,thirdInput,fourthInput,data='';__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-2').keyup(function(){firstInput=this.value;if(firstInput){if(firstInput==='4'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-2').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d4').html('<h4 class="header-4">'+firstInput+'</h4>');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);data='OOPS!<br/>Try again!!';showMagnusMessage(data);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-2').val('');},1500);}}});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-3').keyup(function(){secondInput=this.value;if(secondInput){if(secondInput==='9'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-3').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-c3').html('<h4 class="header-4">'+secondInput+'</h4>');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);data='OOPS!<br/>Try again!!';showMagnusMessage(data);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-3').val('');},1500);}}});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-4').keyup(function(){thirdInput=this.value;var ValueOfFourthSquare=setInterval(valueFourthSquare,2000);function valueFourthSquare(){clearInterval(ValueOfFourthSquare);if(thirdInput){if(thirdInput==='16'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-4').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-b2').html('<h4 class="header-4">'+thirdInput+'</h4>');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);data='OOPS!<br/>Try again!!';showMagnusMessage(data);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-4').val('');},1500);}}}});});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-5').keyup(function(){fourthInput=this.value;var ValueOfFifthSquare=setInterval(valueFifthSquare,2000);function valueFifthSquare(){clearInterval(ValueOfFifthSquare);if(fourthInput){if(fourthInput==='25'){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-5').prop('disabled',true);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-a1').html('<h4 class="header-4">'+fourthInput+'</h4>');}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_3__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);data='OOPS!<br/>Try again!!';showMagnusMessage(data);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#custom-input-5').val('');},1500);}}}});});function showMagnusMessage(data){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:data,position:'right',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();},3000);}var timer=setInterval(function(){if(firstInput==='4'&&secondInput==='9'&&thirdInput==='16'&&fourthInput==='25'){clearInterval(timer);data='Well done John!';showMagnusMessage(data);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.header-4').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-1-lesson-18').remove();},3000);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,config.next,true);}});},7500);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous, .next-btn-container #next').on('click',function(){clearTimeout(timer);clearTimeout(timerTwo);clearTimeout(timerThree);clearTimeout(timerFour);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.speech-bubble').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.activity-1-lesson-18').remove();});};var chessConfig={config:{position:position},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson18Activity2
 * @function
 * @param { config }
 * @description: Animate moves
 */function lesson18Activity2(config){var position=config.position,next=config.next,from=config.from,to=config.to;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);var count=0;__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').on('click',function(){clearInterval(timer);});var timer=setInterval(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(from[count]+'-'+to[count]);if(count>=from.length-1){clearInterval(timer);if(config.resultFen){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.resultFen);}Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,false);}count++;},2000);};var chessConfig={config:{position:position},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson18Activity3
 * @function
 * @param { config }
 * @description: show a 5x5 board
 */function lesson18Activity3(config){var position=config.position,squares=config.squares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+3)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display','none');squares.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('font-size','22px').css('color','#ffe100').css('text-align','right');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-a5').text(1);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-b4').text(4);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-c3').text(9);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d2').text('?');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-e1').text(25);});};var chessConfig={config:{position:position},afterLoad:afterLoad};return chessConfig;}/*
* @name lesson18Activity4
* @function
* @param { config }
* @description: show a 6x6 board
*/function lesson18Activity4(config){var position=config.position,squares=config.squares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c:nth-child(-n+2)').css('display','none');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row-5277c .square-55d63:nth-last-child(-n+3)').css('display','none');squares.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).css('font-size','22px').css('color','#ffe100');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-f6').text(1);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-e5').text(4);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-d4').text(9);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-c3').text(16);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-b2').text(25);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-a1').text('?');});};var chessConfig={config:{position:position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_19/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_19/1.mp3',start:true,controls:false},directions:{timeout:1000,data:'<b>DIRECTIONS:</b> <br/> This activity is to see how many captures you can make on g4. Just focus on that one square.You play white.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson19Assignment */])({position:'3r1br1/3q3k/1p2bn1n/pPp1p1pp/P1PpPp2/3P1P1P/1R1KBNPN/2BQ1R2',studentMoves:['f3','h3','f2','h2','e2','d1'],fromMoves:['g5','h5','h6','f6','e6','g8','d7'],toMove:'g4',showIndicators:{allSides:true},wrongMessage:'Oops...! Try again.',next:2}),positionFen:'3r1br1/3q3k/1p2bn1n/pPp1p1pp/P1PpPp2/3P1P1P/1R1KBNPN/2BQ1R2 w - - 0 1'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_19/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_19/2.mp3',start:true,controls:false},directions:{timeout:1000,data:'<b>DIRECTIONS:</b> <br/>Both White Rooks are attacking black pieces. Which one should White capture first? <br/> You play White, your move.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson19Assignment2 */])({position:'1n2r1k1/3b1pp1/7p/8/3P3P/6P1/5P2/1R2R1K1',resultFen:'4R1k1/5p2/6pp/8/3P3P/6P1/5P2/6K1',next:4,failedMove:{studentMove:{from:['b1'],to:['b8']},computerMove:{from:['e8'],to:['b8']},captureStudentMove:{capturedPiece:['bN'],capturingPiece:['wR']},captureComputerMove:{capturedPiece:['wR'],capturingPiece:['bR']}},successMove:{studentMove:{from:['e1','b1','b8'],to:['e8','b8','e8']},computerMove:{from:['d7','g7'],to:['e8','g6']},captureStudentMove:{capturedPiece:['bR','bN','bB'],capturingPiece:['wR','wR','wR']},captureComputerMove:{capturedPiece:['wR'],capturingPiece:['bB']}},showIndicators:{allSides:true}}),positionFen:'1n2r1k1/3b1pp1/7p/8/3P3P/6P1/5P2/1R2R1K1 w - - 0 1'}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_19/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/lesson_19/3.mp3',start:true,controls:false},directions:{timeout:1000,data:'<b>DIRECTIONS:</b> <br/> You are going to play the next two moves for White. Look at all possible moves and captures.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson19Assignment3 */])({position:'2n1r1k1/5pp1/B6p/4n3/8/6BP/5PP1/R5K1',result:['2r3k1/5pp1/7p/4B3/8/7P/5PP1/R5K1','2B3k1/5pp1/7p/4r3/8/7P/5PP1/R5K1'],next:6,bishop1Moves:{studentMove:{from:['a6','g3'],to:['c8','e5']},computerMove:{from:['e8'],to:['c8']},captureStudentMove:{capturedPiece:['bN','bN'],capturingPiece:['wB','wB']},captureComputerMove:{capturedPiece:['wB'],capturingPiece:['bR']}},bishop2Moves:{studentMove:{from:['g3','a6'],to:['e5','c8']},computerMove:{from:['e8'],to:['e5']},captureStudentMove:{capturedPiece:['bN','bN'],capturingPiece:['wB','wB']},captureComputerMove:{capturedPiece:['wB'],capturingPiece:['bR']}},showIndicators:{allSides:true},wrongMessage:'Use a Bishop to make a capture'}),positionFen:'2n1r1k1/5pp1/B6p/4n3/8/6BP/5PP1/R5K1 w - - 0 1'}},{id:6,previous:4,next:7,video:{src:'img/videos/lesson_19/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:6,next:8,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'Find a successful double attack for White:',answer:['c5','Bxb6','Be2','Qd1'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson19Activity3 */])({showIndicators:true,starSquares:['.square-d6','.square-h5'],position:'r2qk2r/p2p1ppp/1pbbp3/7n/2P1P3/P1N1B3/1PQ2PPP/R3KB1R'}),hint:true},rightAnswer:'Qd1',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'sm'}},{id:8,previous:6,next:9,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'How many different checks, good and bad, <br/>does Black have on this move?',answer:['4','6','8','10'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'4Q3/2K5/2B5/3P2P1/1q1nP2P/4p3/1b2bRp1/1k6'}),hint:true},rightAnswer:'8',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'sm'}},{id:9,previous:6,next:10,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Which capture is best for White?',answer:['Qd1xg4','Bg5xf6','b4xa5','b4xc5'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'r2q2k1/pp3ppp/2p2n2/3p2B1/3P2b1/2P5/PP3PPP/R2Q1NK1'}),hint:true},rightAnswer:'Bg5xf6',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'sm'}},{id:10,previous:6,next:11,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'Which two-move plan will lead to <br/> checkmating the White King?',answer:['Re8xe3 and Re3-e1+','Re8-d8 and Rd7-d1+','Rd7-d1+ and Re8-d8','Rd7-h7 and Re8-h7'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'1k2r3/3r4/8/2P5/1P4p1/P3PpPp/5P1P/R6K'}),hint:true},rightAnswer:'Re8-d8 and Rd7-d1+',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:11,previous:6,next:12,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'This game will be a stalemate if the Black <br/> King can get to h8. What move will stop him?',answer:['h6-h7','Bd3-c4+','Bd3-g6+','Bd3-h7'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'8/5k2/7P/8/8/3B2K1/8/8'}),hint:true},rightAnswer:'Bd3-h7',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'sm'}},{id:12,previous:6,next:13,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'Which move will force the Black <br/> King into the corner?',answer:['Rf2-f8+','Re1-g1+','Rf2-g2+','Bd3-h7+'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'6k1/8/pq2p3/1p1n4/8/P2B4/1P3R2/K3R3'}),hint:true},rightAnswer:'Re1-g1+',validateAnswer:{rightAnswer:'1',userAnswer:-1},styleClass:'sm'}},{id:13,previous:6,next:14,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'Which White move will create checkmate?',answer:['Rg1-h1#','Rg1-g8#','Rf2-h2#','Rf2-f8#'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'7k/8/pq2p3/1pb5/8/P2B4/1P3R2/K5R1'}),hint:true},rightAnswer:'Rf2-h2#',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'sm'}},{id:14,previous:6,next:15,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'How can Black successfully get a Queen? <br/> (she isn’t captured right away)',answer:['Move the f-pawn twice then move the b-pawn twice.','Move each pawn once, then move each one more time.','Move the Black King to a3','Play the Black King to h8'],chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* createChessboard */])({showIndicators:true,position:'5k2/8/7K/8/8/1p1B1p2/8/8'}),hint:true},rightAnswer:'Move each pawn once, then move each one <br/> more time.',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'md'}},{id:15,previous:6,next:16,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'What is most important to look at when planning?',answer:['Blocking moves','Checks and captures','Your second move no matter what','Castling'],rightAnswer:'Checks and captures',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'sm'}},{id:16,previous:6,next:17,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'What is the second thing to look at when planning?',answer:['Your opponent’s next move','Your second move no matter what','How many pieces you’ve already captured','Castling'],rightAnswer:'Your opponent’s next move',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'md'}},{id:17,previous:6,next:null,audio:{src:null,stop:true},qa:{position:'center',result:true,nextLesson:'Lesson Twenty',styleClass:'xl'}}];var assets=['/img/background_14.png','/img/background_15.png','/img/background_16.png'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson19Assignment;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson19Assignment2;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson19Assignment3;
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson19Activity3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_user__ = __webpack_require__(4);
/**
* @name lesson19Assignment
* @function
* @param {config}
* @description: activity related task
*/function lesson19Assignment(config){var moveSpeed=1000,next=config.next,studentMoves=config.studentMoves,fromMoves=config.fromMoves,toMove=config.toMove,count=0,boardFen=void 0,capturingPieces=['bP','bN','bN','bB','bR','bQ'],capturingPiece=0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#next').click(function(){count=0;capturingPiece=0;});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#previous').click(function(){count=0;capturingPiece=0;});setTimeout(function(){computerMove();},5000);};function computerMove(piece){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(fromMoves[count]+'-'+toMove);if(piece){var move={captured:piece.charAt(1),color:'b'};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(capturingPieces[capturingPiece],move);capturingPiece++;},1000);}if(count===6){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Wow! That was a lot of captures just on the g4 square!',styleClass:'lg'});Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(5000,next,true);}count++;boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);},1000);}var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(!move.captured){var _boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(_boardFen+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';}else{Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(piece,move,false);}}};var onSnapEnd=function onSnapEnd(source,target,piece){if(target==='g4'&&studentMoves.includes(source)){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);setTimeout(function(){computerMove(piece);},1000);}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'wrong move!<br/>Try again!',styleClass:'xs',position:'left'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(boardFen+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);},1000);}};var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson19Assignment2
* @function
* @param {config}
* @description: activity related task
*/function lesson19Assignment2(config){var moveSpeed=1000,next=config.next,failedMoves=config.failedMove,successfullMoves=config.successMove,moves=null,computerCount=0,captureCount=0,studentCount=0,flag=false,newPosition=null;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.next-btn-container #next').click(function(){captureCount=0;computerCount=0;studentCount=0;moves=null;flag=false;newPosition=null;});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.back-btn-container #previous').click(function(){captureCount=0;computerCount=0;studentCount=0;moves=null;flag=false;newPosition=null;});var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(move.captured){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(piece,move,false);}}};var onSnapEnd=function onSnapEnd(source,target,piece){if(source==='b1'&&target==='b8'&&!flag){moves=failedMoves;}else if(source==='e1'&&target==='e8'){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.square-b1').addClass('auto-pointer-event');moves=successfullMoves;flag=true;}else if(computerCount===0){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'oops! </br>Try again',position:'left',styleClass:'xs'});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Move the piece to the correct <br/> position.',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},3000);}if(moves){if(studentCount<moves.studentMove.from.length){if(source===moves.studentMove.from[studentCount]&&target===moves.studentMove.to[studentCount]){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);studentCount++;computerMove(moves.computerMove);}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'oops! </br>Try again',position:'left',styleClass:'xs'});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Move the piece to the correct <br/> position.',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(newPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(newPosition+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},2000);}}}var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();if(boardFen===config.resultFen){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Nice job! </br> White is up by three points.',styleClass:'md'});captureCount=0;computerCount=0;studentCount=0;moves=null;flag=false;newPosition=null;Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(3000,next,true);}};function computerMove(computerMove){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(computerMove.from[computerCount]+'-'+computerMove.to[computerCount]);if(moves.captureComputerMove){if(captureCount===0){var move={captured:moves.captureComputerMove.capturedPiece[captureCount][1],color:moves.captureComputerMove.capturingPiece[captureCount].charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(moves.captureComputerMove.capturingPiece[captureCount],move,false);},moveSpeed);}captureCount++;}computerCount++;setTimeout(function(){if(computerMove.from.length===1){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'That wasn’t White’s best choice.Now try it with the other Rook first.',styleClass:'xl'});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.square-b1').addClass('none-pointer-event');computerCount=0;studentCount=0;captureCount=0;moves=null;flag=true;Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* hideCapturedPieces */])();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';}},2000);newPosition=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(newPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(newPosition+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);}var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson19Activity3
* @function
* @param {config}
* @description: activity 3 lesson 19
*/function lesson19Assignment3(config){var moveSpeed=1000,next=config.next,finalMoves=void 0,studentCount=void 0,computerCount=void 0,captureCount=void 0,newPosition=void 0,flag=void 0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);studentCount=0;computerCount=0;captureCount=0;newPosition=null;flag=false;finalMoves=null;};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */]);};__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.next-btn-container #next').click(function(){captureCount=0;computerCount=0;studentCount=0;finalMoves=null;newPosition=null;flag=false;});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.back-btn-container #previous').click(function(){captureCount=0;computerCount=0;studentCount=0;finalMoves=null;newPosition=null;flag=false;});var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var move=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game.move({from:source,to:target});if(move===null){return'snapback';}else{if(move.captured){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(piece,move,false);}}};var onSnapEnd=function onSnapEnd(source,target,piece){var boardFen=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();if(config.result.includes(boardFen)){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Nice job!'+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name,styleClass:'xs'});setTimeout(function(){captureCount=0;computerCount=0;studentCount=0;finalMoves=null;newPosition=null;flag=false;},2000);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* loadNextConfiguration */])(2000,next,true);}if(source==='a6'&&target==='c8'&&!flag){finalMoves=config.bishop1Moves;}else if(source==='g3'&&target==='e5'&&!flag){finalMoves=config.bishop2Moves;}else if(!flag){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(config.position);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(config.position+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';}if(finalMoves){flag=true;if(studentCount<finalMoves.studentMove.from.length){if(source===finalMoves.studentMove.from[studentCount]&&target===finalMoves.studentMove.to[studentCount]){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);studentCount++;computerMove(finalMoves.computerMove);}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_1__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'oops! </br>Try again',position:'left',styleClass:'xs'});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* showMagnus */])({data:'Move the piece to the correct <br/> position.',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(newPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(newPosition+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);return'snapback';},2000);}}}};function computerMove(computerMove){__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.move(computerMove.from[computerCount]+'-'+computerMove.to[computerCount]);if(finalMoves.captureComputerMove){if(captureCount===0){var move={captured:finalMoves.captureComputerMove.capturedPiece[captureCount][1],color:finalMoves.captureComputerMove.capturingPiece[captureCount].charAt(0)};setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showCapturedPieces */])(finalMoves.captureComputerMove.capturingPiece[captureCount],move,false);},moveSpeed);captureCount++;}}computerCount++;newPosition=__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].board.position(newPosition);__WEBPACK_IMPORTED_MODULE_2__components_chessBoard__["a" /* default */].game=new window.Chess(newPosition+__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */]);}var chessConfig={config:{position:config.position,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson19Activity3
* @function
* @param {config}
* @description: to fill squares with stars
*/function lesson19Activity3(config){var square=config.starSquares;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_3_jquery___default()(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.answer').click(function(e){e.preventDefault();square.forEach(function(element){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).append('<img class="star-img" src="/img/star.png" />');});});});};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);
var lessonConfig=[{id:0,previous:null,next:2,video:{src:'img/videos/lesson_20/1.mp4',startTime:0,autoStartNext:true,next:1}},{id:1,previous:0,next:2,audio:{src:'img/audio/lesson_20/1.mp3',start:true,controls:false},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["a" /* lesson20Assignment1 */])({showIndicators:{allSides:true},position:'rnbqkbnr/1p2pp1p/p2p2p1/2p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R',finalPosition:'rnbqkbnr/1p2pp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',resultFen:['r1bqkbnr/1p1npp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','r1bqkbnr/1p2pp1p/p1np2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rn1qkbnr/1p1bpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rnb1kbnr/1p1qpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rnbqkbnr/1p2pp1p/3p2p1/1pp5/3PP3/2N2N2/PPP2PPP/R1BQK2R'],arrowFrom:'square-b5',arrowTo:'square-d8',offset:[0,0,10,10],from:'f1',to:'b5',magnusText:'There are four possible blocks and one capture.<br>Find them all!',assignmentClass:'custom-sparepiece',next:2}),canvas:true,positionFen:'rnbqkbnr/1p2pp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R b - - 0 1'}},{id:2,previous:0,next:4,video:{src:'img/videos/lesson_20/2.mp4',startTime:0,autoStartNext:true,next:3}},{id:3,previous:2,next:4,audio:{src:'img/audio/lesson_20/2.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS:</b><br>This is a checkmate in three moves for White.<br>You play White.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson20Assignment2 */])({showIndicators:{allSides:true},position:'r1bq1r1k/1p3p2/p2p1p2/4p3/4PP2/P2Q4/1PP4P/1K1R2R1',resultFen:'r2q2rk/1p3p2/p2p1p2/4pP2/8/P6Q/1PP4P/1K1R2R1',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],moves:{studentMove:{from:['f4','e4','d3'],to:['f5','f5','h3']},computerMove:{from:['c8','f8'],to:['f5','g8']}},magnusText:'That move won\'t get you checkmate in 3',magnusInitialText:'Here\'s a hint!<br>Move the pawn to f5',next:4}),positionFen:'r1bq1r1k/1p3p2/p2p1p2/4p3/4PP2/P2Q4/1PP4P/1K1R2R1 w - - 0 1'}},{id:4,previous:2,next:6,video:{src:'img/videos/lesson_20/3.mp4',startTime:0,autoStartNext:true,next:5}},{id:5,previous:4,next:6,audio:{src:'img/audio/lesson_20/3.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>This is a checkmate in two moves for White.<br>You play White.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson20Assignment2 */])({showIndicators:{allSides:true},position:'7k/8/pR6/1p3K2/8/6P1/rP6/8',resultFen:'7k/8/pR4K1/1p6/8/6P1/rP6/8',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["f" /* BLACK_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["i" /* WHITE_INITIAL_MOVE */],moves:{studentMove:{from:['f5','b6'],to:['g6','b8']},computerMove:{from:['h8'],to:['g8']}},magnusText:'That\'s not going to get you to checkmate.',magnusInitialText:'Here\'s a hint!<br>Move the King to g6',next:6}),positionFen:'7k/8/pR6/1p3K2/8/6P1/rP6/8 w - - 0 1'}},{id:6,previous:4,next:8,video:{src:'img/videos/lesson_20/4.mp4',startTime:0,autoStartNext:true,next:7}},{id:7,previous:6,next:8,audio:{src:'img/audio/lesson_20/4.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>This is a checkmate in two moves for Black.<br>You move for Black.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["b" /* lesson20Assignment2 */])({showIndicators:{allSides:true},position:'k7/8/pp6/P2Pn3/8/6P1/RPP1r3/7K',resultFen:'k7/8/pp6/P2P4/8/5nP1/1PP4r/R6K',assignmentClass:'custom-sparepiece',restrictMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */],initialMoveOf:__WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* BLACK_INITIAL_MOVE */],moves:{studentMove:{from:['e5','e2'],to:['f3','h2']},computerMove:{from:['a2'],to:['a1']}},magnusText:'That\'s not going to get you to checkmate in two.',magnusInitialText:'Here\'s a hint!<br>Move the Knight to f3',next:8}),positionFen:'k7/8/pp6/P2Pn3/8/6P1/RPP1r3/7K b - - 0 1'}},{id:8,previous:6,next:11,video:{src:'img/videos/lesson_20/5.mp4',startTime:0,autoStartNext:true,next:9}},{id:9,previous:8,next:11,audio:{src:'img/audio/lesson_20/5.mp3',start:true,controls:false},directions:{data:'<b>DIRECTIONS</b><br>Place the Black Queen on the board to create checkmate.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson20Assignment3 */])({showIndicators:{allSides:true},position:'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/1K1NR2R',piecesArray:['bQ'],validatePieces:{'bQ':['a1']},pieceLimit:{bQ:1},fen:'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/qK1NR2R',pieceTheme:'simple_black_white',assignmentClass:'custom-sparepiece',next:11})}},{id:10,previous:9,next:11,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson20Assignment4 */])({showIndicators:{allSides:true},position:'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/qK1NR2R',assignmentClass:'custom-sparepiece',from:["square-g7"],to:["square-a1"],offset:[0,0,5,5],color:["#cc0000"],next:11}),canvas:true}},{id:11,previous:8,next:20,video:{src:'img/videos/lesson_20/6.mp4',startTime:0,autoStartNext:true,next:12}},{id:12,previous:11,next:20,directions:{data:'<b>DIRECTIONS</b><br>Place the Black Bishop on the board to create checkmate.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson20Assignment3 */])({showIndicators:{allSides:true},position:'1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/8/KNR5',piecesArray:['bB'],validatePieces:{'bB':['b2']},pieceLimit:{bB:2},fen:'1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/1b6/KNR5',pieceTheme:'simple_black_white',assignmentClass:'custom-sparepiece',next:14})}},{id:13,previous:12,next:20,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson20Assignment4 */])({showIndicators:{allSides:true},position:'1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/1b6/KNR5',assignmentClass:'custom-sparepiece',from:["square-b4","square-a3","square-b2"],to:["square-a2","square-b2","square-a1"],offset:[0,0,5,5],color:["#f9e420","#f9e420","#cc0000"],next:14}),canvas:true}},{id:14,previous:11,next:20,directions:{data:'<b>DIRECTIONS</b><br>Place the Black Knight on the board to create checkmate.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson20Assignment3 */])({showIndicators:{allSides:true},position:'1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP2P2/3R1RK1',piecesArray:['bN'],validatePieces:{'bN':['e2']},pieceLimit:{bN:1},fen:'1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP1nP2/3R1RK1',pieceTheme:'simple_black_white',assignmentClass:'custom-sparepiece',next:16})}},{id:15,previous:14,next:20,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson20Assignment4 */])({showIndicators:{allSides:true},position:'1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP1nP2/3R1RK1',assignmentClass:'custom-sparepiece',from:["square-h3","square-h3"],to:["square-g2","square-h1"],offset:[0,0,5,5],color:["#f9e420","#f9e420"],next:16}),canvas:true}},{id:16,previous:11,next:20,directions:{data:'<b>DIRECTIONS</b><br>Place the Black pawn on the board to create checkmate.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson20Assignment3 */])({showIndicators:{allSides:true},position:'1b4k1/1b3p2/6p1/7n/8/8/5P2/3R1RK1',piecesArray:['bP'],validatePieces:{'bP':['h2']},pieceLimit:{bP:3},fen:'1b4k1/1b3p2/6p1/7n/8/8/5P1p/3R1RK1',pieceTheme:'simple_black_white',assignmentClass:'custom-sparepiece',next:18})}},{id:17,previous:16,next:20,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson20Assignment4 */])({showIndicators:{allSides:true},position:'1b4k1/1b3p2/6p1/7n/8/8/5P1p/3R1RK1',assignmentClass:'custom-sparepiece',from:["square-b8","square-b7"],to:["square-h2","square-h1"],offset:[0,0,5,5],color:["#f9e420","#f9e420"],next:18}),canvas:true}},{id:18,previous:11,next:20,directions:{data:'<b>DIRECTIONS</b><br>Place the White Rook on the board to create checkmate.'},chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["c" /* lesson20Assignment3 */])({showIndicators:{allSides:true},position:'r4rk1/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',piecesArray:['wR'],validatePieces:{'wR':['h8']},pieceLimit:{wR:2},fen:'r4rkR/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',pieceTheme:'simple_black_white',assignmentClass:'custom-sparepiece',next:20})}},{id:19,previous:18,next:20,chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_0__assignments__["d" /* lesson20Assignment4 */])({showIndicators:{allSides:true},position:'r4rkR/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',assignmentClass:'custom-sparepiece',from:["square-g1","square-h1"],to:["square-g7","square-h8"],offset:[0,0,5,5],color:["#cc0000","#cc0000"],next:20}),canvas:true}},{id:20,previous:11,next:21,video:{src:'img/videos/lesson_20/7.mp4',startTime:0,autoStartNext:true,next:21}},{id:21,previous:20,next:22,audio:{src:'img/audio/qa_bgm.mp3',start:true,loop:true},qa:{id:0,question:'White is two moves from checkmate. What move can White make to block the King\'s escape?',answer:['g2-g4','Re1-e7','Re1-e8+','f5-f6'],rightAnswer:'f5-f6',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'7k/5p1p/p6p/1p3P2/qp6/2P4P/P1P2PP1/K3R3'}),hint:true}}},{id:22,previous:20,next:23,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:1,question:'White has four possible checks, which one is checkmate?',answer:['Rc6-d6+','Rc6-c5+','Bd3-c4+','Bd3-e4+'],rightAnswer:'Bd3-e4+',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'md',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/p4p2/2R5/3k4/1q1P4/3BK3/5P2/8'}),hint:true}}},{id:23,previous:20,next:24,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:2,question:'Placing two BLACK Queens on which pair of squares makes a checkmate?',answer:['d6 and e7','b4 and d2','c2 and e4','h2 and h3'],rightAnswer:'c2 and e4',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/1k6/8/8/8/4K3/8/8'}),hint:true}}},{id:24,previous:20,next:25,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:3,question:'Placing two WHITE Queens on which pair of squares makes a checkmate?',answer:['d6 and d7','b4 and c4','a5 and b6','b6 and d8'],rightAnswer:'b6 and d8',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/1k6/8/8/8/4K3/8/8'}),hint:true}}},{id:25,previous:20,next:26,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:4,question:'To checkmate White in just two moves which move should Black play first?',answer:['Kd3-e3','Rb7-e7+','Rb7-b1+','Rb7-f7'],rightAnswer:'Rb7-f7',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/1r6/8/8/8/3k4/8/4K3'}),hint:true}}},{id:26,previous:20,next:27,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:5,question:'To checkmate White in just two moves which move should Black play first?',answer:['Re7-e3+','Re7-b7+','Rc6-b6+','Rc6-c3+'],rightAnswer:'Re7-b7+',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'8/4r3/2r3k1/8/8/1K6/8/8'}),hint:true}}},{id:27,previous:20,next:28,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:6,question:'If only very good moves are made by both players for the rest of this game what will the end result be?',answer:['White will checkmate Black','Black will checkmate White','The game must be a tie','It is impossible to tell, yet'],rightAnswer:'White will checkmate Black',validateAnswer:{rightAnswer:0,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/8/8/8/3K4/2R5/8/8'}),hint:true}}},{id:28,previous:20,next:29,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:7,question:'If only very good moves are made by both players for the rest of this game what will the end result be?',answer:['White will checkmate Black','Black will checkmate White','The game must be a tie','It is impossible to tell, yet'],rightAnswer:'The game must be a tie',validateAnswer:{rightAnswer:2,userAnswer:-1},styleClass:'lg',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/8/8/4B3/8/4B3/5K2/8'}),hint:true}}},{id:29,previous:20,next:30,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:8,question:'If only very good moves are made by both players for the rest of this game what will the end result be?',answer:['White will checkmate Black','Black will checkmate White','The game must be a tie','It is impossible to tell, yet'],rightAnswer:'Black will checkmate White',validateAnswer:{rightAnswer:1,userAnswer:-1},styleClass:'xxxl',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'6k1/1q6/8/8/3K4/8/8/8'}),hint:true}}},{id:30,previous:20,next:31,audio:{src:'img/audio/qa_bgm.mp3',startTime:null},qa:{id:9,question:'If only very good moves are made by both players for the rest of this game what will the end result be?',answer:['White will checkmate Black','Black will checkmate White','The game must be a tie','It is impossible to tell, yet'],rightAnswer:'It is impossible to tell, yet',validateAnswer:{rightAnswer:3,userAnswer:-1},styleClass:'xxxl',chessboard:{board:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createChessboard */])({showIndicators:true,position:'4K1k1/5pb1/6b1/8/2Q5/8/8/8'}),hint:true}}},{id:31,previous:20,next:32,audio:{src:null,stop:true},qa:{position:'center',nextLesson:'None',result:true,styleClass:'xl',timeout:7000,next:32,lesson20:true}},{id:32,previous:20,next:null,video:{src:'img/videos/lesson_20/8.mp4',startTime:0,autoStartNext:true,next:null}}];var assets=['/img/background_9.png','/img/background_10.png','/img/box.png','/img/chesspieces/assignment_10_1/bK.svg','/img/chesspieces/assignment_10_1/bQ.svg','/img/chesspieces/assignment_10_1/bR.svg','/img/chesspieces/assignment_10_1/bB.svg','/img/chesspieces/assignment_10_1/bN.svg','/img/chesspieces/assignment_10_1/bP.svg'];var config={config:lessonConfig,assets:assets};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lesson20Assignment1;
/* harmony export (immutable) */ __webpack_exports__["b"] = lesson20Assignment2;
/* harmony export (immutable) */ __webpack_exports__["c"] = lesson20Assignment3;
/* harmony export (immutable) */ __webpack_exports__["d"] = lesson20Assignment4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chessBoard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_user__ = __webpack_require__(4);
/**
 * @name lesson20Assignment1
 * @function
 * @param { config }
 * @description: Select all moves.
 */function lesson20Assignment1(config){var next=config.next,initialBoardPosition=config.position,finalBoardPosition=config.finalPosition,timer=void 0,timer1=void 0,timer2=void 0,timer3=void 0,results=config.resultFen,squares=[1,2,3,4,5],count=0,pieces=['a6','b8','c8','d8'],star=0,offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];}var afterLoad=function afterLoad(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function(){var body='<div class=\'right-content-holder\'>\n                <div class=\'square-box\' id=\'box-1\'><p class=\'box-content\'>1</p></div>\n                <div class=\'square-box\' id=\'box-2\'><p class=\'box-content\'>2</p></div>\n                <div class=\'square-box\' id=\'box-3\'><p class=\'box-content\'>3</p></div>\n                <div class=\'square-box\' id=\'box-4\'><p class=\'box-content\'>4</p></div>\n                <div class=\'square-box\' id=\'box-5\'><p class=\'box-content\'>5</p></div>\n            </div>';__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-box-content').html(body);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-content-holder').remove();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-btn-container #previous').click(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-content-holder').remove();});});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next, .back-btn-container #previous').click(function(){star=0;clearTimeout(timer);clearTimeout(timer1);clearTimeout(timer2);clearTimeout(timer3);results=['r1bqkbnr/1p1npp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','r1bqkbnr/1p2pp1p/p1np2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rn1qkbnr/1p1bpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rnb1kbnr/1p1qpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R','rnbqkbnr/1p2pp1p/3p2p1/1pp5/3PP3/2N2N2/PPP2PPP/R1BQK2R'];});firstComputerMove();timer=setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:config.magnusText,position:'left',styleClass:'xxl'},1000);},5000);};var onDragStart=function onDragStart(source,piece,position,orientation){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,__WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* WHITE_PIECE_SEARCH_KEY */]);};function firstComputerMove(){timer1=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(config.from+'-'+config.to);},2000);timer2=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,config.arrowFrom,config.arrowTo,offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,"#cc0000");},3000);timer3=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('hide').removeClass('show');},6000);}function hideMagnus(){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},3000);}var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){if(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* validateMove */])(source,target,piece,false)!=='snapback'){return;}else{count++;if(count>=2){pieces.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-'+element).addClass('temporary-border');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.temporary-border').css('border','1px solid red');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.temporary-border').css('border','');},4000);hideMagnus();}}};var onSnapEnd=function onSnapEnd(source,target,piece){clearTimeout(timer);hideMagnus();var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(results.includes(boardFen)){var index=results.indexOf(boardFen);if(index>-1){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#box-'+squares[star]).css('background-color','green');__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#box-'+squares[star]+'>.box-content').remove();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#box-'+squares[star]).css('margin-top','16px').prepend('<img class="yellow-star" style="height: 100%; width: 100%;" src="/img/yellow_star_1.svg" />');results.splice(index,1);star++;}if(results.length===0){setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Good job!',position:'left',styleClass:'md'});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.right-content-holder').remove();Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(3000,next,true);},1000);}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(finalBoardPosition);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(finalBoardPosition+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);},2000);}else{if(count>=2){count=0;pieces.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.square-'+element).addClass('temporary-border');});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.temporary-border').css('border','1px solid red');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.temporary-border').css('border','');},4000);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'These are the pieces you need to give attention to!',position:'left',styleClass:'lg'});}else{count++;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s not the right move',position:'left',styleClass:'md'});hideMagnus();__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(finalBoardPosition);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(finalBoardPosition+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);return'snapback';}__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(initialBoardPosition);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(initialBoardPosition+__WEBPACK_IMPORTED_MODULE_2__utils_constants__["c" /* BLACK_INITIAL_MOVE */]);firstComputerMove();return'snapback';}};var chessConfig={config:{position:initialBoardPosition,next:next,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:1000},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson20Assignment2
 * @function
 * @param { config }
 * @description: Make a mate
 */function lesson20Assignment2(config){var next=config.next,moveSpeed=1000,initialBoardPosition=config.position,magnusText=config.magnusText,magnusInitialText=config.magnusInitialText,timer=void 0,initialTimer=void 0,moves=config.moves,totalStudentMoves=moves.studentMove.from.length,totalComputerMoves=moves.computerMove.from.length,studentFromCount=0,studentToCount=0,computerFromCount=0,computerToCount=0,board=void 0;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.next-btn-container #next, .back-btn-container #previous').click(function(){studentFromCount=0;studentToCount=0;computerFromCount=0;computerToCount=0;clearTimeout(initialTimer);clearTimeout(timer);});initialTimer=setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:magnusInitialText,position:'left',styleClass:'lg'},1000);},5000);};var onDragStart=function onDragStart(source,piece,position,orientation){board=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* restrictMove */])(piece,config.restrictMoveOf);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){// return validateMove(source, target, piece, false);
__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game.move({from:source,to:target});};var onSnapEnd=function onSnapEnd(source,target,piece){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');clearTimeout(initialTimer);if(studentFromCount<totalStudentMoves&&studentToCount<totalStudentMoves){if(source===moves.studentMove.from[studentFromCount]&&target===moves.studentMove.to[studentToCount]){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* CORRECT_ANSWER_AUDIO */]);studentFromCount++;studentToCount++;if(studentFromCount===totalStudentMoves&&studentToCount===totalStudentMoves){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'Nice job '+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'md'});Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next,true);}computerMove();}else{__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* WRONG_ANSWER_AUDIO */]);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'That\'s not the right move',position:'left',styleClass:'md'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('bubble-hide');},3000);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(board);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(board+config.initialMoveOf);}}function computerMove(){if(computerFromCount<totalComputerMoves&&computerToCount<totalComputerMoves){timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.move(moves.computerMove.from[computerFromCount]+'-'+moves.computerMove.to[computerToCount]);computerFromCount++;computerToCount++;},2000);var boardFen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.position(boardFen);__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].game=new window.Chess(board+config.initialMoveOf);}}};var chessConfig={config:{next:next,magnusText:magnusText,position:initialBoardPosition,onDragStart:onDragStart,onDrop:onDrop,onSnapEnd:onSnapEnd,draggable:true,sparePieces:true,moveSpeed:moveSpeed},afterLoad:afterLoad};return chessConfig;}/**
 * @name lesson20Assignment3
 * @function
 * @param { config }
 * @description: Place the piece in the right square
 */function lesson20Assignment3(config){var position=config.position,next=config.next,fen=config.fen,pieceLimit=config.pieceLimit,piecesArray=config.piecesArray?config.piecesArray:[],validatePieces=config.validatePieces?config.validatePieces:[],tryCount=2;var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);};var onDragStart=function onDragStart(source,piece,position,orientation){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* validateDrag */])(piece,pieceLimit[piece]);};var onDrop=function onDrop(source,target,piece,newPos,oldPos,orientation){var bubbleConfig={data:'Good job '+__WEBPACK_IMPORTED_MODULE_4__classes_user__["a" /* default */].user.name+'!',position:'left',styleClass:'xs'};validatePosition(piecesArray.length,fen,next,bubbleConfig,false,true);if(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true)==='trash'){if(tryCount===0){setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])({data:'This is where you need to place the piece',position:'left',styleClass:'lg'});},1000);tryCount=2;Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(4000,next-1,false);}tryCount--;}return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* validateDrop */])(piece,pieceLimit[piece],target,validatePieces,true);};function validatePosition(pieceLimit,resultFen,next){var bubbleConfig=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var isQA=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var celebrationSound=arguments[5];if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".piece-417db").length>=12+pieceLimit){setTimeout(function(){var fen=__WEBPACK_IMPORTED_MODULE_3__components_chessBoard__["a" /* default */].board.fen();if(fen===resultFen){if(celebrationSound){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('audio-play',__WEBPACK_IMPORTED_MODULE_2__utils_constants__["b" /* ACTIVITY_SUCCESS_AUDIO */]);}Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* showMagnus */])(bubbleConfig);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(2000,next-1,celebrationSound);}},100);}}var chessConfig={config:{position:position,draggable:true,dropOffBoard:'trash',sparePieces:true,onDrop:onDrop,onDragStart:onDragStart,pieceTheme:'img/chesspieces/'+config.pieceTheme+'/{piece}.svg'},afterLoad:afterLoad};return chessConfig;}/**
* @name lesson20Assignment4
* @function
* @param {config}
* @description: chess board related task
*/function lesson20Assignment4(config){var offsetFromx=null,offsetFromy=null,offsetTox=null,offsetToy=null,from=config.from,to=config.to,fromCount=from.length,toCount=to.length,color=config.color,colorCount=color.length;if(config.offset){offsetFromx=config.offset[0];offsetFromy=config.offset[1];offsetTox=config.offset[2];offsetToy=config.offset[3];}var afterLoad=function afterLoad(){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* prepareChessboard */])(config);__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myCanvas').addClass('show').removeClass('hide');var c=document.getElementById("myCanvas");var ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);setTimeout(function(){while(fromCount>0&&toCount>0){Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* plotArrow */])(ctx,from[fromCount-1],to[toCount-1],offsetFromx,offsetFromy,offsetTox,offsetToy,null,null,color[colorCount-1]);fromCount--;toCount--;colorCount--;}},1000);setTimeout(function(){ctx.clearRect(0,0,c.width,c.height);Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* loadNextConfiguration */])(500,config.next,false);},3000);};var chessConfig={config:{position:config.position},afterLoad:afterLoad};return chessConfig;}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(68);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(70)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(69)(undefined);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: \"GOTHIC\";\n  src: url(\"/font/GOTHIC.TTF\") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"GOTHIC-BOLD\";\n  src: url(\"/font/GOTHICB.TTF\") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"PatrickHand-Regular\";\n  src: url(\"/font/PatrickHand-Regular.ttf\") format(\"truetype\"); }\n\n.flex, .flex-stretch {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex; }\n\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-nowrap, .flex-stretch {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-fixed {\n  -ms-flex: 0 0 initial;\n  -webkit-box-flex: 0;\n  flex: 0 0 initial; }\n\n.flex-grow {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n.flex-nogrow {\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.flex-stretch {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .flex-stretch {\n      -ms-flex-preferred-size: auto !important;\n          flex-basis: auto !important;\n      padding-top: 4px; } }\n\n.flex-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-end {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-baseline {\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-space-between {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-space-around {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-bottom {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-top {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-bottom {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-top {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-right {\n  margin-left: auto; }\n\n.flex-left {\n  margin-right: auto; }\n\n.flex-full {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.flex-row {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n\n.flex-column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.flex-display {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.title-bold {\n  font-family: GOTHIC-BOLD;\n  font-size: 16px;\n  letter-spacing: 1.5px; }\n\n.sub-title-bold {\n  font-family: GOTHIC-BOLD;\n  font-size: 12px;\n  letter-spacing: 0; }\n\n.full-width {\n  width: 100%; }\n\n.full-height {\n  height: 100%; }\n\n.stretch {\n  width: 100%;\n  height: 100%; }\n\n.stretch-absolute {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto; }\n\n.padding {\n  padding: 15px; }\n\n.padding-left {\n  padding-left: 15px; }\n\n.btn {\n  cursor: pointer; }\n\nbutton {\n  border: none; }\n  button:focus {\n    outline: 0; }\n\n.hide {\n  display: none !important; }\n\n.show {\n  display: block !important; }\n\n.show-flex {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important; }\n\n.visible {\n  visibility: visible; }\n\n.invisible {\n  visibility: hidden; }\n\n.show-back {\n  z-index: 0;\n  visibility: visible; }\n\n.show-front {\n  z-index: 1;\n  visibility: visible; }\n\n.no-action {\n  pointer-events: none; }\n\n@font-face {\n  font-family: \"GOTHIC\";\n  src: url(\"/font/GOTHIC.TTF\") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"GOTHIC-BOLD\";\n  src: url(\"/font/GOTHICB.TTF\") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"PatrickHand-Regular\";\n  src: url(\"/font/PatrickHand-Regular.ttf\") format(\"truetype\"); }\n\n.flex, .flex-stretch {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex; }\n\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-nowrap, .flex-stretch {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-fixed {\n  -ms-flex: 0 0 initial;\n  -webkit-box-flex: 0;\n  flex: 0 0 initial; }\n\n.flex-grow {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n.flex-nogrow {\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.flex-stretch {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .flex-stretch {\n      -ms-flex-preferred-size: auto !important;\n          flex-basis: auto !important;\n      padding-top: 4px; } }\n\n.flex-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-end {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-baseline {\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-space-between {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-space-around {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-bottom {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-vertical-top {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-bottom {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-horizontal-top {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-right {\n  margin-left: auto; }\n\n.flex-left {\n  margin-right: auto; }\n\n.flex-full {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.flex-row {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n\n.flex-column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.flex-display {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.title-bold {\n  font-family: GOTHIC-BOLD;\n  font-size: 16px;\n  letter-spacing: 1.5px; }\n\n.sub-title-bold {\n  font-family: GOTHIC-BOLD;\n  font-size: 12px;\n  letter-spacing: 0; }\n\n.full-width {\n  width: 100%; }\n\n.full-height {\n  height: 100%; }\n\n.stretch {\n  width: 100%;\n  height: 100%; }\n\n.stretch-absolute {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto; }\n\n.padding {\n  padding: 15px; }\n\n.padding-left {\n  padding-left: 15px; }\n\n.btn {\n  cursor: pointer; }\n\nbutton {\n  border: none; }\n  button:focus {\n    outline: 0; }\n\n.hide {\n  display: none !important; }\n\n.show {\n  display: block !important; }\n\n.show-flex {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important; }\n\n.visible {\n  visibility: visible; }\n\n.invisible {\n  visibility: hidden; }\n\n.show-back {\n  z-index: 0;\n  visibility: visible; }\n\n.show-front {\n  z-index: 1;\n  visibility: visible; }\n\n.no-action {\n  pointer-events: none; }\n\n.chessboard-container .chessboard .black-3c85d, .chessboard-container .chessboard .white-1e1d7, .chessboard-container .chessboard .square-55d63 {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\n\n.chessboard-container .chessboard .board-b72b1 {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box; }\n\n.chessboard-container .chessboard {\n  width: 70%;\n  position: relative; }\n  .chessboard-container .chessboard .board-b72b1 {\n    border: none; }\n  .chessboard-container .chessboard .black-3c85d {\n    background-color: #6DA3D9; }\n  .chessboard-container .chessboard .white-1e1d7 {\n    background-color: #F9F4ED; }\n  .chessboard-container .chessboard .row-5277c:nth-child(8) .square-55d63 {\n    border-bottom: 1px solid #6DA3D9; }\n  .chessboard-container .chessboard .row-5277c:nth-child(1) .square-55d63 {\n    border-top: 1px solid #6DA3D9; }\n  .chessboard-container .chessboard .row-5277c .square-55d63:nth-child(8) {\n    border-right: 1px solid #6DA3D9; }\n  .chessboard-container .chessboard .row-5277c .square-55d63:nth-child(1) {\n    border-left: 1px solid #6DA3D9; }\n  .chessboard-container .chessboard.indicators {\n    padding: 6%;\n    background-image: url(/img/chessboard_indication.svg);\n    background-repeat: no-repeat; }\n    .chessboard-container .chessboard.indicators.all-sides {\n      background-image: url(/img/chessboard_indication_full.svg); }\n    .chessboard-container .chessboard.indicators.custom-background-image-5x5 {\n      background-image: url(/img/chess_5x5.svg); }\n    .chessboard-container .chessboard.indicators.custom-background-image-4x4 {\n      background-image: url(/img/chess_4x4.svg); }\n  .chessboard-container .chessboard .numeric-fc462, .chessboard-container .chessboard .alpha-d2270 {\n    display: none; }\n  .chessboard-container .chessboard.assignment .white-coordinate {\n    background-color: #F9F4ED; }\n  .chessboard-container .chessboard.assignment div[data-square].filled-square {\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    -webkit-box-shadow: inset 0 0 0 5px #8a2023;\n            box-shadow: inset 0 0 0 5px #8a2023; }\n    .chessboard-container .chessboard.assignment div[data-square].filled-square.success {\n      -webkit-box-shadow: inset 0 0 0 5px #0BB466;\n              box-shadow: inset 0 0 0 5px #0BB466; }\n  .chessboard-container .chessboard.assignment div[data-square].filled-yellow-square {\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    -webkit-box-shadow: inset 0 0 0 5px #f4ff25;\n            box-shadow: inset 0 0 0 5px #f4ff25; }\n    .chessboard-container .chessboard.assignment div[data-square].filled-yellow-square.success {\n      -webkit-box-shadow: inset 0 0 0 5px #0BB466;\n              box-shadow: inset 0 0 0 5px #0BB466; }\n  .chessboard-container .chessboard.assignment div[data-square].filled-cell {\n    position: relative; }\n    .chessboard-container .chessboard.assignment div[data-square].filled-cell::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background: yellow;\n      opacity: 0.8; }\n  .chessboard-container .chessboard.assignment div[data-square].filled-cell-red {\n    position: relative; }\n    .chessboard-container .chessboard.assignment div[data-square].filled-cell-red::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background: #ba0303;\n      opacity: 0.8; }\n  .chessboard-container .chessboard.assignment.assignment-1-1 .row-5277c .square-55d63 {\n    border-top: 1px solid #6DA3D9;\n    border-left: 1px solid #6DA3D9; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .row-5277c .square-55d63:nth-child(4) {\n    border-right: 2px solid #BC371C; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .row-5277c .square-55d63:nth-child(5) {\n    border-left: 2px solid #BC371C; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .row-5277c:nth-child(4) .square-55d63 {\n    border-bottom: 2px solid #BC371C; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .row-5277c:nth-child(5) .square-55d63 {\n    border-top: 2px solid #BC371C; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .chessboard-63f37 .piece-417db {\n    visibility: hidden; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left {\n    left: -37%;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left .spare-pieces-7492f img {\n      margin-bottom: 10px;\n      margin-right: 10px; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left img[data-piece=\"bK\"] {\n      -webkit-box-ordinal-group: 3;\n          -ms-flex-order: 2;\n              order: 2; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left img[data-piece=\"bQ\"] {\n      -webkit-box-ordinal-group: 2;\n          -ms-flex-order: 1;\n              order: 1; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left img[data-piece=\"wK\"] {\n      -webkit-box-ordinal-group: 3;\n          -ms-flex-order: 2;\n              order: 2; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .sparepieces_container_left img[data-piece=\"wQ\"] {\n      -webkit-box-ordinal-group: 2;\n          -ms-flex-order: 1;\n              order: 1; }\n  .chessboard-container .chessboard.assignment.assignment-2-2 .cp {\n    position: absolute;\n    visibility: hidden;\n    height: 120px;\n    width: 80px; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .cp.bK {\n      background-image: url(/img/chesspieces/assignment_2_2/bK.svg);\n      top: 17%;\n      right: 21%; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .cp.bQ {\n      background-image: url(/img/chesspieces/assignment_2_2/bQ.svg);\n      top: 17%;\n      left: 21%; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .cp.wK {\n      background-image: url(/img/chesspieces/assignment_2_2/wK.svg);\n      top: 60%;\n      right: 21%; }\n    .chessboard-container .chessboard.assignment.assignment-2-2 .cp.wQ {\n      background-image: url(/img/chesspieces/assignment_2_2/wQ.svg);\n      top: 60%;\n      left: 21%; }\n  .chessboard-container .chessboard.assignment.assignment-7-3 img[data-piece=\"bK\"], .chessboard-container .chessboard.assignment.assignment-7-4 img[data-piece=\"bK\"] {\n    display: none; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .sparepieces_container_left {\n    left: -15%; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .piece-417db {\n    display: block; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .spare-pieces-bottom-ae20f {\n    display: none; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .row-5277c .highlight2-9c5d2 {\n    -webkit-box-shadow: none;\n            box-shadow: none; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .row-5277c .square-55d63:nth-child(1) {\n    border: none;\n    background: transparent; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .row-5277c .square-55d63:not(:nth-child(1)) {\n    background: transparent;\n    border: none; }\n  .chessboard-container .chessboard.assignment.assignment-10-1 .row-5277c:nth-child(1) .square-55d63, .chessboard-container .chessboard.assignment.assignment-10-1 .row-5277c:nth-child(8) .square-55d63 {\n    background: transparent;\n    border: none;\n    -webkit-box-shadow: none;\n            box-shadow: none; }\n  .chessboard-container .chessboard.assignment.assignment-16-2 {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .chessboard-63f37 {\n      background-color: #6f9be2;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 50%;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .board-b72b1 {\n      height: 105%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c {\n      background: transparent;\n      padding-bottom: 22px; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-c3 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-c4 {\n        border-radius: 50%;\n        border: 1px solid #000000; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-c5 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-c6 {\n        border-radius: 50%;\n        border: 1px solid #000000; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-c7 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-e7 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-e6 {\n        border-radius: 50%;\n        border: 1px solid #000000; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-e5 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-e4 {\n        border-radius: 50%;\n        border: 1px solid #000000; }\n      .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-e3 {\n        border-radius: 50%;\n        border: 1px solid #000000;\n        background-color: #ffffff; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c:nth-child(1) {\n      display: none; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c:nth-last-child(-n+2) {\n      display: none; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-55d63:nth-child(-n+2) {\n      display: none; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-55d63:nth-child(4) {\n      display: none; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-55d63:nth-child(3) {\n      margin-right: 15px; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 .row-5277c .square-55d63:nth-last-child(-n+4) {\n      display: none; }\n    .chessboard-container .chessboard.assignment.assignment-16-2 #imgOne {\n      height: 100%; }\n  .chessboard-container .chessboard.assignment.custom-background-image-4x4 {\n    background-image: url(/img/chess_4x4.svg); }\n  .chessboard-container .chessboard.custom-sparepiece .spare-pieces-7492f {\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    height: 100%;\n    padding: 30% 0 !important;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap; }\n  .chessboard-container .chessboard.custom-sparepiece.show-center .spare-pieces-7492f {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n\n.chessboard-container.hint-chessboard {\n  width: 100% !important;\n  height: auto !important; }\n  .chessboard-container.hint-chessboard .chessboard {\n    width: 85%; }\n    .chessboard-container.hint-chessboard .chessboard.indicators {\n      padding: 8%; }\n\n.chess-app {\n  background-size: cover;\n  background-repeat: no-repeat; }\n\n.chess-app .page-body .right-box .volume-control .volume-icon, .speech-bubble .speech .bubble, .select-box :after {\n  background-size: contain;\n  background-repeat: no-repeat; }\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: GOTHIC;\n  background: #000000;\n  min-width: 1080px;\n  overflow-y: hidden;\n  overflow-x: hidden; }\n\n.blue-star {\n  position: absolute;\n  height: 25px;\n  width: 25px; }\n\nbody:before {\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n  z-index: -1;\n  font-family: PatrickHand-Regular;\n  left: -999em;\n  content: url(/img/volume.svg) url(/img/mute.svg) url(/img/thinking_bubble.svg) url(/img/dragon.png) url(/img/bubble_down.svg) url(/img/chessboard_indication.svg) url(/img/chessboard_indication_full.svg) url(/img/dropdown.png) url(/img/chesspieces/simple_black_white/bK.svg) url(/img/chesspieces/simple_black_white/bQ.svg) url(/img/chesspieces/simple_black_white/bR.svg) url(/img/chesspieces/simple_black_white/bB.svg) url(/img/chesspieces/simple_black_white/bN.svg) url(/img/chesspieces/simple_black_white/bP.svg) url(/img/chesspieces/simple_black_white/wK.svg) url(/img/chesspieces/simple_black_white/wQ.svg) url(/img/chesspieces/simple_black_white/wR.svg) url(/img/chesspieces/simple_black_white/wB.svg) url(/img/chesspieces/simple_black_white/wN.svg) url(/img/chesspieces/simple_black_white/wP.svg); }\n\n.chessboard-container canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0; }\n\ntable, tr, th, td {\n  border: 1px solid black;\n  border-collapse: collapse; }\n\n.star-icon {\n  height: 25px;\n  width: 25px;\n  position: absolute;\n  top: 15px;\n  left: 14px; }\n\n.chess-app.lesson-0 {\n  background-image: url(\"/img/background_0.png\"); }\n\n.chess-app.lesson-1 {\n  background-image: url(\"/img/background_1.png\"); }\n\n.chess-app.lesson-2 {\n  background-image: url(\"/img/background_2.png\"); }\n\n.chess-app.lesson-3 {\n  background-image: url(\"/img/background_3.png\"); }\n\n.chess-app.lesson-4 {\n  background-image: url(\"/img/background_4.png\"); }\n\n.chess-app.lesson-5 {\n  background-image: url(\"/img/background_5.png\"); }\n\n.chess-app.lesson-6 {\n  background-image: url(\"/img/background_6.png\"); }\n\n.chess-app.lesson-7 {\n  background-image: url(\"/img/background_7.png\"); }\n\n.chess-app.lesson-8 {\n  background-image: url(\"/img/background_8.png\"); }\n\n.chess-app.lesson-9 {\n  background-image: url(\"/img/background_9.png\"); }\n\n.chess-app.lesson-10 {\n  background-image: url(\"/img/background_10.png\"); }\n\n.chess-app.lesson-11 {\n  background-image: url(\"/img/background_11.png\"); }\n\n.chess-app.lesson-12 {\n  background-image: url(\"/img/background_12.png\"); }\n\n.chess-app.lesson-13 {\n  background-image: url(\"/img/background_13.png\"); }\n\n.chess-app.lesson-14 {\n  background-image: url(\"/img/background_14.png\"); }\n\n.chess-app.lesson-15 {\n  background-image: url(\"/img/background_15.png\"); }\n\n.chess-app.lesson-16 {\n  background-image: url(\"/img/background_16.png\"); }\n\n.chess-app.lesson-17 {\n  background-image: url(\"/img/background_17.png\"); }\n\n.chess-app.lesson-18 {\n  background-image: url(\"/img/background_18.png\"); }\n\n.chess-app.lesson-19 {\n  background-image: url(\"/img/background_19.png\"); }\n\n.chess-app.lesson-20 {\n  background-image: url(\"/img/background_20.png\"); }\n\n.chess-app .page-header {\n  height: 55px; }\n  .chess-app .page-header .header-section {\n    background: #ffffff; }\n    .chess-app .page-header .header-section:not(:last-child) {\n      border-right: 1px solid #d6d6d6; }\n    .chess-app .page-header .header-section .user-profile img {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%; }\n\n.chess-app .page-body {\n  position: relative; }\n  .chess-app .page-body .left-box-content #fill-table {\n    width: 100%;\n    margin-left: 23%;\n    background: white;\n    text-align: center;\n    height: 50%; }\n    .chess-app .page-body .left-box-content #fill-table th, .chess-app .page-body .left-box-content #fill-table tr, .chess-app .page-body .left-box-content #fill-table td {\n      padding: 4%;\n      min-width: 70px; }\n  .chess-app .page-body .center-box #chessVideo {\n    position: relative;\n    z-index: 2; }\n  .chess-app .page-body .right-box .right-box-content {\n    width: 70%;\n    left: -30px;\n    position: relative;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .chess-app .page-body .right-box .right-box-content .right-content-holder {\n      width: 75%;\n      height: 50%;\n      text-align: center; }\n      .chess-app .page-body .right-box .right-box-content .right-content-holder .square-box {\n        height: 10%;\n        width: 20%;\n        -webkit-box-shadow: #333;\n                box-shadow: #333;\n        background-color: #4d7fd1;\n        margin: 2% 10%;\n        border-radius: 10%; }\n        .chess-app .page-body .right-box .right-box-content .right-content-holder .square-box .box-content {\n          color: white;\n          padding: 15% 0 0 0; }\n    .chess-app .page-body .right-box .right-box-content .directions {\n      width: 70%;\n      text-align: center;\n      font-size: 44px;\n      background: #fff;\n      border-radius: 30px;\n      padding: 20px 10px;\n      color: #1f729a;\n      border: 2px solid #666666;\n      line-height: 1.5;\n      -webkit-transition: all 0.9s ease;\n      transition: all 0.9s ease;\n      opacity: 0; }\n      @media (max-width: 3000px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 38.5px; } }\n      @media (max-width: 2560px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 33px; } }\n      @media (max-width: 1920px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 27.5px; } }\n      @media (max-width: 1680px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 22px; } }\n      @media (max-width: 1440px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 17.6px; } }\n      @media (max-width: 1080px) {\n        .chess-app .page-body .right-box .right-box-content .directions {\n          font-size: 14.3px; } }\n      .chess-app .page-body .right-box .right-box-content .directions.no-animation {\n        -webkit-transition: 0ms;\n        transition: 0ms; }\n    .chess-app .page-body .right-box .right-box-content .repeat-btn-qa {\n      margin: 10%;\n      padding: 3%;\n      border-radius: 10%;\n      font-weight: bold;\n      cursor: not-allowed; }\n    .chess-app .page-body .right-box .right-box-content .options {\n      width: 100%;\n      opacity: 0; }\n      .chess-app .page-body .right-box .right-box-content .options #repeat-btn {\n        width: 80%;\n        margin-left: 25px;\n        border-radius: 7px;\n        padding: 15px;\n        font-weight: bold;\n        font-size: 16px;\n        margin-top: 20px;\n        cursor: pointer; }\n      .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center; }\n        .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container {\n          width: 80%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          -ms-flex-item-align: center;\n              align-self: center; }\n          .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n            font-size: 30px;\n            color: #fff;\n            font-weight: bold;\n            background: #6997FF;\n            border-radius: 10px;\n            padding: 2vh;\n            margin: 2% 0;\n            text-align: center; }\n            @media (max-width: 3000px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 26px; } }\n            @media (max-width: 2560px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 22px; } }\n            @media (max-width: 1920px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 20px; } }\n            @media (max-width: 1680px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 18px; } }\n            @media (max-width: 1440px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 18px; } }\n            @media (max-width: 1080px) {\n              .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer {\n                font-size: 16px; } }\n            .chess-app .page-body .right-box .right-box-content .options .options-section .options-section-wrapper .body .answer-container .answer.selected {\n              background-color: #3863c1;\n              -webkit-box-shadow: 0px 1px 50.3px 8.2px rgba(34, 34, 85, 0.4);\n                      box-shadow: 0px 1px 50.3px 8.2px rgba(34, 34, 85, 0.4); }\n  .chess-app .page-body .right-box .volume-control {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    top: 20px;\n    right: 0;\n    border-radius: 50%;\n    cursor: pointer; }\n    .chess-app .page-body .right-box .volume-control .volume-icon {\n      width: 40px;\n      height: 40px; }\n      .chess-app .page-body .right-box .volume-control .volume-icon.volume {\n        background-image: url(/img/volume.svg); }\n      .chess-app .page-body .right-box .volume-control .volume-icon.mute {\n        background-image: url(/img/mute.svg); }\n  .chess-app .page-body .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 0; }\n\n.back-btn-container, .next-btn-container {\n  width: 4%;\n  top: 0;\n  position: absolute;\n  z-index: 10;\n  min-width: 50px;\n  min-height: 100px; }\n  .back-btn-container button, .next-btn-container button {\n    border-radius: 50%;\n    width: 100%;\n    height: auto;\n    padding: 0;\n    min-width: 54px;\n    min-height: 54px; }\n    .back-btn-container button img, .next-btn-container button img {\n      vertical-align: middle;\n      width: 100%;\n      height: 100%; }\n\n.next-btn-container {\n  right: 15px; }\n\n.back-btn-container {\n  left: 15px; }\n\n.star-icon {\n  height: 25px;\n  width: 25px;\n  position: absolute;\n  left: 14px;\n  top: 15px; }\n\n.speech-bubble {\n  height: 95%;\n  width: 95%; }\n  .speech-bubble.center {\n    width: 65%; }\n  .speech-bubble .speech {\n    -webkit-box-flex: 1.3;\n        -ms-flex: 1.3;\n            flex: 1.3;\n    position: relative; }\n    .speech-bubble .speech .bubble {\n      background-image: url(/img/thinking_bubble.svg);\n      background-position: center;\n      font-family: PatrickHand-Regular;\n      color: #1f729a;\n      line-height: 1.2;\n      -webkit-transition: all 0.5s ease;\n      transition: all 0.5s ease;\n      opacity: 0; }\n      .speech-bubble .speech .bubble.xs {\n        width: 45%;\n        height: 45%; }\n      .speech-bubble .speech .bubble.sm {\n        width: 50%;\n        height: 50%; }\n      .speech-bubble .speech .bubble.md {\n        width: 55%;\n        height: 55%; }\n      .speech-bubble .speech .bubble.lg {\n        width: 60%;\n        height: 60%; }\n      .speech-bubble .speech .bubble.xl {\n        width: 68%;\n        height: 68%; }\n      .speech-bubble .speech .bubble.xxl {\n        width: 72%;\n        height: 72%; }\n      .speech-bubble .speech .bubble.xxxl {\n        width: 78%;\n        height: 78%; }\n      .speech-bubble .speech .bubble .bubble-content {\n        font-size: 48px;\n        text-align: center;\n        padding-top: 20%;\n        width: 75%; }\n        @media (max-width: 3000px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 42px; } }\n        @media (max-width: 2560px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 36px; } }\n        @media (max-width: 1920px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 30px; } }\n        @media (max-width: 1680px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 24px; } }\n        @media (max-width: 1440px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 19.2px; } }\n        @media (max-width: 1080px) {\n          .speech-bubble .speech .bubble .bubble-content {\n            font-size: 15.6px; } }\n  .speech-bubble .bubble-down-container {\n    -webkit-box-flex: 0.22;\n        -ms-flex: 0.22;\n            flex: 0.22; }\n    .speech-bubble .bubble-down-container .bubble-down {\n      background: url(/img/bubble_down.svg);\n      background-size: contain;\n      background-repeat: no-repeat;\n      -webkit-transform: scaleX(-1);\n              transform: scaleX(-1);\n      background-position: 40%;\n      opacity: 0;\n      height: 0;\n      -webkit-transition: all 0.5s ease;\n      transition: all 0.5s ease; }\n  .speech-bubble .dragon-container .dragon {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    background: url(/img/dragon.png);\n    background-position: 100%;\n    background-size: contain;\n    background-repeat: no-repeat;\n    opacity: 1;\n    height: 0;\n    width: 0;\n    -webkit-transition: all 0.6s ease;\n    transition: all 0.6s ease; }\n    .speech-bubble .dragon-container .dragon.left, .speech-bubble .dragon-container .dragon.center {\n      background-position: 0;\n      -webkit-transform: scaleX(-1);\n              transform: scaleX(-1); }\n\n.qa-section-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .qa-section-container .qa-section {\n    width: 100%;\n    height: 90%; }\n    .qa-section-container .qa-section .qa-section-wrapper {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      height: 100%;\n      width: 100%;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column; }\n      .qa-section-container .qa-section .qa-section-wrapper .header {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 100%;\n        min-height: 20%;\n        background-color: #DAE6FF; }\n        .qa-section-container .qa-section .qa-section-wrapper .header .question-container {\n          width: 80%; }\n          .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n            font-size: 40px;\n            font-weight: bold; }\n            @media (max-width: 3000px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 30px; } }\n            @media (max-width: 2560px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 26px; } }\n            @media (max-width: 1920px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 22px; } }\n            @media (max-width: 1680px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 20px; } }\n            @media (max-width: 1440px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 18px; } }\n            @media (max-width: 1080px) {\n              .qa-section-container .qa-section .qa-section-wrapper .header .question-container .question {\n                font-size: 16px; } }\n      .qa-section-container .qa-section .qa-section-wrapper .body {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        height: 100%;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        background: #fff; }\n        .qa-section-container .qa-section .qa-section-wrapper .body .answer-container {\n          width: 80%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          -ms-flex-item-align: center;\n              align-self: center; }\n          .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n            font-size: 30px;\n            color: #fff;\n            font-weight: bold;\n            background: #6997FF;\n            border-radius: 20px;\n            padding: 2vh;\n            margin: 3% 0;\n            padding-left: 25px; }\n            @media (max-width: 3000px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 26px; } }\n            @media (max-width: 2560px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 22px; } }\n            @media (max-width: 1920px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 20px; } }\n            @media (max-width: 1680px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 18px; } }\n            @media (max-width: 1440px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 18px; } }\n            @media (max-width: 1080px) {\n              .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer {\n                font-size: 16px; } }\n            .qa-section-container .qa-section .qa-section-wrapper .body .answer-container .answer.selected {\n              background-color: #326ef9;\n              -webkit-box-shadow: 0px 1px 50.3px 8.2px rgba(34, 34, 85, 0.4);\n                      box-shadow: 0px 1px 50.3px 8.2px rgba(34, 34, 85, 0.4); }\n\n.activity-section-container {\n  display: none; }\n  .activity-section-container .activity-section-content {\n    color: #000000; }\n  .activity-section-container.assignment-10-1 {\n    position: absolute; }\n    .activity-section-container.assignment-10-1 .activity-section-content {\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end; }\n      .activity-section-container.assignment-10-1 .activity-section-content .card {\n        width: 86.3%;\n        height: 65%;\n        padding: 0; }\n        .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper {\n          height: 86.5%; }\n          .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table {\n            height: 100%;\n            margin: 0; }\n            .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row {\n              border-bottom: none;\n              padding: 0;\n              margin: 0 1.8%; }\n              .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer-img {\n                height: 100%;\n                background-position: 100% 50%; }\n              .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                font-size: 44px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-flex: .8;\n                    -ms-flex: .8;\n                        flex: .8;\n                padding-left: 2%; }\n                @media (max-width: 3000px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 38.5px; } }\n                @media (max-width: 2560px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 33px; } }\n                @media (max-width: 1920px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 27.5px; } }\n                @media (max-width: 1680px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 22px; } }\n                @media (max-width: 1440px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 17.6px; } }\n                @media (max-width: 1080px) {\n                  .activity-section-container.assignment-10-1 .activity-section-content .card .card-wrapper .options-table .table-row .answer {\n                    font-size: 14.3px; } }\n\n.card {\n  background-color: #ffffff;\n  height: 85%;\n  width: 55%;\n  border-radius: 6px;\n  padding: 10px; }\n  .card .card-wrapper {\n    height: 100%; }\n    .card .card-wrapper .options-table {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      list-style: none;\n      padding: 0;\n      margin: 0px;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      height: 98%;\n      margin-top: 0%; }\n      .card .card-wrapper .options-table .table-row {\n        padding: 0px 10px;\n        margin: 0 10px;\n        height: 100%;\n        cursor: pointer; }\n        .card .card-wrapper .options-table .table-row:not(:last-child) {\n          border-bottom: 1px solid #e5e6e8; }\n        .card .card-wrapper .options-table .table-row .answer-img {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-flex: .1;\n              -ms-flex: .1;\n                  flex: .1;\n          background: url(/img/box.png) no-repeat;\n          background-size: contain;\n          background-repeat: no-repeat;\n          width: 100%;\n          height: 60%; }\n        .card .card-wrapper .options-table .table-row.correct .answer-img {\n          background-image: url(/img/tick.png); }\n        .card .card-wrapper .options-table .table-row.wrong .answer-img {\n          background-image: url(/img/cross.png); }\n        .card .card-wrapper .options-table .table-row .answer {\n          font-size: 44px;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-flex: .8;\n              -ms-flex: .8;\n                  flex: .8;\n          padding-left: 5%; }\n          @media (max-width: 3000px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 38.5px; } }\n          @media (max-width: 2560px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 33px; } }\n          @media (max-width: 1920px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 27.5px; } }\n          @media (max-width: 1680px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 22px; } }\n          @media (max-width: 1440px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 17.6px; } }\n          @media (max-width: 1080px) {\n            .card .card-wrapper .options-table .table-row .answer {\n              font-size: 14.3px; } }\n    .card .card-wrapper .checkboxes {\n      width: 15%;\n      padding-right: 5px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column; }\n    .card .card-wrapper .table-wrap {\n      width: 85%;\n      height: 100%; }\n\n.customCheckbox {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  position: relative;\n  border-radius: 5px;\n  border: 1px solid #2b9bca;\n  font-size: 2.3vh;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.1);\n          box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.1);\n  margin-right: 5px;\n  overflow: hidden;\n  margin-right: 3px;\n  margin-left: 2px;\n  margin-top: 3px;\n  margin-bottom: 3px; }\n\n.customCheckbox.customCheckboxChecked {\n  border: 1px solid #2b9bca; }\n\n.customCheckbox input {\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 5;\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0; }\n\n.customCheckbox span {\n  display: none;\n  line-height: 110%;\n  font-size: 150%; }\n\n.customCheckbox.customCheckboxChecked span {\n  display: block; }\n\n.greenCheck {\n  color: #14fd3b; }\n\n.orangeCheck {\n  color: #fd5e14; }\n\n.board-section {\n  width: 100%; }\n  .board-section .board-section-wrapper .body img {\n    min-width: 200%;\n    min-height: 200%;\n    -webkit-transform: translate(-30%, 0%);\n            transform: translate(-30%, 0%); }\n\n.spare-pieces-7492f {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 0; }\n\n.castling-head {\n  background-color: white;\n  padding: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #6f79ff;\n  border-radius: 3px;\n  margin-bottom: 15px;\n  font-style: bold;\n  font-size: 200%;\n  font-family: GOTHIC-BOLD;\n  color: #6D95DA; }\n\n.spare-pieces-7492f .spare-pieces {\n  padding: 0; }\n\n.sparepieces_container {\n  height: 100%;\n  position: absolute;\n  top: 3%;\n  left: -12%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n  .sparepieces_container.assignment {\n    top: 3%;\n    left: -12%; }\n  .sparepieces_container.qa {\n    top: 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    right: -15%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 100%; }\n  .sparepieces_container .piece-417db {\n    margin-bottom: 5px; }\n  .sparepieces_container img {\n    display: none;\n    visibility: hidden; }\n\n.sparepieces_container_right {\n  right: -12%;\n  left: auto; }\n\n.sparepieces_container_left, .sparepieces_container_right {\n  position: absolute;\n  top: 0;\n  height: 100%; }\n  .sparepieces_container_left .piece-417db, .sparepieces_container_right .piece-417db {\n    margin-bottom: 5px; }\n  .sparepieces_container_left img, .sparepieces_container_right img {\n    visibility: hidden; }\n\n.select-box {\n  list-style: none;\n  z-index: 4;\n  padding: 0;\n  border: none;\n  width: 100%;\n  height: 100%;\n  position: relative; }\n  .select-box :after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 15px;\n    bottom: 0;\n    margin: auto;\n    width: 12px;\n    height: 7px;\n    background-image: url(/img/dropdown.png); }\n  .select-box .scroll-dropdown {\n    width: 100%;\n    padding: 0;\n    overflow: scroll;\n    overflow-x: hidden;\n    min-height: 260px;\n    z-index: 1;\n    display: none; }\n  .select-box li {\n    padding: 18px 15px;\n    z-index: 2;\n    cursor: pointer; }\n    .select-box li:not(.init) {\n      background: #fff;\n      -webkit-box-shadow: #333 10px 10px 20px 0px;\n              box-shadow: #333 10px 10px 20px 0px; }\n    .select-box li:not(:last-child):not(:first-child) {\n      border-bottom: 1px solid #d6d6d6; }\n    .select-box li:nth-child(2) {\n      border-top: 1px solid #d6d6d6; }\n    .select-box li:not(.init):hover, .select-box li.selected:not(.init) {\n      background: #ddd; }\n\n.activity-section-container {\n  display: none; }\n  .activity-section-container.assignment-16-1 {\n    position: absolute; }\n    .activity-section-container.assignment-16-1 .activity-section-content {\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      color: #0000e5;\n      font-size: 25px;\n      font-weight: bold; }\n      .activity-section-container.assignment-16-1 .activity-section-content .card {\n        width: 86.3%;\n        height: 65%;\n        padding: 0;\n        background: transparent; }\n        .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper {\n          height: 86.5%; }\n          .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table {\n            height: 100%;\n            margin: 0;\n            position: relative; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .question-mark {\n              position: absolute;\n              width: 16%;\n              margin-top: -1%;\n              font-size: 25px;\n              color: #ffffff;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -ms-flex-pack: distribute;\n                  justify-content: space-around;\n              margin-left: 40%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table #AnswerOne {\n              width: 27px;\n              border-bottom: 2px solid #0000e5; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table #AnswerTwo {\n              width: 27px;\n              border-bottom: 2px solid #0000e5; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .imgArrows {\n              position: absolute;\n              height: 85%;\n              width: 45%;\n              margin-left: -7%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox1 {\n              position: absolute;\n              margin-left: 20%;\n              margin-top: 53%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .plus1 {\n              position: absolute;\n              margin-left: 26.8%;\n              margin-top: 54%;\n              font-size: 24px; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox2 {\n              position: absolute;\n              margin-top: 53%;\n              margin-left: 30%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .equal-1 {\n              position: absolute;\n              margin-left: 36.7%;\n              margin-top: 54%;\n              font-size: 24px; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox3 {\n              position: absolute;\n              margin-left: 40%;\n              margin-top: 53%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox4 {\n              position: absolute;\n              margin-left: 30%;\n              margin-top: 62%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .plus2 {\n              position: absolute;\n              margin-left: 36.9%;\n              margin-top: 62.5%;\n              font-size: 24px; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox5 {\n              position: absolute;\n              margin-left: 40%;\n              margin-top: 61.6%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .equal-2 {\n              position: absolute;\n              margin-left: 47%;\n              margin-top: 62.5%;\n              font-size: 24px; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table .checkbox6 {\n              position: absolute;\n              margin-left: 50.5%;\n              margin-top: 61.6%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table #imgSix {\n              position: absolute;\n              top: 10%;\n              left: 43%;\n              height: 78%;\n              width: 2.2%; }\n            .activity-section-container.assignment-16-1 .activity-section-content .card .card-wrapper .options-table #imgSeven {\n              position: absolute;\n              top: 10%;\n              left: 51.5%;\n              height: 92%;\n              width: 2.2%; }\n\n.NumberBoxInput {\n  height: 27px;\n  width: 33px;\n  background-color: #ffd27f;\n  font-size: 20px;\n  color: #000000;\n  border: 1px solid grey; }\n\ninput {\n  text-align: center; }\n\n.checkBoxAssignment16 {\n  height: 25px;\n  width: 25px;\n  -webkit-box-shadow: inset 0px 1px 1px #14717e, 0px 1px 3px #14717e;\n          box-shadow: inset 0px 1px 1px #14717e, 0px 1px 3px #14717e;\n  position: relative;\n  display: none; }\n\n.activity {\n  background: #6f9be2;\n  width: 100%; }\n  .activity .table-row {\n    position: relative;\n    border-bottom: none;\n    padding: 8px;\n    margin: 0 1.8%; }\n  .activity .one-number {\n    position: absolute; }\n  .activity #OneNumber {\n    margin-left: 126px;\n    top: 50px; }\n\n.left-section-lesson16 {\n  height: 54%;\n  background: none;\n  margin-left: 35%;\n  margin-right: -96%; }\n\n.container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n/* Hide the browser's default checkbox */\n.container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer; }\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: #eee;\n  font: white; }\n\n/* When the checkbox is checked, add a blue background */\n.container input:checked ~ .checkmark {\n  background-color: #eee; }\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none; }\n\n/* Show the checkmark when checked */\n.container input:checked ~ .checkmark:after {\n  display: block; }\n\n/* Style the checkmark/indicator */\n.container .checkmark:after {\n  left: 9px;\n  top: 5px;\n  width: 7px;\n  height: 12px;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg); }\n\n.numbersCheckbox {\n  font-weight: bold;\n  font-size: 15px;\n  margin-top: 3px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.directions-lesson16-activity1 {\n  margin-left: 5%;\n  width: 35% !important; }\n\n.background-red {\n  background: #BC371C !important; }\n\n.none-pointer-event {\n  pointer-events: none; }\n\n.auto-pointer-event {\n  pointer-events: auto; }\n\n.margin-lesson16 {\n  margin-left: -86%; }\n\n.margin-left-lesson16 {\n  margin-left: -850%; }\n\n@media only screen and (min-width: 1600px) and (max-width: 3500px) {\n  .margin-left-lesson16 {\n    margin-left: -828%; } }\n\n.margin-right-lesson16 {\n  margin-right: -200px; }\n\n.hideLabel {\n  opacity: 0;\n  margin: 0; }\n\n.star-img {\n  height: 15px;\n  width: 15px;\n  position: absolute;\n  top: 7px;\n  left: 6px; }\n\n.activity-1-lesson-18 {\n  background-color: white;\n  height: 42%;\n  min-height: 266px;\n  width: 50%;\n  font-size: 24px; }\n  .activity-1-lesson-18 .first-column {\n    height: 20%; }\n    .activity-1-lesson-18 .first-column .input-rows {\n      float: left; }\n      .activity-1-lesson-18 .first-column .input-rows .custom-input {\n        width: 35%;\n        margin-left: 10px;\n        background-color: #ffcd05;\n        border: 1px solid black;\n        font-size: 24px;\n        border-radius: 1px;\n        text-align: center; }\n      .activity-1-lesson-18 .first-column .input-rows #yellow-arrow {\n        top: 30%;\n        width: 32%;\n        height: 6.5%;\n        position: absolute;\n        z-index: 1; }\n  .activity-1-lesson-18 .first-column h4 {\n    margin: 6% 0 6% 10px; }\n\n.header-4 {\n  margin: 0;\n  padding: 16% 0;\n  color: yellow;\n  font-size: 24px;\n  text-align: center; }\n\n.width-lesson16Activity4 {\n  width: 20%; }\n\n.right-box-lesson16-activity1 {\n  left: 19% !important; }\n\n.activity-16-alignment {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 70%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-left: -4%; }\n\n@media only screen and (min-width: 1600px) and (max-width: 3500px) {\n  .activity-16-alignment {\n    margin-left: -1%; } }\n", ""]);

// exports


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(71);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 71 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.8bbe54f5.js